import { defineComponent as ee, reactive as se, withDirectives as V, openBlock as x, createElementBlock as E, Fragment as H, renderList as q, toDisplayString as F, createCommentVNode as D, unref as N, onMounted as we, normalizeClass as ge, createElementVNode as p, vModelCheckbox as qs, createBlock as De, onUnmounted as Ye, createStaticVNode as Ws, createTextVNode as ls, ref as Ie, watch as Xs, onBeforeUnmount as Ys, nextTick as Js, computed as Ks, createVNode as fe } from "vue";
const Le = /* @__PURE__ */ new WeakMap(), G = {
  mounted: (t) => {
    t.classList.contains("will-appear") || t.classList.add("will-appear"), t.classList.contains("move-up") || t.classList.add("move-up");
    const e = () => {
      const n = t.getBoundingClientRect().top + window.scrollY, r = n + t.offsetHeight, o = window.scrollY + window.innerHeight - 25, a = window.scrollY;
      o > n && a < r && (setTimeout(() => {
        t.classList.remove("will-appear"), t.classList.add("did-appear");
      }, 100), window.removeEventListener("scroll", e), window.removeEventListener("resize", e), Le.delete(t));
    };
    Le.set(t, e), e(), window.addEventListener("scroll", e), window.addEventListener("resize", e);
  },
  unmounted: (t) => {
    const e = Le.get(t);
    e && (window.removeEventListener("scroll", e), window.removeEventListener("resize", e), Le.delete(t));
  }
}, Zs = { class: "Breadcrumb" }, Qs = { class: "Breadcrumb__item" }, ei = ["href"], ti = { key: 1 }, si = /* @__PURE__ */ ee({
  __name: "BreadcrumbComponent",
  props: {
    crumbs: {}
  },
  setup(t) {
    const s = se(t);
    return (i, n) => V((x(), E("div", Zs, [
      (x(!0), E(H, null, q(s.crumbs, (r, o) => (x(), E("div", Qs, [
        o < s.crumbs.length - 1 ? (x(), E("a", {
          key: 0,
          href: r.url,
          title: ""
        }, F(r.text), 9, ei)) : D("", !0),
        o === s.crumbs.length - 1 ? (x(), E("span", ti, F(r.text), 1)) : D("", !0)
      ]))), 256))
    ])), [
      [N(G)]
    ]);
  }
}), ii = {
  key: 0,
  class: "far fa-times"
}, Pt = /* @__PURE__ */ ee({
  __name: "TagComponent",
  props: {
    text: {},
    deletable: { type: Boolean }
  },
  setup(t) {
    const s = t.deletable ?? !1;
    return we(() => {
    }), (i, n) => (x(), E("div", {
      class: ge(["Tag", { removable: N(s) }])
    }, [
      N(s) ? (x(), E("i", ii)) : D("", !0),
      p("span", null, F(i.text), 1)
    ], 2));
  }
}), ni = { class: "Form" }, ri = { class: "etx-flex Flex gv-150" }, oi = { class: "FormField select" }, ai = { class: "FormField__input" }, li = ["onClick"], di = { class: "CustomSelect__trigger" }, ci = { class: "CustomSelect__trigger__label etx-text-crop line-1" }, ui = ["onMouseleave"], fi = { class: "CustomSelect__header" }, pi = { class: "CustomSelect__header__text" }, hi = { class: "etx-text-crop line-1" }, mi = { class: "CustomSelect__options" }, gi = ["for"], vi = ["id", "onUpdate:modelValue", "onChange"], wi = { class: "TagList" }, Cd = /* @__PURE__ */ ee({
  __name: "FilterComponent",
  props: {
    entries: {}
  },
  emits: ["filtersChanged"],
  setup(t, { emit: e }) {
    const s = e, n = se(t.entries), r = (d) => {
      s("filtersChanged", n);
    }, o = (d, c) => {
      c.selected ? d.selected.push(c) : d.selected = d.selected.filter((u) => u.value !== c.value), r();
    }, a = (d) => {
      d.selected = !1, n.forEach((c) => {
        c.selected = c.selected.filter((u) => u.value !== d.value);
      }), s("filtersChanged", n);
    }, l = (d, c) => {
      d.expanded = c ?? !d.expanded;
    };
    return (d, c) => V((x(), E("div", ni, [
      p("div", ri, [
        (x(!0), E(H, null, q(n, (u, v) => (x(), E("div", {
          key: "filter-entry" + v,
          class: "etx-flex__item Flex__item tab-s:c-6"
        }, [
          p("div", oi, [
            p("div", ai, [
              p("div", {
                class: ge(["CustomSelect", { active: u.expanded === !0 }]),
                onClick: (g) => l(u)
              }, [
                c[1] || (c[1] = p("input", {
                  type: "hidden",
                  name: "categories"
                }, null, -1)),
                c[2] || (c[2] = p("div", { class: "CustomSelect__total" }, null, -1)),
                p("div", di, [
                  p("div", ci, F(u.text), 1)
                ]),
                p("div", {
                  class: "CustomSelect__drawer",
                  onMouseleave: (g) => l(u, !1)
                }, [
                  p("div", fi, [
                    p("div", pi, [
                      p("span", hi, F(u.text), 1)
                    ]),
                    c[0] || (c[0] = p("div", { class: "CustomSelect__header__close" }, [
                      p("i", { class: "far fa-arrow-up-long" })
                    ], -1))
                  ]),
                  p("ul", mi, [
                    (x(!0), E(H, null, q(u.items, (g, m) => (x(), E("li", {
                      key: "filter-entry-item" + m,
                      class: ge(["level-" + (g.level ?? 0)])
                    }, [
                      p("label", {
                        for: "CUSTOMSELECT_ELEMENT_" + m
                      }, [
                        V(p("input", {
                          type: "checkbox",
                          id: "CUSTOMSELECT_ELEMENT_" + m,
                          "onUpdate:modelValue": (w) => g.selected = w,
                          onChange: (w) => o(u, g)
                        }, null, 40, vi), [
                          [qs, g.selected]
                        ]),
                        p("span", null, F(g.text), 1)
                      ], 8, gi)
                    ], 2))), 128))
                  ])
                ], 40, ui)
              ], 10, li)
            ])
          ])
        ]))), 128))
      ]),
      n.length > 0 ? (x(), E(H, { key: 0 }, [
        c[3] || (c[3] = p("div", { class: "etx-spacer Spacer h-25" }, null, -1)),
        p("div", wi, [
          (x(!0), E(H, null, q(n, (u) => (x(), E(H, null, [
            (x(!0), E(H, null, q(u.selected, (v, g) => (x(), De(Pt, {
              text: v.text,
              deletable: !0,
              key: "filter-tag-entry" + g,
              onClick: (m) => a(v)
            }, null, 8, ["text", "onClick"]))), 128))
          ], 64))), 256))
        ])
      ], 64)) : D("", !0)
    ])), [
      [N(G)]
    ]);
  }
}), yi = { class: "etx-container pt-50 pb-50" }, bi = { class: "etx-center" }, _i = { class: "etx-flex Flex gv-150 tab-m:gv-0 av-bottom" }, Si = { class: "etx-flex__item Flex__item tab-s:c-10 tab-m:c-8 tab-l:c-7" }, xi = { class: "etx-text Text" }, Ti = {
  key: 0,
  class: "font-h1 alt"
}, Ei = {
  key: 0,
  class: "etx-flex__item Flex__item tab-s:c-10 tab-m:c-3 tab-l:c-4 tab-m:ml-1"
}, Ci = { class: "TagList tab-m:a-right" }, Pi = { class: "etx-container pt-0 pb-0" }, Oi = { class: "etx-center" }, Li = { class: "FixedRatio ratio-3-2 falling-off-left falling-off-right desk-l:falling-off-max-left desk-l:falling-off-max-right" }, Mi = { class: "etx-background-media BackgroundMedia" }, Ai = { class: "etx-media Media" }, ki = { class: "" }, Ii = ["src"], $i = /* @__PURE__ */ ee({
  __name: "HeroComponent",
  props: {
    data: {}
  },
  setup(t) {
    const s = se(t);
    return (i, n) => (x(), E(H, null, [
      p("div", yi, [
        p("div", bi, [
          p("div", _i, [
            p("div", Si, [
              s.data.breadcrumbs ? (x(), De(si, {
                key: 0,
                crumbs: s.data.breadcrumbs
              }, null, 8, ["crumbs"])) : D("", !0),
              V((x(), E("div", xi, [
                p("h1", null, F(s.data.title.main), 1),
                s.data.title.sub ? (x(), E("p", Ti, F(s.data.title.sub), 1)) : D("", !0)
              ])), [
                [N(G)]
              ])
            ]),
            s.data.tags?.length > 0 ? (x(), E("div", Ei, [
              V((x(), E("div", Ci, [
                (x(!0), E(H, null, q(s.data.tags, (r) => (x(), De(Pt, {
                  text: r.text
                }, null, 8, ["text"]))), 256))
              ])), [
                [N(G)]
              ])
            ])) : D("", !0)
          ])
        ])
      ]),
      p("div", Pi, [
        p("div", Oi, [
          V((x(), E("div", Li, [
            n[0] || (n[0] = p("div", {
              class: "Brandshape",
              "data-color-main": "primary",
              "data-color-accent": "azure"
            }, [
              p("svg", {
                width: "208",
                height: "208"
              }, [
                p("use", { "xlink:href": "#brandshape-diagonal" })
              ])
            ], -1)),
            p("div", Mi, [
              p("div", Ai, [
                p("picture", ki, [
                  p("img", {
                    src: s.data.image.url,
                    title: "",
                    alt: ""
                  }, null, 8, Ii)
                ])
              ])
            ])
          ])), [
            [N(G)]
          ])
        ])
      ])
    ], 64));
  }
});
function $t(t) {
  return t !== null && typeof t == "object" && "constructor" in t && t.constructor === Object;
}
function Ot(t, e) {
  t === void 0 && (t = {}), e === void 0 && (e = {});
  const s = ["__proto__", "constructor", "prototype"];
  Object.keys(e).filter((i) => s.indexOf(i) < 0).forEach((i) => {
    typeof t[i] > "u" ? t[i] = e[i] : $t(e[i]) && $t(t[i]) && Object.keys(e[i]).length > 0 && Ot(t[i], e[i]);
  });
}
const ds = {
  body: {},
  addEventListener() {
  },
  removeEventListener() {
  },
  activeElement: {
    blur() {
    },
    nodeName: ""
  },
  querySelector() {
    return null;
  },
  querySelectorAll() {
    return [];
  },
  getElementById() {
    return null;
  },
  createEvent() {
    return {
      initEvent() {
      }
    };
  },
  createElement() {
    return {
      children: [],
      childNodes: [],
      style: {},
      setAttribute() {
      },
      getElementsByTagName() {
        return [];
      }
    };
  },
  createElementNS() {
    return {};
  },
  importNode() {
    return null;
  },
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: ""
  }
};
function oe() {
  const t = typeof document < "u" ? document : {};
  return Ot(t, ds), t;
}
const Ri = {
  document: ds,
  navigator: {
    userAgent: ""
  },
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: ""
  },
  history: {
    replaceState() {
    },
    pushState() {
    },
    go() {
    },
    back() {
    }
  },
  CustomEvent: function() {
    return this;
  },
  addEventListener() {
  },
  removeEventListener() {
  },
  getComputedStyle() {
    return {
      getPropertyValue() {
        return "";
      }
    };
  },
  Image() {
  },
  Date() {
  },
  screen: {},
  setTimeout() {
  },
  clearTimeout() {
  },
  matchMedia() {
    return {};
  },
  requestAnimationFrame(t) {
    return typeof setTimeout > "u" ? (t(), null) : setTimeout(t, 0);
  },
  cancelAnimationFrame(t) {
    typeof setTimeout > "u" || clearTimeout(t);
  }
};
function J() {
  const t = typeof window < "u" ? window : {};
  return Ot(t, Ri), t;
}
function Fi(t) {
  return t === void 0 && (t = ""), t.trim().split(" ").filter((e) => !!e.trim());
}
function Bi(t) {
  const e = t;
  Object.keys(e).forEach((s) => {
    try {
      e[s] = null;
    } catch {
    }
    try {
      delete e[s];
    } catch {
    }
  });
}
function mt(t, e) {
  return e === void 0 && (e = 0), setTimeout(t, e);
}
function Ne() {
  return Date.now();
}
function zi(t) {
  const e = J();
  let s;
  return e.getComputedStyle && (s = e.getComputedStyle(t, null)), !s && t.currentStyle && (s = t.currentStyle), s || (s = t.style), s;
}
function Di(t, e) {
  e === void 0 && (e = "x");
  const s = J();
  let i, n, r;
  const o = zi(t);
  return s.WebKitCSSMatrix ? (n = o.transform || o.webkitTransform, n.split(",").length > 6 && (n = n.split(", ").map((a) => a.replace(",", ".")).join(", ")), r = new s.WebKitCSSMatrix(n === "none" ? "" : n)) : (r = o.MozTransform || o.OTransform || o.MsTransform || o.msTransform || o.transform || o.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,"), i = r.toString().split(",")), e === "x" && (s.WebKitCSSMatrix ? n = r.m41 : i.length === 16 ? n = parseFloat(i[12]) : n = parseFloat(i[4])), e === "y" && (s.WebKitCSSMatrix ? n = r.m42 : i.length === 16 ? n = parseFloat(i[13]) : n = parseFloat(i[5])), n || 0;
}
function Me(t) {
  return typeof t == "object" && t !== null && t.constructor && Object.prototype.toString.call(t).slice(8, -1) === "Object";
}
function Ni(t) {
  return typeof window < "u" && typeof window.HTMLElement < "u" ? t instanceof HTMLElement : t && (t.nodeType === 1 || t.nodeType === 11);
}
function Z() {
  const t = Object(arguments.length <= 0 ? void 0 : arguments[0]), e = ["__proto__", "constructor", "prototype"];
  for (let s = 1; s < arguments.length; s += 1) {
    const i = s < 0 || arguments.length <= s ? void 0 : arguments[s];
    if (i != null && !Ni(i)) {
      const n = Object.keys(Object(i)).filter((r) => e.indexOf(r) < 0);
      for (let r = 0, o = n.length; r < o; r += 1) {
        const a = n[r], l = Object.getOwnPropertyDescriptor(i, a);
        l !== void 0 && l.enumerable && (Me(t[a]) && Me(i[a]) ? i[a].__swiper__ ? t[a] = i[a] : Z(t[a], i[a]) : !Me(t[a]) && Me(i[a]) ? (t[a] = {}, i[a].__swiper__ ? t[a] = i[a] : Z(t[a], i[a])) : t[a] = i[a]);
      }
    }
  }
  return t;
}
function Ae(t, e, s) {
  t.style.setProperty(e, s);
}
function cs(t) {
  let {
    swiper: e,
    targetPosition: s,
    side: i
  } = t;
  const n = J(), r = -e.translate;
  let o = null, a;
  const l = e.params.speed;
  e.wrapperEl.style.scrollSnapType = "none", n.cancelAnimationFrame(e.cssModeFrameID);
  const d = s > r ? "next" : "prev", c = (v, g) => d === "next" && v >= g || d === "prev" && v <= g, u = () => {
    a = (/* @__PURE__ */ new Date()).getTime(), o === null && (o = a);
    const v = Math.max(Math.min((a - o) / l, 1), 0), g = 0.5 - Math.cos(v * Math.PI) / 2;
    let m = r + g * (s - r);
    if (c(m, s) && (m = s), e.wrapperEl.scrollTo({
      [i]: m
    }), c(m, s)) {
      e.wrapperEl.style.overflow = "hidden", e.wrapperEl.style.scrollSnapType = "", setTimeout(() => {
        e.wrapperEl.style.overflow = "", e.wrapperEl.scrollTo({
          [i]: m
        });
      }), n.cancelAnimationFrame(e.cssModeFrameID);
      return;
    }
    e.cssModeFrameID = n.requestAnimationFrame(u);
  };
  u();
}
function re(t, e) {
  e === void 0 && (e = "");
  const s = J(), i = [...t.children];
  return s.HTMLSlotElement && t instanceof HTMLSlotElement && i.push(...t.assignedElements()), e ? i.filter((n) => n.matches(e)) : i;
}
function Hi(t, e) {
  const s = [e];
  for (; s.length > 0; ) {
    const i = s.shift();
    if (t === i)
      return !0;
    s.push(...i.children, ...i.shadowRoot ? i.shadowRoot.children : [], ...i.assignedElements ? i.assignedElements() : []);
  }
}
function Vi(t, e) {
  const s = J();
  let i = e.contains(t);
  return !i && s.HTMLSlotElement && e instanceof HTMLSlotElement && (i = [...e.assignedElements()].includes(t), i || (i = Hi(t, e))), i;
}
function He(t) {
  try {
    console.warn(t);
    return;
  } catch {
  }
}
function Ve(t, e) {
  e === void 0 && (e = []);
  const s = document.createElement(t);
  return s.classList.add(...Array.isArray(e) ? e : Fi(e)), s;
}
function Gi(t, e) {
  const s = [];
  for (; t.previousElementSibling; ) {
    const i = t.previousElementSibling;
    e ? i.matches(e) && s.push(i) : s.push(i), t = i;
  }
  return s;
}
function ji(t, e) {
  const s = [];
  for (; t.nextElementSibling; ) {
    const i = t.nextElementSibling;
    e ? i.matches(e) && s.push(i) : s.push(i), t = i;
  }
  return s;
}
function de(t, e) {
  return J().getComputedStyle(t, null).getPropertyValue(e);
}
function Ge(t) {
  let e = t, s;
  if (e) {
    for (s = 0; (e = e.previousSibling) !== null; )
      e.nodeType === 1 && (s += 1);
    return s;
  }
}
function us(t, e) {
  const s = [];
  let i = t.parentElement;
  for (; i; )
    e ? i.matches(e) && s.push(i) : s.push(i), i = i.parentElement;
  return s;
}
function gt(t, e, s) {
  const i = J();
  return t[e === "width" ? "offsetWidth" : "offsetHeight"] + parseFloat(i.getComputedStyle(t, null).getPropertyValue(e === "width" ? "margin-right" : "margin-top")) + parseFloat(i.getComputedStyle(t, null).getPropertyValue(e === "width" ? "margin-left" : "margin-bottom"));
}
function le(t) {
  return (Array.isArray(t) ? t : [t]).filter((e) => !!e);
}
let it;
function Ui() {
  const t = J(), e = oe();
  return {
    smoothScroll: e.documentElement && e.documentElement.style && "scrollBehavior" in e.documentElement.style,
    touch: !!("ontouchstart" in t || t.DocumentTouch && e instanceof t.DocumentTouch)
  };
}
function fs() {
  return it || (it = Ui()), it;
}
let nt;
function qi(t) {
  let {
    userAgent: e
  } = t === void 0 ? {} : t;
  const s = fs(), i = J(), n = i.navigator.platform, r = e || i.navigator.userAgent, o = {
    ios: !1,
    android: !1
  }, a = i.screen.width, l = i.screen.height, d = r.match(/(Android);?[\s\/]+([\d.]+)?/);
  let c = r.match(/(iPad).*OS\s([\d_]+)/);
  const u = r.match(/(iPod)(.*OS\s([\d_]+))?/), v = !c && r.match(/(iPhone\sOS|iOS)\s([\d_]+)/), g = n === "Win32";
  let m = n === "MacIntel";
  const w = ["1024x1366", "1366x1024", "834x1194", "1194x834", "834x1112", "1112x834", "768x1024", "1024x768", "820x1180", "1180x820", "810x1080", "1080x810"];
  return !c && m && s.touch && w.indexOf(`${a}x${l}`) >= 0 && (c = r.match(/(Version)\/([\d.]+)/), c || (c = [0, 1, "13_0_0"]), m = !1), d && !g && (o.os = "android", o.android = !0), (c || v || u) && (o.os = "ios", o.ios = !0), o;
}
function ps(t) {
  return t === void 0 && (t = {}), nt || (nt = qi(t)), nt;
}
let rt;
function Wi() {
  const t = J(), e = ps();
  let s = !1;
  function i() {
    const a = t.navigator.userAgent.toLowerCase();
    return a.indexOf("safari") >= 0 && a.indexOf("chrome") < 0 && a.indexOf("android") < 0;
  }
  if (i()) {
    const a = String(t.navigator.userAgent);
    if (a.includes("Version/")) {
      const [l, d] = a.split("Version/")[1].split(" ")[0].split(".").map((c) => Number(c));
      s = l < 16 || l === 16 && d < 2;
    }
  }
  const n = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(t.navigator.userAgent), r = i(), o = r || n && e.ios;
  return {
    isSafari: s || r,
    needPerspectiveFix: s,
    need3dFix: o,
    isWebView: n
  };
}
function hs() {
  return rt || (rt = Wi()), rt;
}
function Xi(t) {
  let {
    swiper: e,
    on: s,
    emit: i
  } = t;
  const n = J();
  let r = null, o = null;
  const a = () => {
    !e || e.destroyed || !e.initialized || (i("beforeResize"), i("resize"));
  }, l = () => {
    !e || e.destroyed || !e.initialized || (r = new ResizeObserver((u) => {
      o = n.requestAnimationFrame(() => {
        const {
          width: v,
          height: g
        } = e;
        let m = v, w = g;
        u.forEach((b) => {
          let {
            contentBoxSize: S,
            contentRect: f,
            target: h
          } = b;
          h && h !== e.el || (m = f ? f.width : (S[0] || S).inlineSize, w = f ? f.height : (S[0] || S).blockSize);
        }), (m !== v || w !== g) && a();
      });
    }), r.observe(e.el));
  }, d = () => {
    o && n.cancelAnimationFrame(o), r && r.unobserve && e.el && (r.unobserve(e.el), r = null);
  }, c = () => {
    !e || e.destroyed || !e.initialized || i("orientationchange");
  };
  s("init", () => {
    if (e.params.resizeObserver && typeof n.ResizeObserver < "u") {
      l();
      return;
    }
    n.addEventListener("resize", a), n.addEventListener("orientationchange", c);
  }), s("destroy", () => {
    d(), n.removeEventListener("resize", a), n.removeEventListener("orientationchange", c);
  });
}
function Yi(t) {
  let {
    swiper: e,
    extendParams: s,
    on: i,
    emit: n
  } = t;
  const r = [], o = J(), a = function(c, u) {
    u === void 0 && (u = {});
    const v = o.MutationObserver || o.WebkitMutationObserver, g = new v((m) => {
      if (e.__preventObserver__) return;
      if (m.length === 1) {
        n("observerUpdate", m[0]);
        return;
      }
      const w = function() {
        n("observerUpdate", m[0]);
      };
      o.requestAnimationFrame ? o.requestAnimationFrame(w) : o.setTimeout(w, 0);
    });
    g.observe(c, {
      attributes: typeof u.attributes > "u" ? !0 : u.attributes,
      childList: e.isElement || (typeof u.childList > "u" ? !0 : u).childList,
      characterData: typeof u.characterData > "u" ? !0 : u.characterData
    }), r.push(g);
  }, l = () => {
    if (e.params.observer) {
      if (e.params.observeParents) {
        const c = us(e.hostEl);
        for (let u = 0; u < c.length; u += 1)
          a(c[u]);
      }
      a(e.hostEl, {
        childList: e.params.observeSlideChildren
      }), a(e.wrapperEl, {
        attributes: !1
      });
    }
  }, d = () => {
    r.forEach((c) => {
      c.disconnect();
    }), r.splice(0, r.length);
  };
  s({
    observer: !1,
    observeParents: !1,
    observeSlideChildren: !1
  }), i("init", l), i("destroy", d);
}
var Ji = {
  on(t, e, s) {
    const i = this;
    if (!i.eventsListeners || i.destroyed || typeof e != "function") return i;
    const n = s ? "unshift" : "push";
    return t.split(" ").forEach((r) => {
      i.eventsListeners[r] || (i.eventsListeners[r] = []), i.eventsListeners[r][n](e);
    }), i;
  },
  once(t, e, s) {
    const i = this;
    if (!i.eventsListeners || i.destroyed || typeof e != "function") return i;
    function n() {
      i.off(t, n), n.__emitterProxy && delete n.__emitterProxy;
      for (var r = arguments.length, o = new Array(r), a = 0; a < r; a++)
        o[a] = arguments[a];
      e.apply(i, o);
    }
    return n.__emitterProxy = e, i.on(t, n, s);
  },
  onAny(t, e) {
    const s = this;
    if (!s.eventsListeners || s.destroyed || typeof t != "function") return s;
    const i = e ? "unshift" : "push";
    return s.eventsAnyListeners.indexOf(t) < 0 && s.eventsAnyListeners[i](t), s;
  },
  offAny(t) {
    const e = this;
    if (!e.eventsListeners || e.destroyed || !e.eventsAnyListeners) return e;
    const s = e.eventsAnyListeners.indexOf(t);
    return s >= 0 && e.eventsAnyListeners.splice(s, 1), e;
  },
  off(t, e) {
    const s = this;
    return !s.eventsListeners || s.destroyed || !s.eventsListeners || t.split(" ").forEach((i) => {
      typeof e > "u" ? s.eventsListeners[i] = [] : s.eventsListeners[i] && s.eventsListeners[i].forEach((n, r) => {
        (n === e || n.__emitterProxy && n.__emitterProxy === e) && s.eventsListeners[i].splice(r, 1);
      });
    }), s;
  },
  emit() {
    const t = this;
    if (!t.eventsListeners || t.destroyed || !t.eventsListeners) return t;
    let e, s, i;
    for (var n = arguments.length, r = new Array(n), o = 0; o < n; o++)
      r[o] = arguments[o];
    return typeof r[0] == "string" || Array.isArray(r[0]) ? (e = r[0], s = r.slice(1, r.length), i = t) : (e = r[0].events, s = r[0].data, i = r[0].context || t), s.unshift(i), (Array.isArray(e) ? e : e.split(" ")).forEach((l) => {
      t.eventsAnyListeners && t.eventsAnyListeners.length && t.eventsAnyListeners.forEach((d) => {
        d.apply(i, [l, ...s]);
      }), t.eventsListeners && t.eventsListeners[l] && t.eventsListeners[l].forEach((d) => {
        d.apply(i, s);
      });
    }), t;
  }
};
function Ki() {
  const t = this;
  let e, s;
  const i = t.el;
  typeof t.params.width < "u" && t.params.width !== null ? e = t.params.width : e = i.clientWidth, typeof t.params.height < "u" && t.params.height !== null ? s = t.params.height : s = i.clientHeight, !(e === 0 && t.isHorizontal() || s === 0 && t.isVertical()) && (e = e - parseInt(de(i, "padding-left") || 0, 10) - parseInt(de(i, "padding-right") || 0, 10), s = s - parseInt(de(i, "padding-top") || 0, 10) - parseInt(de(i, "padding-bottom") || 0, 10), Number.isNaN(e) && (e = 0), Number.isNaN(s) && (s = 0), Object.assign(t, {
    width: e,
    height: s,
    size: t.isHorizontal() ? e : s
  }));
}
function Zi() {
  const t = this;
  function e(C, O) {
    return parseFloat(C.getPropertyValue(t.getDirectionLabel(O)) || 0);
  }
  const s = t.params, {
    wrapperEl: i,
    slidesEl: n,
    size: r,
    rtlTranslate: o,
    wrongRTL: a
  } = t, l = t.virtual && s.virtual.enabled, d = l ? t.virtual.slides.length : t.slides.length, c = re(n, `.${t.params.slideClass}, swiper-slide`), u = l ? t.virtual.slides.length : c.length;
  let v = [];
  const g = [], m = [];
  let w = s.slidesOffsetBefore;
  typeof w == "function" && (w = s.slidesOffsetBefore.call(t));
  let b = s.slidesOffsetAfter;
  typeof b == "function" && (b = s.slidesOffsetAfter.call(t));
  const S = t.snapGrid.length, f = t.slidesGrid.length;
  let h = s.spaceBetween, _ = -w, T = 0, M = 0;
  if (typeof r > "u")
    return;
  typeof h == "string" && h.indexOf("%") >= 0 ? h = parseFloat(h.replace("%", "")) / 100 * r : typeof h == "string" && (h = parseFloat(h)), t.virtualSize = -h, c.forEach((C) => {
    o ? C.style.marginLeft = "" : C.style.marginRight = "", C.style.marginBottom = "", C.style.marginTop = "";
  }), s.centeredSlides && s.cssMode && (Ae(i, "--swiper-centered-offset-before", ""), Ae(i, "--swiper-centered-offset-after", ""));
  const A = s.grid && s.grid.rows > 1 && t.grid;
  A ? t.grid.initSlides(c) : t.grid && t.grid.unsetSlides();
  let L;
  const I = s.slidesPerView === "auto" && s.breakpoints && Object.keys(s.breakpoints).filter((C) => typeof s.breakpoints[C].slidesPerView < "u").length > 0;
  for (let C = 0; C < u; C += 1) {
    L = 0;
    let O;
    if (c[C] && (O = c[C]), A && t.grid.updateSlide(C, O, c), !(c[C] && de(O, "display") === "none")) {
      if (s.slidesPerView === "auto") {
        I && (c[C].style[t.getDirectionLabel("width")] = "");
        const k = getComputedStyle(O), P = O.style.transform, R = O.style.webkitTransform;
        if (P && (O.style.transform = "none"), R && (O.style.webkitTransform = "none"), s.roundLengths)
          L = t.isHorizontal() ? gt(O, "width") : gt(O, "height");
        else {
          const B = e(k, "width"), U = e(k, "padding-left"), st = e(k, "padding-right"), z = e(k, "margin-left"), te = e(k, "margin-right"), Y = k.getPropertyValue("box-sizing");
          if (Y && Y === "border-box")
            L = B + z + te;
          else {
            const {
              clientWidth: ue,
              offsetWidth: Oe
            } = O;
            L = B + U + st + z + te + (Oe - ue);
          }
        }
        P && (O.style.transform = P), R && (O.style.webkitTransform = R), s.roundLengths && (L = Math.floor(L));
      } else
        L = (r - (s.slidesPerView - 1) * h) / s.slidesPerView, s.roundLengths && (L = Math.floor(L)), c[C] && (c[C].style[t.getDirectionLabel("width")] = `${L}px`);
      c[C] && (c[C].swiperSlideSize = L), m.push(L), s.centeredSlides ? (_ = _ + L / 2 + T / 2 + h, T === 0 && C !== 0 && (_ = _ - r / 2 - h), C === 0 && (_ = _ - r / 2 - h), Math.abs(_) < 1 / 1e3 && (_ = 0), s.roundLengths && (_ = Math.floor(_)), M % s.slidesPerGroup === 0 && v.push(_), g.push(_)) : (s.roundLengths && (_ = Math.floor(_)), (M - Math.min(t.params.slidesPerGroupSkip, M)) % t.params.slidesPerGroup === 0 && v.push(_), g.push(_), _ = _ + L + h), t.virtualSize += L + h, T = L, M += 1;
    }
  }
  if (t.virtualSize = Math.max(t.virtualSize, r) + b, o && a && (s.effect === "slide" || s.effect === "coverflow") && (i.style.width = `${t.virtualSize + h}px`), s.setWrapperSize && (i.style[t.getDirectionLabel("width")] = `${t.virtualSize + h}px`), A && t.grid.updateWrapperSize(L, v), !s.centeredSlides) {
    const C = [];
    for (let O = 0; O < v.length; O += 1) {
      let k = v[O];
      s.roundLengths && (k = Math.floor(k)), v[O] <= t.virtualSize - r && C.push(k);
    }
    v = C, Math.floor(t.virtualSize - r) - Math.floor(v[v.length - 1]) > 1 && v.push(t.virtualSize - r);
  }
  if (l && s.loop) {
    const C = m[0] + h;
    if (s.slidesPerGroup > 1) {
      const O = Math.ceil((t.virtual.slidesBefore + t.virtual.slidesAfter) / s.slidesPerGroup), k = C * s.slidesPerGroup;
      for (let P = 0; P < O; P += 1)
        v.push(v[v.length - 1] + k);
    }
    for (let O = 0; O < t.virtual.slidesBefore + t.virtual.slidesAfter; O += 1)
      s.slidesPerGroup === 1 && v.push(v[v.length - 1] + C), g.push(g[g.length - 1] + C), t.virtualSize += C;
  }
  if (v.length === 0 && (v = [0]), h !== 0) {
    const C = t.isHorizontal() && o ? "marginLeft" : t.getDirectionLabel("marginRight");
    c.filter((O, k) => !s.cssMode || s.loop ? !0 : k !== c.length - 1).forEach((O) => {
      O.style[C] = `${h}px`;
    });
  }
  if (s.centeredSlides && s.centeredSlidesBounds) {
    let C = 0;
    m.forEach((k) => {
      C += k + (h || 0);
    }), C -= h;
    const O = C > r ? C - r : 0;
    v = v.map((k) => k <= 0 ? -w : k > O ? O + b : k);
  }
  if (s.centerInsufficientSlides) {
    let C = 0;
    m.forEach((k) => {
      C += k + (h || 0);
    }), C -= h;
    const O = (s.slidesOffsetBefore || 0) + (s.slidesOffsetAfter || 0);
    if (C + O < r) {
      const k = (r - C - O) / 2;
      v.forEach((P, R) => {
        v[R] = P - k;
      }), g.forEach((P, R) => {
        g[R] = P + k;
      });
    }
  }
  if (Object.assign(t, {
    slides: c,
    snapGrid: v,
    slidesGrid: g,
    slidesSizesGrid: m
  }), s.centeredSlides && s.cssMode && !s.centeredSlidesBounds) {
    Ae(i, "--swiper-centered-offset-before", `${-v[0]}px`), Ae(i, "--swiper-centered-offset-after", `${t.size / 2 - m[m.length - 1] / 2}px`);
    const C = -t.snapGrid[0], O = -t.slidesGrid[0];
    t.snapGrid = t.snapGrid.map((k) => k + C), t.slidesGrid = t.slidesGrid.map((k) => k + O);
  }
  if (u !== d && t.emit("slidesLengthChange"), v.length !== S && (t.params.watchOverflow && t.checkOverflow(), t.emit("snapGridLengthChange")), g.length !== f && t.emit("slidesGridLengthChange"), s.watchSlidesProgress && t.updateSlidesOffset(), t.emit("slidesUpdated"), !l && !s.cssMode && (s.effect === "slide" || s.effect === "fade")) {
    const C = `${s.containerModifierClass}backface-hidden`, O = t.el.classList.contains(C);
    u <= s.maxBackfaceHiddenSlides ? O || t.el.classList.add(C) : O && t.el.classList.remove(C);
  }
}
function Qi(t) {
  const e = this, s = [], i = e.virtual && e.params.virtual.enabled;
  let n = 0, r;
  typeof t == "number" ? e.setTransition(t) : t === !0 && e.setTransition(e.params.speed);
  const o = (a) => i ? e.slides[e.getSlideIndexByData(a)] : e.slides[a];
  if (e.params.slidesPerView !== "auto" && e.params.slidesPerView > 1)
    if (e.params.centeredSlides)
      (e.visibleSlides || []).forEach((a) => {
        s.push(a);
      });
    else
      for (r = 0; r < Math.ceil(e.params.slidesPerView); r += 1) {
        const a = e.activeIndex + r;
        if (a > e.slides.length && !i) break;
        s.push(o(a));
      }
  else
    s.push(o(e.activeIndex));
  for (r = 0; r < s.length; r += 1)
    if (typeof s[r] < "u") {
      const a = s[r].offsetHeight;
      n = a > n ? a : n;
    }
  (n || n === 0) && (e.wrapperEl.style.height = `${n}px`);
}
function en() {
  const t = this, e = t.slides, s = t.isElement ? t.isHorizontal() ? t.wrapperEl.offsetLeft : t.wrapperEl.offsetTop : 0;
  for (let i = 0; i < e.length; i += 1)
    e[i].swiperSlideOffset = (t.isHorizontal() ? e[i].offsetLeft : e[i].offsetTop) - s - t.cssOverflowAdjustment();
}
const Rt = (t, e, s) => {
  e && !t.classList.contains(s) ? t.classList.add(s) : !e && t.classList.contains(s) && t.classList.remove(s);
};
function tn(t) {
  t === void 0 && (t = this && this.translate || 0);
  const e = this, s = e.params, {
    slides: i,
    rtlTranslate: n,
    snapGrid: r
  } = e;
  if (i.length === 0) return;
  typeof i[0].swiperSlideOffset > "u" && e.updateSlidesOffset();
  let o = -t;
  n && (o = t), e.visibleSlidesIndexes = [], e.visibleSlides = [];
  let a = s.spaceBetween;
  typeof a == "string" && a.indexOf("%") >= 0 ? a = parseFloat(a.replace("%", "")) / 100 * e.size : typeof a == "string" && (a = parseFloat(a));
  for (let l = 0; l < i.length; l += 1) {
    const d = i[l];
    let c = d.swiperSlideOffset;
    s.cssMode && s.centeredSlides && (c -= i[0].swiperSlideOffset);
    const u = (o + (s.centeredSlides ? e.minTranslate() : 0) - c) / (d.swiperSlideSize + a), v = (o - r[0] + (s.centeredSlides ? e.minTranslate() : 0) - c) / (d.swiperSlideSize + a), g = -(o - c), m = g + e.slidesSizesGrid[l], w = g >= 0 && g <= e.size - e.slidesSizesGrid[l], b = g >= 0 && g < e.size - 1 || m > 1 && m <= e.size || g <= 0 && m >= e.size;
    b && (e.visibleSlides.push(d), e.visibleSlidesIndexes.push(l)), Rt(d, b, s.slideVisibleClass), Rt(d, w, s.slideFullyVisibleClass), d.progress = n ? -u : u, d.originalProgress = n ? -v : v;
  }
}
function sn(t) {
  const e = this;
  if (typeof t > "u") {
    const c = e.rtlTranslate ? -1 : 1;
    t = e && e.translate && e.translate * c || 0;
  }
  const s = e.params, i = e.maxTranslate() - e.minTranslate();
  let {
    progress: n,
    isBeginning: r,
    isEnd: o,
    progressLoop: a
  } = e;
  const l = r, d = o;
  if (i === 0)
    n = 0, r = !0, o = !0;
  else {
    n = (t - e.minTranslate()) / i;
    const c = Math.abs(t - e.minTranslate()) < 1, u = Math.abs(t - e.maxTranslate()) < 1;
    r = c || n <= 0, o = u || n >= 1, c && (n = 0), u && (n = 1);
  }
  if (s.loop) {
    const c = e.getSlideIndexByData(0), u = e.getSlideIndexByData(e.slides.length - 1), v = e.slidesGrid[c], g = e.slidesGrid[u], m = e.slidesGrid[e.slidesGrid.length - 1], w = Math.abs(t);
    w >= v ? a = (w - v) / m : a = (w + m - g) / m, a > 1 && (a -= 1);
  }
  Object.assign(e, {
    progress: n,
    progressLoop: a,
    isBeginning: r,
    isEnd: o
  }), (s.watchSlidesProgress || s.centeredSlides && s.autoHeight) && e.updateSlidesProgress(t), r && !l && e.emit("reachBeginning toEdge"), o && !d && e.emit("reachEnd toEdge"), (l && !r || d && !o) && e.emit("fromEdge"), e.emit("progress", n);
}
const ot = (t, e, s) => {
  e && !t.classList.contains(s) ? t.classList.add(s) : !e && t.classList.contains(s) && t.classList.remove(s);
};
function nn() {
  const t = this, {
    slides: e,
    params: s,
    slidesEl: i,
    activeIndex: n
  } = t, r = t.virtual && s.virtual.enabled, o = t.grid && s.grid && s.grid.rows > 1, a = (u) => re(i, `.${s.slideClass}${u}, swiper-slide${u}`)[0];
  let l, d, c;
  if (r)
    if (s.loop) {
      let u = n - t.virtual.slidesBefore;
      u < 0 && (u = t.virtual.slides.length + u), u >= t.virtual.slides.length && (u -= t.virtual.slides.length), l = a(`[data-swiper-slide-index="${u}"]`);
    } else
      l = a(`[data-swiper-slide-index="${n}"]`);
  else
    o ? (l = e.find((u) => u.column === n), c = e.find((u) => u.column === n + 1), d = e.find((u) => u.column === n - 1)) : l = e[n];
  l && (o || (c = ji(l, `.${s.slideClass}, swiper-slide`)[0], s.loop && !c && (c = e[0]), d = Gi(l, `.${s.slideClass}, swiper-slide`)[0], s.loop && !d === 0 && (d = e[e.length - 1]))), e.forEach((u) => {
    ot(u, u === l, s.slideActiveClass), ot(u, u === c, s.slideNextClass), ot(u, u === d, s.slidePrevClass);
  }), t.emitSlidesClasses();
}
const $e = (t, e) => {
  if (!t || t.destroyed || !t.params) return;
  const s = () => t.isElement ? "swiper-slide" : `.${t.params.slideClass}`, i = e.closest(s());
  if (i) {
    let n = i.querySelector(`.${t.params.lazyPreloaderClass}`);
    !n && t.isElement && (i.shadowRoot ? n = i.shadowRoot.querySelector(`.${t.params.lazyPreloaderClass}`) : requestAnimationFrame(() => {
      i.shadowRoot && (n = i.shadowRoot.querySelector(`.${t.params.lazyPreloaderClass}`), n && n.remove());
    })), n && n.remove();
  }
}, at = (t, e) => {
  if (!t.slides[e]) return;
  const s = t.slides[e].querySelector('[loading="lazy"]');
  s && s.removeAttribute("loading");
}, vt = (t) => {
  if (!t || t.destroyed || !t.params) return;
  let e = t.params.lazyPreloadPrevNext;
  const s = t.slides.length;
  if (!s || !e || e < 0) return;
  e = Math.min(e, s);
  const i = t.params.slidesPerView === "auto" ? t.slidesPerViewDynamic() : Math.ceil(t.params.slidesPerView), n = t.activeIndex;
  if (t.params.grid && t.params.grid.rows > 1) {
    const o = n, a = [o - e];
    a.push(...Array.from({
      length: e
    }).map((l, d) => o + i + d)), t.slides.forEach((l, d) => {
      a.includes(l.column) && at(t, d);
    });
    return;
  }
  const r = n + i - 1;
  if (t.params.rewind || t.params.loop)
    for (let o = n - e; o <= r + e; o += 1) {
      const a = (o % s + s) % s;
      (a < n || a > r) && at(t, a);
    }
  else
    for (let o = Math.max(n - e, 0); o <= Math.min(r + e, s - 1); o += 1)
      o !== n && (o > r || o < n) && at(t, o);
};
function rn(t) {
  const {
    slidesGrid: e,
    params: s
  } = t, i = t.rtlTranslate ? t.translate : -t.translate;
  let n;
  for (let r = 0; r < e.length; r += 1)
    typeof e[r + 1] < "u" ? i >= e[r] && i < e[r + 1] - (e[r + 1] - e[r]) / 2 ? n = r : i >= e[r] && i < e[r + 1] && (n = r + 1) : i >= e[r] && (n = r);
  return s.normalizeSlideIndex && (n < 0 || typeof n > "u") && (n = 0), n;
}
function on(t) {
  const e = this, s = e.rtlTranslate ? e.translate : -e.translate, {
    snapGrid: i,
    params: n,
    activeIndex: r,
    realIndex: o,
    snapIndex: a
  } = e;
  let l = t, d;
  const c = (g) => {
    let m = g - e.virtual.slidesBefore;
    return m < 0 && (m = e.virtual.slides.length + m), m >= e.virtual.slides.length && (m -= e.virtual.slides.length), m;
  };
  if (typeof l > "u" && (l = rn(e)), i.indexOf(s) >= 0)
    d = i.indexOf(s);
  else {
    const g = Math.min(n.slidesPerGroupSkip, l);
    d = g + Math.floor((l - g) / n.slidesPerGroup);
  }
  if (d >= i.length && (d = i.length - 1), l === r && !e.params.loop) {
    d !== a && (e.snapIndex = d, e.emit("snapIndexChange"));
    return;
  }
  if (l === r && e.params.loop && e.virtual && e.params.virtual.enabled) {
    e.realIndex = c(l);
    return;
  }
  const u = e.grid && n.grid && n.grid.rows > 1;
  let v;
  if (e.virtual && n.virtual.enabled && n.loop)
    v = c(l);
  else if (u) {
    const g = e.slides.find((w) => w.column === l);
    let m = parseInt(g.getAttribute("data-swiper-slide-index"), 10);
    Number.isNaN(m) && (m = Math.max(e.slides.indexOf(g), 0)), v = Math.floor(m / n.grid.rows);
  } else if (e.slides[l]) {
    const g = e.slides[l].getAttribute("data-swiper-slide-index");
    g ? v = parseInt(g, 10) : v = l;
  } else
    v = l;
  Object.assign(e, {
    previousSnapIndex: a,
    snapIndex: d,
    previousRealIndex: o,
    realIndex: v,
    previousIndex: r,
    activeIndex: l
  }), e.initialized && vt(e), e.emit("activeIndexChange"), e.emit("snapIndexChange"), (e.initialized || e.params.runCallbacksOnInit) && (o !== v && e.emit("realIndexChange"), e.emit("slideChange"));
}
function an(t, e) {
  const s = this, i = s.params;
  let n = t.closest(`.${i.slideClass}, swiper-slide`);
  !n && s.isElement && e && e.length > 1 && e.includes(t) && [...e.slice(e.indexOf(t) + 1, e.length)].forEach((a) => {
    !n && a.matches && a.matches(`.${i.slideClass}, swiper-slide`) && (n = a);
  });
  let r = !1, o;
  if (n) {
    for (let a = 0; a < s.slides.length; a += 1)
      if (s.slides[a] === n) {
        r = !0, o = a;
        break;
      }
  }
  if (n && r)
    s.clickedSlide = n, s.virtual && s.params.virtual.enabled ? s.clickedIndex = parseInt(n.getAttribute("data-swiper-slide-index"), 10) : s.clickedIndex = o;
  else {
    s.clickedSlide = void 0, s.clickedIndex = void 0;
    return;
  }
  i.slideToClickedSlide && s.clickedIndex !== void 0 && s.clickedIndex !== s.activeIndex && s.slideToClickedSlide();
}
var ln = {
  updateSize: Ki,
  updateSlides: Zi,
  updateAutoHeight: Qi,
  updateSlidesOffset: en,
  updateSlidesProgress: tn,
  updateProgress: sn,
  updateSlidesClasses: nn,
  updateActiveIndex: on,
  updateClickedSlide: an
};
function dn(t) {
  t === void 0 && (t = this.isHorizontal() ? "x" : "y");
  const e = this, {
    params: s,
    rtlTranslate: i,
    translate: n,
    wrapperEl: r
  } = e;
  if (s.virtualTranslate)
    return i ? -n : n;
  if (s.cssMode)
    return n;
  let o = Di(r, t);
  return o += e.cssOverflowAdjustment(), i && (o = -o), o || 0;
}
function cn(t, e) {
  const s = this, {
    rtlTranslate: i,
    params: n,
    wrapperEl: r,
    progress: o
  } = s;
  let a = 0, l = 0;
  const d = 0;
  s.isHorizontal() ? a = i ? -t : t : l = t, n.roundLengths && (a = Math.floor(a), l = Math.floor(l)), s.previousTranslate = s.translate, s.translate = s.isHorizontal() ? a : l, n.cssMode ? r[s.isHorizontal() ? "scrollLeft" : "scrollTop"] = s.isHorizontal() ? -a : -l : n.virtualTranslate || (s.isHorizontal() ? a -= s.cssOverflowAdjustment() : l -= s.cssOverflowAdjustment(), r.style.transform = `translate3d(${a}px, ${l}px, ${d}px)`);
  let c;
  const u = s.maxTranslate() - s.minTranslate();
  u === 0 ? c = 0 : c = (t - s.minTranslate()) / u, c !== o && s.updateProgress(t), s.emit("setTranslate", s.translate, e);
}
function un() {
  return -this.snapGrid[0];
}
function fn() {
  return -this.snapGrid[this.snapGrid.length - 1];
}
function pn(t, e, s, i, n) {
  t === void 0 && (t = 0), e === void 0 && (e = this.params.speed), s === void 0 && (s = !0), i === void 0 && (i = !0);
  const r = this, {
    params: o,
    wrapperEl: a
  } = r;
  if (r.animating && o.preventInteractionOnTransition)
    return !1;
  const l = r.minTranslate(), d = r.maxTranslate();
  let c;
  if (i && t > l ? c = l : i && t < d ? c = d : c = t, r.updateProgress(c), o.cssMode) {
    const u = r.isHorizontal();
    if (e === 0)
      a[u ? "scrollLeft" : "scrollTop"] = -c;
    else {
      if (!r.support.smoothScroll)
        return cs({
          swiper: r,
          targetPosition: -c,
          side: u ? "left" : "top"
        }), !0;
      a.scrollTo({
        [u ? "left" : "top"]: -c,
        behavior: "smooth"
      });
    }
    return !0;
  }
  return e === 0 ? (r.setTransition(0), r.setTranslate(c), s && (r.emit("beforeTransitionStart", e, n), r.emit("transitionEnd"))) : (r.setTransition(e), r.setTranslate(c), s && (r.emit("beforeTransitionStart", e, n), r.emit("transitionStart")), r.animating || (r.animating = !0, r.onTranslateToWrapperTransitionEnd || (r.onTranslateToWrapperTransitionEnd = function(v) {
    !r || r.destroyed || v.target === this && (r.wrapperEl.removeEventListener("transitionend", r.onTranslateToWrapperTransitionEnd), r.onTranslateToWrapperTransitionEnd = null, delete r.onTranslateToWrapperTransitionEnd, r.animating = !1, s && r.emit("transitionEnd"));
  }), r.wrapperEl.addEventListener("transitionend", r.onTranslateToWrapperTransitionEnd))), !0;
}
var hn = {
  getTranslate: dn,
  setTranslate: cn,
  minTranslate: un,
  maxTranslate: fn,
  translateTo: pn
};
function mn(t, e) {
  const s = this;
  s.params.cssMode || (s.wrapperEl.style.transitionDuration = `${t}ms`, s.wrapperEl.style.transitionDelay = t === 0 ? "0ms" : ""), s.emit("setTransition", t, e);
}
function ms(t) {
  let {
    swiper: e,
    runCallbacks: s,
    direction: i,
    step: n
  } = t;
  const {
    activeIndex: r,
    previousIndex: o
  } = e;
  let a = i;
  if (a || (r > o ? a = "next" : r < o ? a = "prev" : a = "reset"), e.emit(`transition${n}`), s && r !== o) {
    if (a === "reset") {
      e.emit(`slideResetTransition${n}`);
      return;
    }
    e.emit(`slideChangeTransition${n}`), a === "next" ? e.emit(`slideNextTransition${n}`) : e.emit(`slidePrevTransition${n}`);
  }
}
function gn(t, e) {
  t === void 0 && (t = !0);
  const s = this, {
    params: i
  } = s;
  i.cssMode || (i.autoHeight && s.updateAutoHeight(), ms({
    swiper: s,
    runCallbacks: t,
    direction: e,
    step: "Start"
  }));
}
function vn(t, e) {
  t === void 0 && (t = !0);
  const s = this, {
    params: i
  } = s;
  s.animating = !1, !i.cssMode && (s.setTransition(0), ms({
    swiper: s,
    runCallbacks: t,
    direction: e,
    step: "End"
  }));
}
var wn = {
  setTransition: mn,
  transitionStart: gn,
  transitionEnd: vn
};
function yn(t, e, s, i, n) {
  t === void 0 && (t = 0), s === void 0 && (s = !0), typeof t == "string" && (t = parseInt(t, 10));
  const r = this;
  let o = t;
  o < 0 && (o = 0);
  const {
    params: a,
    snapGrid: l,
    slidesGrid: d,
    previousIndex: c,
    activeIndex: u,
    rtlTranslate: v,
    wrapperEl: g,
    enabled: m
  } = r;
  if (!m && !i && !n || r.destroyed || r.animating && a.preventInteractionOnTransition)
    return !1;
  typeof e > "u" && (e = r.params.speed);
  const w = Math.min(r.params.slidesPerGroupSkip, o);
  let b = w + Math.floor((o - w) / r.params.slidesPerGroup);
  b >= l.length && (b = l.length - 1);
  const S = -l[b];
  if (a.normalizeSlideIndex)
    for (let A = 0; A < d.length; A += 1) {
      const L = -Math.floor(S * 100), I = Math.floor(d[A] * 100), C = Math.floor(d[A + 1] * 100);
      typeof d[A + 1] < "u" ? L >= I && L < C - (C - I) / 2 ? o = A : L >= I && L < C && (o = A + 1) : L >= I && (o = A);
    }
  if (r.initialized && o !== u && (!r.allowSlideNext && (v ? S > r.translate && S > r.minTranslate() : S < r.translate && S < r.minTranslate()) || !r.allowSlidePrev && S > r.translate && S > r.maxTranslate() && (u || 0) !== o))
    return !1;
  o !== (c || 0) && s && r.emit("beforeSlideChangeStart"), r.updateProgress(S);
  let f;
  o > u ? f = "next" : o < u ? f = "prev" : f = "reset";
  const h = r.virtual && r.params.virtual.enabled;
  if (!(h && n) && (v && -S === r.translate || !v && S === r.translate))
    return r.updateActiveIndex(o), a.autoHeight && r.updateAutoHeight(), r.updateSlidesClasses(), a.effect !== "slide" && r.setTranslate(S), f !== "reset" && (r.transitionStart(s, f), r.transitionEnd(s, f)), !1;
  if (a.cssMode) {
    const A = r.isHorizontal(), L = v ? S : -S;
    if (e === 0)
      h && (r.wrapperEl.style.scrollSnapType = "none", r._immediateVirtual = !0), h && !r._cssModeVirtualInitialSet && r.params.initialSlide > 0 ? (r._cssModeVirtualInitialSet = !0, requestAnimationFrame(() => {
        g[A ? "scrollLeft" : "scrollTop"] = L;
      })) : g[A ? "scrollLeft" : "scrollTop"] = L, h && requestAnimationFrame(() => {
        r.wrapperEl.style.scrollSnapType = "", r._immediateVirtual = !1;
      });
    else {
      if (!r.support.smoothScroll)
        return cs({
          swiper: r,
          targetPosition: L,
          side: A ? "left" : "top"
        }), !0;
      g.scrollTo({
        [A ? "left" : "top"]: L,
        behavior: "smooth"
      });
    }
    return !0;
  }
  const M = hs().isSafari;
  return h && !n && M && r.isElement && r.virtual.update(!1, !1, o), r.setTransition(e), r.setTranslate(S), r.updateActiveIndex(o), r.updateSlidesClasses(), r.emit("beforeTransitionStart", e, i), r.transitionStart(s, f), e === 0 ? r.transitionEnd(s, f) : r.animating || (r.animating = !0, r.onSlideToWrapperTransitionEnd || (r.onSlideToWrapperTransitionEnd = function(L) {
    !r || r.destroyed || L.target === this && (r.wrapperEl.removeEventListener("transitionend", r.onSlideToWrapperTransitionEnd), r.onSlideToWrapperTransitionEnd = null, delete r.onSlideToWrapperTransitionEnd, r.transitionEnd(s, f));
  }), r.wrapperEl.addEventListener("transitionend", r.onSlideToWrapperTransitionEnd)), !0;
}
function bn(t, e, s, i) {
  t === void 0 && (t = 0), s === void 0 && (s = !0), typeof t == "string" && (t = parseInt(t, 10));
  const n = this;
  if (n.destroyed) return;
  typeof e > "u" && (e = n.params.speed);
  const r = n.grid && n.params.grid && n.params.grid.rows > 1;
  let o = t;
  if (n.params.loop)
    if (n.virtual && n.params.virtual.enabled)
      o = o + n.virtual.slidesBefore;
    else {
      let a;
      if (r) {
        const v = o * n.params.grid.rows;
        a = n.slides.find((g) => g.getAttribute("data-swiper-slide-index") * 1 === v).column;
      } else
        a = n.getSlideIndexByData(o);
      const l = r ? Math.ceil(n.slides.length / n.params.grid.rows) : n.slides.length, {
        centeredSlides: d
      } = n.params;
      let c = n.params.slidesPerView;
      c === "auto" ? c = n.slidesPerViewDynamic() : (c = Math.ceil(parseFloat(n.params.slidesPerView, 10)), d && c % 2 === 0 && (c = c + 1));
      let u = l - a < c;
      if (d && (u = u || a < Math.ceil(c / 2)), i && d && n.params.slidesPerView !== "auto" && !r && (u = !1), u) {
        const v = d ? a < n.activeIndex ? "prev" : "next" : a - n.activeIndex - 1 < n.params.slidesPerView ? "next" : "prev";
        n.loopFix({
          direction: v,
          slideTo: !0,
          activeSlideIndex: v === "next" ? a + 1 : a - l + 1,
          slideRealIndex: v === "next" ? n.realIndex : void 0
        });
      }
      if (r) {
        const v = o * n.params.grid.rows;
        o = n.slides.find((g) => g.getAttribute("data-swiper-slide-index") * 1 === v).column;
      } else
        o = n.getSlideIndexByData(o);
    }
  return requestAnimationFrame(() => {
    n.slideTo(o, e, s, i);
  }), n;
}
function _n(t, e, s) {
  e === void 0 && (e = !0);
  const i = this, {
    enabled: n,
    params: r,
    animating: o
  } = i;
  if (!n || i.destroyed) return i;
  typeof t > "u" && (t = i.params.speed);
  let a = r.slidesPerGroup;
  r.slidesPerView === "auto" && r.slidesPerGroup === 1 && r.slidesPerGroupAuto && (a = Math.max(i.slidesPerViewDynamic("current", !0), 1));
  const l = i.activeIndex < r.slidesPerGroupSkip ? 1 : a, d = i.virtual && r.virtual.enabled;
  if (r.loop) {
    if (o && !d && r.loopPreventsSliding) return !1;
    if (i.loopFix({
      direction: "next"
    }), i._clientLeft = i.wrapperEl.clientLeft, i.activeIndex === i.slides.length - 1 && r.cssMode)
      return requestAnimationFrame(() => {
        i.slideTo(i.activeIndex + l, t, e, s);
      }), !0;
  }
  return r.rewind && i.isEnd ? i.slideTo(0, t, e, s) : i.slideTo(i.activeIndex + l, t, e, s);
}
function Sn(t, e, s) {
  e === void 0 && (e = !0);
  const i = this, {
    params: n,
    snapGrid: r,
    slidesGrid: o,
    rtlTranslate: a,
    enabled: l,
    animating: d
  } = i;
  if (!l || i.destroyed) return i;
  typeof t > "u" && (t = i.params.speed);
  const c = i.virtual && n.virtual.enabled;
  if (n.loop) {
    if (d && !c && n.loopPreventsSliding) return !1;
    i.loopFix({
      direction: "prev"
    }), i._clientLeft = i.wrapperEl.clientLeft;
  }
  const u = a ? i.translate : -i.translate;
  function v(f) {
    return f < 0 ? -Math.floor(Math.abs(f)) : Math.floor(f);
  }
  const g = v(u), m = r.map((f) => v(f)), w = n.freeMode && n.freeMode.enabled;
  let b = r[m.indexOf(g) - 1];
  if (typeof b > "u" && (n.cssMode || w)) {
    let f;
    r.forEach((h, _) => {
      g >= h && (f = _);
    }), typeof f < "u" && (b = w ? r[f] : r[f > 0 ? f - 1 : f]);
  }
  let S = 0;
  if (typeof b < "u" && (S = o.indexOf(b), S < 0 && (S = i.activeIndex - 1), n.slidesPerView === "auto" && n.slidesPerGroup === 1 && n.slidesPerGroupAuto && (S = S - i.slidesPerViewDynamic("previous", !0) + 1, S = Math.max(S, 0))), n.rewind && i.isBeginning) {
    const f = i.params.virtual && i.params.virtual.enabled && i.virtual ? i.virtual.slides.length - 1 : i.slides.length - 1;
    return i.slideTo(f, t, e, s);
  } else if (n.loop && i.activeIndex === 0 && n.cssMode)
    return requestAnimationFrame(() => {
      i.slideTo(S, t, e, s);
    }), !0;
  return i.slideTo(S, t, e, s);
}
function xn(t, e, s) {
  e === void 0 && (e = !0);
  const i = this;
  if (!i.destroyed)
    return typeof t > "u" && (t = i.params.speed), i.slideTo(i.activeIndex, t, e, s);
}
function Tn(t, e, s, i) {
  e === void 0 && (e = !0), i === void 0 && (i = 0.5);
  const n = this;
  if (n.destroyed) return;
  typeof t > "u" && (t = n.params.speed);
  let r = n.activeIndex;
  const o = Math.min(n.params.slidesPerGroupSkip, r), a = o + Math.floor((r - o) / n.params.slidesPerGroup), l = n.rtlTranslate ? n.translate : -n.translate;
  if (l >= n.snapGrid[a]) {
    const d = n.snapGrid[a], c = n.snapGrid[a + 1];
    l - d > (c - d) * i && (r += n.params.slidesPerGroup);
  } else {
    const d = n.snapGrid[a - 1], c = n.snapGrid[a];
    l - d <= (c - d) * i && (r -= n.params.slidesPerGroup);
  }
  return r = Math.max(r, 0), r = Math.min(r, n.slidesGrid.length - 1), n.slideTo(r, t, e, s);
}
function En() {
  const t = this;
  if (t.destroyed) return;
  const {
    params: e,
    slidesEl: s
  } = t, i = e.slidesPerView === "auto" ? t.slidesPerViewDynamic() : e.slidesPerView;
  let n = t.clickedIndex, r;
  const o = t.isElement ? "swiper-slide" : `.${e.slideClass}`;
  if (e.loop) {
    if (t.animating) return;
    r = parseInt(t.clickedSlide.getAttribute("data-swiper-slide-index"), 10), e.centeredSlides ? n < t.loopedSlides - i / 2 || n > t.slides.length - t.loopedSlides + i / 2 ? (t.loopFix(), n = t.getSlideIndex(re(s, `${o}[data-swiper-slide-index="${r}"]`)[0]), mt(() => {
      t.slideTo(n);
    })) : t.slideTo(n) : n > t.slides.length - i ? (t.loopFix(), n = t.getSlideIndex(re(s, `${o}[data-swiper-slide-index="${r}"]`)[0]), mt(() => {
      t.slideTo(n);
    })) : t.slideTo(n);
  } else
    t.slideTo(n);
}
var Cn = {
  slideTo: yn,
  slideToLoop: bn,
  slideNext: _n,
  slidePrev: Sn,
  slideReset: xn,
  slideToClosest: Tn,
  slideToClickedSlide: En
};
function Pn(t) {
  const e = this, {
    params: s,
    slidesEl: i
  } = e;
  if (!s.loop || e.virtual && e.params.virtual.enabled) return;
  const n = () => {
    re(i, `.${s.slideClass}, swiper-slide`).forEach((u, v) => {
      u.setAttribute("data-swiper-slide-index", v);
    });
  }, r = e.grid && s.grid && s.grid.rows > 1, o = s.slidesPerGroup * (r ? s.grid.rows : 1), a = e.slides.length % o !== 0, l = r && e.slides.length % s.grid.rows !== 0, d = (c) => {
    for (let u = 0; u < c; u += 1) {
      const v = e.isElement ? Ve("swiper-slide", [s.slideBlankClass]) : Ve("div", [s.slideClass, s.slideBlankClass]);
      e.slidesEl.append(v);
    }
  };
  if (a) {
    if (s.loopAddBlankSlides) {
      const c = o - e.slides.length % o;
      d(c), e.recalcSlides(), e.updateSlides();
    } else
      He("Swiper Loop Warning: The number of slides is not even to slidesPerGroup, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)");
    n();
  } else if (l) {
    if (s.loopAddBlankSlides) {
      const c = s.grid.rows - e.slides.length % s.grid.rows;
      d(c), e.recalcSlides(), e.updateSlides();
    } else
      He("Swiper Loop Warning: The number of slides is not even to grid.rows, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)");
    n();
  } else
    n();
  e.loopFix({
    slideRealIndex: t,
    direction: s.centeredSlides ? void 0 : "next"
  });
}
function On(t) {
  let {
    slideRealIndex: e,
    slideTo: s = !0,
    direction: i,
    setTranslate: n,
    activeSlideIndex: r,
    byController: o,
    byMousewheel: a
  } = t === void 0 ? {} : t;
  const l = this;
  if (!l.params.loop) return;
  l.emit("beforeLoopFix");
  const {
    slides: d,
    allowSlidePrev: c,
    allowSlideNext: u,
    slidesEl: v,
    params: g
  } = l, {
    centeredSlides: m
  } = g;
  if (l.allowSlidePrev = !0, l.allowSlideNext = !0, l.virtual && g.virtual.enabled) {
    s && (!g.centeredSlides && l.snapIndex === 0 ? l.slideTo(l.virtual.slides.length, 0, !1, !0) : g.centeredSlides && l.snapIndex < g.slidesPerView ? l.slideTo(l.virtual.slides.length + l.snapIndex, 0, !1, !0) : l.snapIndex === l.snapGrid.length - 1 && l.slideTo(l.virtual.slidesBefore, 0, !1, !0)), l.allowSlidePrev = c, l.allowSlideNext = u, l.emit("loopFix");
    return;
  }
  let w = g.slidesPerView;
  w === "auto" ? w = l.slidesPerViewDynamic() : (w = Math.ceil(parseFloat(g.slidesPerView, 10)), m && w % 2 === 0 && (w = w + 1));
  const b = g.slidesPerGroupAuto ? w : g.slidesPerGroup;
  let S = b;
  S % b !== 0 && (S += b - S % b), S += g.loopAdditionalSlides, l.loopedSlides = S;
  const f = l.grid && g.grid && g.grid.rows > 1;
  d.length < w + S ? He("Swiper Loop Warning: The number of slides is not enough for loop mode, it will be disabled and not function properly. You need to add more slides (or make duplicates) or lower the values of slidesPerView and slidesPerGroup parameters") : f && g.grid.fill === "row" && He("Swiper Loop Warning: Loop mode is not compatible with grid.fill = `row`");
  const h = [], _ = [];
  let T = l.activeIndex;
  typeof r > "u" ? r = l.getSlideIndex(d.find((P) => P.classList.contains(g.slideActiveClass))) : T = r;
  const M = i === "next" || !i, A = i === "prev" || !i;
  let L = 0, I = 0;
  const C = f ? Math.ceil(d.length / g.grid.rows) : d.length, k = (f ? d[r].column : r) + (m && typeof n > "u" ? -w / 2 + 0.5 : 0);
  if (k < S) {
    L = Math.max(S - k, b);
    for (let P = 0; P < S - k; P += 1) {
      const R = P - Math.floor(P / C) * C;
      if (f) {
        const B = C - R - 1;
        for (let U = d.length - 1; U >= 0; U -= 1)
          d[U].column === B && h.push(U);
      } else
        h.push(C - R - 1);
    }
  } else if (k + w > C - S) {
    I = Math.max(k - (C - S * 2), b);
    for (let P = 0; P < I; P += 1) {
      const R = P - Math.floor(P / C) * C;
      f ? d.forEach((B, U) => {
        B.column === R && _.push(U);
      }) : _.push(R);
    }
  }
  if (l.__preventObserver__ = !0, requestAnimationFrame(() => {
    l.__preventObserver__ = !1;
  }), A && h.forEach((P) => {
    d[P].swiperLoopMoveDOM = !0, v.prepend(d[P]), d[P].swiperLoopMoveDOM = !1;
  }), M && _.forEach((P) => {
    d[P].swiperLoopMoveDOM = !0, v.append(d[P]), d[P].swiperLoopMoveDOM = !1;
  }), l.recalcSlides(), g.slidesPerView === "auto" ? l.updateSlides() : f && (h.length > 0 && A || _.length > 0 && M) && l.slides.forEach((P, R) => {
    l.grid.updateSlide(R, P, l.slides);
  }), g.watchSlidesProgress && l.updateSlidesOffset(), s) {
    if (h.length > 0 && A) {
      if (typeof e > "u") {
        const P = l.slidesGrid[T], B = l.slidesGrid[T + L] - P;
        a ? l.setTranslate(l.translate - B) : (l.slideTo(T + Math.ceil(L), 0, !1, !0), n && (l.touchEventsData.startTranslate = l.touchEventsData.startTranslate - B, l.touchEventsData.currentTranslate = l.touchEventsData.currentTranslate - B));
      } else if (n) {
        const P = f ? h.length / g.grid.rows : h.length;
        l.slideTo(l.activeIndex + P, 0, !1, !0), l.touchEventsData.currentTranslate = l.translate;
      }
    } else if (_.length > 0 && M)
      if (typeof e > "u") {
        const P = l.slidesGrid[T], B = l.slidesGrid[T - I] - P;
        a ? l.setTranslate(l.translate - B) : (l.slideTo(T - I, 0, !1, !0), n && (l.touchEventsData.startTranslate = l.touchEventsData.startTranslate - B, l.touchEventsData.currentTranslate = l.touchEventsData.currentTranslate - B));
      } else {
        const P = f ? _.length / g.grid.rows : _.length;
        l.slideTo(l.activeIndex - P, 0, !1, !0);
      }
  }
  if (l.allowSlidePrev = c, l.allowSlideNext = u, l.controller && l.controller.control && !o) {
    const P = {
      slideRealIndex: e,
      direction: i,
      setTranslate: n,
      activeSlideIndex: r,
      byController: !0
    };
    Array.isArray(l.controller.control) ? l.controller.control.forEach((R) => {
      !R.destroyed && R.params.loop && R.loopFix({
        ...P,
        slideTo: R.params.slidesPerView === g.slidesPerView ? s : !1
      });
    }) : l.controller.control instanceof l.constructor && l.controller.control.params.loop && l.controller.control.loopFix({
      ...P,
      slideTo: l.controller.control.params.slidesPerView === g.slidesPerView ? s : !1
    });
  }
  l.emit("loopFix");
}
function Ln() {
  const t = this, {
    params: e,
    slidesEl: s
  } = t;
  if (!e.loop || t.virtual && t.params.virtual.enabled) return;
  t.recalcSlides();
  const i = [];
  t.slides.forEach((n) => {
    const r = typeof n.swiperSlideIndex > "u" ? n.getAttribute("data-swiper-slide-index") * 1 : n.swiperSlideIndex;
    i[r] = n;
  }), t.slides.forEach((n) => {
    n.removeAttribute("data-swiper-slide-index");
  }), i.forEach((n) => {
    s.append(n);
  }), t.recalcSlides(), t.slideTo(t.realIndex, 0);
}
var Mn = {
  loopCreate: Pn,
  loopFix: On,
  loopDestroy: Ln
};
function An(t) {
  const e = this;
  if (!e.params.simulateTouch || e.params.watchOverflow && e.isLocked || e.params.cssMode) return;
  const s = e.params.touchEventsTarget === "container" ? e.el : e.wrapperEl;
  e.isElement && (e.__preventObserver__ = !0), s.style.cursor = "move", s.style.cursor = t ? "grabbing" : "grab", e.isElement && requestAnimationFrame(() => {
    e.__preventObserver__ = !1;
  });
}
function kn() {
  const t = this;
  t.params.watchOverflow && t.isLocked || t.params.cssMode || (t.isElement && (t.__preventObserver__ = !0), t[t.params.touchEventsTarget === "container" ? "el" : "wrapperEl"].style.cursor = "", t.isElement && requestAnimationFrame(() => {
    t.__preventObserver__ = !1;
  }));
}
var In = {
  setGrabCursor: An,
  unsetGrabCursor: kn
};
function $n(t, e) {
  e === void 0 && (e = this);
  function s(i) {
    if (!i || i === oe() || i === J()) return null;
    i.assignedSlot && (i = i.assignedSlot);
    const n = i.closest(t);
    return !n && !i.getRootNode ? null : n || s(i.getRootNode().host);
  }
  return s(e);
}
function Ft(t, e, s) {
  const i = J(), {
    params: n
  } = t, r = n.edgeSwipeDetection, o = n.edgeSwipeThreshold;
  return r && (s <= o || s >= i.innerWidth - o) ? r === "prevent" ? (e.preventDefault(), !0) : !1 : !0;
}
function Rn(t) {
  const e = this, s = oe();
  let i = t;
  i.originalEvent && (i = i.originalEvent);
  const n = e.touchEventsData;
  if (i.type === "pointerdown") {
    if (n.pointerId !== null && n.pointerId !== i.pointerId)
      return;
    n.pointerId = i.pointerId;
  } else i.type === "touchstart" && i.targetTouches.length === 1 && (n.touchId = i.targetTouches[0].identifier);
  if (i.type === "touchstart") {
    Ft(e, i, i.targetTouches[0].pageX);
    return;
  }
  const {
    params: r,
    touches: o,
    enabled: a
  } = e;
  if (!a || !r.simulateTouch && i.pointerType === "mouse" || e.animating && r.preventInteractionOnTransition)
    return;
  !e.animating && r.cssMode && r.loop && e.loopFix();
  let l = i.target;
  if (r.touchEventsTarget === "wrapper" && !Vi(l, e.wrapperEl) || "which" in i && i.which === 3 || "button" in i && i.button > 0 || n.isTouched && n.isMoved) return;
  const d = !!r.noSwipingClass && r.noSwipingClass !== "", c = i.composedPath ? i.composedPath() : i.path;
  d && i.target && i.target.shadowRoot && c && (l = c[0]);
  const u = r.noSwipingSelector ? r.noSwipingSelector : `.${r.noSwipingClass}`, v = !!(i.target && i.target.shadowRoot);
  if (r.noSwiping && (v ? $n(u, l) : l.closest(u))) {
    e.allowClick = !0;
    return;
  }
  if (r.swipeHandler && !l.closest(r.swipeHandler))
    return;
  o.currentX = i.pageX, o.currentY = i.pageY;
  const g = o.currentX, m = o.currentY;
  if (!Ft(e, i, g))
    return;
  Object.assign(n, {
    isTouched: !0,
    isMoved: !1,
    allowTouchCallbacks: !0,
    isScrolling: void 0,
    startMoving: void 0
  }), o.startX = g, o.startY = m, n.touchStartTime = Ne(), e.allowClick = !0, e.updateSize(), e.swipeDirection = void 0, r.threshold > 0 && (n.allowThresholdMove = !1);
  let w = !0;
  l.matches(n.focusableElements) && (w = !1, l.nodeName === "SELECT" && (n.isTouched = !1)), s.activeElement && s.activeElement.matches(n.focusableElements) && s.activeElement !== l && (i.pointerType === "mouse" || i.pointerType !== "mouse" && !l.matches(n.focusableElements)) && s.activeElement.blur();
  const b = w && e.allowTouchMove && r.touchStartPreventDefault;
  (r.touchStartForcePreventDefault || b) && !l.isContentEditable && i.preventDefault(), r.freeMode && r.freeMode.enabled && e.freeMode && e.animating && !r.cssMode && e.freeMode.onTouchStart(), e.emit("touchStart", i);
}
function Fn(t) {
  const e = oe(), s = this, i = s.touchEventsData, {
    params: n,
    touches: r,
    rtlTranslate: o,
    enabled: a
  } = s;
  if (!a || !n.simulateTouch && t.pointerType === "mouse") return;
  let l = t;
  if (l.originalEvent && (l = l.originalEvent), l.type === "pointermove" && (i.touchId !== null || l.pointerId !== i.pointerId))
    return;
  let d;
  if (l.type === "touchmove") {
    if (d = [...l.changedTouches].find((T) => T.identifier === i.touchId), !d || d.identifier !== i.touchId) return;
  } else
    d = l;
  if (!i.isTouched) {
    i.startMoving && i.isScrolling && s.emit("touchMoveOpposite", l);
    return;
  }
  const c = d.pageX, u = d.pageY;
  if (l.preventedByNestedSwiper) {
    r.startX = c, r.startY = u;
    return;
  }
  if (!s.allowTouchMove) {
    l.target.matches(i.focusableElements) || (s.allowClick = !1), i.isTouched && (Object.assign(r, {
      startX: c,
      startY: u,
      currentX: c,
      currentY: u
    }), i.touchStartTime = Ne());
    return;
  }
  if (n.touchReleaseOnEdges && !n.loop) {
    if (s.isVertical()) {
      if (u < r.startY && s.translate <= s.maxTranslate() || u > r.startY && s.translate >= s.minTranslate()) {
        i.isTouched = !1, i.isMoved = !1;
        return;
      }
    } else if (c < r.startX && s.translate <= s.maxTranslate() || c > r.startX && s.translate >= s.minTranslate())
      return;
  }
  if (e.activeElement && e.activeElement.matches(i.focusableElements) && e.activeElement !== l.target && l.pointerType !== "mouse" && e.activeElement.blur(), e.activeElement && l.target === e.activeElement && l.target.matches(i.focusableElements)) {
    i.isMoved = !0, s.allowClick = !1;
    return;
  }
  i.allowTouchCallbacks && s.emit("touchMove", l), r.previousX = r.currentX, r.previousY = r.currentY, r.currentX = c, r.currentY = u;
  const v = r.currentX - r.startX, g = r.currentY - r.startY;
  if (s.params.threshold && Math.sqrt(v ** 2 + g ** 2) < s.params.threshold) return;
  if (typeof i.isScrolling > "u") {
    let T;
    s.isHorizontal() && r.currentY === r.startY || s.isVertical() && r.currentX === r.startX ? i.isScrolling = !1 : v * v + g * g >= 25 && (T = Math.atan2(Math.abs(g), Math.abs(v)) * 180 / Math.PI, i.isScrolling = s.isHorizontal() ? T > n.touchAngle : 90 - T > n.touchAngle);
  }
  if (i.isScrolling && s.emit("touchMoveOpposite", l), typeof i.startMoving > "u" && (r.currentX !== r.startX || r.currentY !== r.startY) && (i.startMoving = !0), i.isScrolling || l.type === "touchmove" && i.preventTouchMoveFromPointerMove) {
    i.isTouched = !1;
    return;
  }
  if (!i.startMoving)
    return;
  s.allowClick = !1, !n.cssMode && l.cancelable && l.preventDefault(), n.touchMoveStopPropagation && !n.nested && l.stopPropagation();
  let m = s.isHorizontal() ? v : g, w = s.isHorizontal() ? r.currentX - r.previousX : r.currentY - r.previousY;
  n.oneWayMovement && (m = Math.abs(m) * (o ? 1 : -1), w = Math.abs(w) * (o ? 1 : -1)), r.diff = m, m *= n.touchRatio, o && (m = -m, w = -w);
  const b = s.touchesDirection;
  s.swipeDirection = m > 0 ? "prev" : "next", s.touchesDirection = w > 0 ? "prev" : "next";
  const S = s.params.loop && !n.cssMode, f = s.touchesDirection === "next" && s.allowSlideNext || s.touchesDirection === "prev" && s.allowSlidePrev;
  if (!i.isMoved) {
    if (S && f && s.loopFix({
      direction: s.swipeDirection
    }), i.startTranslate = s.getTranslate(), s.setTransition(0), s.animating) {
      const T = new window.CustomEvent("transitionend", {
        bubbles: !0,
        cancelable: !0,
        detail: {
          bySwiperTouchMove: !0
        }
      });
      s.wrapperEl.dispatchEvent(T);
    }
    i.allowMomentumBounce = !1, n.grabCursor && (s.allowSlideNext === !0 || s.allowSlidePrev === !0) && s.setGrabCursor(!0), s.emit("sliderFirstMove", l);
  }
  if ((/* @__PURE__ */ new Date()).getTime(), n._loopSwapReset !== !1 && i.isMoved && i.allowThresholdMove && b !== s.touchesDirection && S && f && Math.abs(m) >= 1) {
    Object.assign(r, {
      startX: c,
      startY: u,
      currentX: c,
      currentY: u,
      startTranslate: i.currentTranslate
    }), i.loopSwapReset = !0, i.startTranslate = i.currentTranslate;
    return;
  }
  s.emit("sliderMove", l), i.isMoved = !0, i.currentTranslate = m + i.startTranslate;
  let h = !0, _ = n.resistanceRatio;
  if (n.touchReleaseOnEdges && (_ = 0), m > 0 ? (S && f && i.allowThresholdMove && i.currentTranslate > (n.centeredSlides ? s.minTranslate() - s.slidesSizesGrid[s.activeIndex + 1] - (n.slidesPerView !== "auto" && s.slides.length - n.slidesPerView >= 2 ? s.slidesSizesGrid[s.activeIndex + 1] + s.params.spaceBetween : 0) - s.params.spaceBetween : s.minTranslate()) && s.loopFix({
    direction: "prev",
    setTranslate: !0,
    activeSlideIndex: 0
  }), i.currentTranslate > s.minTranslate() && (h = !1, n.resistance && (i.currentTranslate = s.minTranslate() - 1 + (-s.minTranslate() + i.startTranslate + m) ** _))) : m < 0 && (S && f && i.allowThresholdMove && i.currentTranslate < (n.centeredSlides ? s.maxTranslate() + s.slidesSizesGrid[s.slidesSizesGrid.length - 1] + s.params.spaceBetween + (n.slidesPerView !== "auto" && s.slides.length - n.slidesPerView >= 2 ? s.slidesSizesGrid[s.slidesSizesGrid.length - 1] + s.params.spaceBetween : 0) : s.maxTranslate()) && s.loopFix({
    direction: "next",
    setTranslate: !0,
    activeSlideIndex: s.slides.length - (n.slidesPerView === "auto" ? s.slidesPerViewDynamic() : Math.ceil(parseFloat(n.slidesPerView, 10)))
  }), i.currentTranslate < s.maxTranslate() && (h = !1, n.resistance && (i.currentTranslate = s.maxTranslate() + 1 - (s.maxTranslate() - i.startTranslate - m) ** _))), h && (l.preventedByNestedSwiper = !0), !s.allowSlideNext && s.swipeDirection === "next" && i.currentTranslate < i.startTranslate && (i.currentTranslate = i.startTranslate), !s.allowSlidePrev && s.swipeDirection === "prev" && i.currentTranslate > i.startTranslate && (i.currentTranslate = i.startTranslate), !s.allowSlidePrev && !s.allowSlideNext && (i.currentTranslate = i.startTranslate), n.threshold > 0)
    if (Math.abs(m) > n.threshold || i.allowThresholdMove) {
      if (!i.allowThresholdMove) {
        i.allowThresholdMove = !0, r.startX = r.currentX, r.startY = r.currentY, i.currentTranslate = i.startTranslate, r.diff = s.isHorizontal() ? r.currentX - r.startX : r.currentY - r.startY;
        return;
      }
    } else {
      i.currentTranslate = i.startTranslate;
      return;
    }
  !n.followFinger || n.cssMode || ((n.freeMode && n.freeMode.enabled && s.freeMode || n.watchSlidesProgress) && (s.updateActiveIndex(), s.updateSlidesClasses()), n.freeMode && n.freeMode.enabled && s.freeMode && s.freeMode.onTouchMove(), s.updateProgress(i.currentTranslate), s.setTranslate(i.currentTranslate));
}
function Bn(t) {
  const e = this, s = e.touchEventsData;
  let i = t;
  i.originalEvent && (i = i.originalEvent);
  let n;
  if (i.type === "touchend" || i.type === "touchcancel") {
    if (n = [...i.changedTouches].find((T) => T.identifier === s.touchId), !n || n.identifier !== s.touchId) return;
  } else {
    if (s.touchId !== null || i.pointerId !== s.pointerId) return;
    n = i;
  }
  if (["pointercancel", "pointerout", "pointerleave", "contextmenu"].includes(i.type) && !(["pointercancel", "contextmenu"].includes(i.type) && (e.browser.isSafari || e.browser.isWebView)))
    return;
  s.pointerId = null, s.touchId = null;
  const {
    params: o,
    touches: a,
    rtlTranslate: l,
    slidesGrid: d,
    enabled: c
  } = e;
  if (!c || !o.simulateTouch && i.pointerType === "mouse") return;
  if (s.allowTouchCallbacks && e.emit("touchEnd", i), s.allowTouchCallbacks = !1, !s.isTouched) {
    s.isMoved && o.grabCursor && e.setGrabCursor(!1), s.isMoved = !1, s.startMoving = !1;
    return;
  }
  o.grabCursor && s.isMoved && s.isTouched && (e.allowSlideNext === !0 || e.allowSlidePrev === !0) && e.setGrabCursor(!1);
  const u = Ne(), v = u - s.touchStartTime;
  if (e.allowClick) {
    const T = i.path || i.composedPath && i.composedPath();
    e.updateClickedSlide(T && T[0] || i.target, T), e.emit("tap click", i), v < 300 && u - s.lastClickTime < 300 && e.emit("doubleTap doubleClick", i);
  }
  if (s.lastClickTime = Ne(), mt(() => {
    e.destroyed || (e.allowClick = !0);
  }), !s.isTouched || !s.isMoved || !e.swipeDirection || a.diff === 0 && !s.loopSwapReset || s.currentTranslate === s.startTranslate && !s.loopSwapReset) {
    s.isTouched = !1, s.isMoved = !1, s.startMoving = !1;
    return;
  }
  s.isTouched = !1, s.isMoved = !1, s.startMoving = !1;
  let g;
  if (o.followFinger ? g = l ? e.translate : -e.translate : g = -s.currentTranslate, o.cssMode)
    return;
  if (o.freeMode && o.freeMode.enabled) {
    e.freeMode.onTouchEnd({
      currentPos: g
    });
    return;
  }
  const m = g >= -e.maxTranslate() && !e.params.loop;
  let w = 0, b = e.slidesSizesGrid[0];
  for (let T = 0; T < d.length; T += T < o.slidesPerGroupSkip ? 1 : o.slidesPerGroup) {
    const M = T < o.slidesPerGroupSkip - 1 ? 1 : o.slidesPerGroup;
    typeof d[T + M] < "u" ? (m || g >= d[T] && g < d[T + M]) && (w = T, b = d[T + M] - d[T]) : (m || g >= d[T]) && (w = T, b = d[d.length - 1] - d[d.length - 2]);
  }
  let S = null, f = null;
  o.rewind && (e.isBeginning ? f = o.virtual && o.virtual.enabled && e.virtual ? e.virtual.slides.length - 1 : e.slides.length - 1 : e.isEnd && (S = 0));
  const h = (g - d[w]) / b, _ = w < o.slidesPerGroupSkip - 1 ? 1 : o.slidesPerGroup;
  if (v > o.longSwipesMs) {
    if (!o.longSwipes) {
      e.slideTo(e.activeIndex);
      return;
    }
    e.swipeDirection === "next" && (h >= o.longSwipesRatio ? e.slideTo(o.rewind && e.isEnd ? S : w + _) : e.slideTo(w)), e.swipeDirection === "prev" && (h > 1 - o.longSwipesRatio ? e.slideTo(w + _) : f !== null && h < 0 && Math.abs(h) > o.longSwipesRatio ? e.slideTo(f) : e.slideTo(w));
  } else {
    if (!o.shortSwipes) {
      e.slideTo(e.activeIndex);
      return;
    }
    e.navigation && (i.target === e.navigation.nextEl || i.target === e.navigation.prevEl) ? i.target === e.navigation.nextEl ? e.slideTo(w + _) : e.slideTo(w) : (e.swipeDirection === "next" && e.slideTo(S !== null ? S : w + _), e.swipeDirection === "prev" && e.slideTo(f !== null ? f : w));
  }
}
function Bt() {
  const t = this, {
    params: e,
    el: s
  } = t;
  if (s && s.offsetWidth === 0) return;
  e.breakpoints && t.setBreakpoint();
  const {
    allowSlideNext: i,
    allowSlidePrev: n,
    snapGrid: r
  } = t, o = t.virtual && t.params.virtual.enabled;
  t.allowSlideNext = !0, t.allowSlidePrev = !0, t.updateSize(), t.updateSlides(), t.updateSlidesClasses();
  const a = o && e.loop;
  (e.slidesPerView === "auto" || e.slidesPerView > 1) && t.isEnd && !t.isBeginning && !t.params.centeredSlides && !a ? t.slideTo(t.slides.length - 1, 0, !1, !0) : t.params.loop && !o ? t.slideToLoop(t.realIndex, 0, !1, !0) : t.slideTo(t.activeIndex, 0, !1, !0), t.autoplay && t.autoplay.running && t.autoplay.paused && (clearTimeout(t.autoplay.resizeTimeout), t.autoplay.resizeTimeout = setTimeout(() => {
    t.autoplay && t.autoplay.running && t.autoplay.paused && t.autoplay.resume();
  }, 500)), t.allowSlidePrev = n, t.allowSlideNext = i, t.params.watchOverflow && r !== t.snapGrid && t.checkOverflow();
}
function zn(t) {
  const e = this;
  e.enabled && (e.allowClick || (e.params.preventClicks && t.preventDefault(), e.params.preventClicksPropagation && e.animating && (t.stopPropagation(), t.stopImmediatePropagation())));
}
function Dn() {
  const t = this, {
    wrapperEl: e,
    rtlTranslate: s,
    enabled: i
  } = t;
  if (!i) return;
  t.previousTranslate = t.translate, t.isHorizontal() ? t.translate = -e.scrollLeft : t.translate = -e.scrollTop, t.translate === 0 && (t.translate = 0), t.updateActiveIndex(), t.updateSlidesClasses();
  let n;
  const r = t.maxTranslate() - t.minTranslate();
  r === 0 ? n = 0 : n = (t.translate - t.minTranslate()) / r, n !== t.progress && t.updateProgress(s ? -t.translate : t.translate), t.emit("setTranslate", t.translate, !1);
}
function Nn(t) {
  const e = this;
  $e(e, t.target), !(e.params.cssMode || e.params.slidesPerView !== "auto" && !e.params.autoHeight) && e.update();
}
function Hn() {
  const t = this;
  t.documentTouchHandlerProceeded || (t.documentTouchHandlerProceeded = !0, t.params.touchReleaseOnEdges && (t.el.style.touchAction = "auto"));
}
const gs = (t, e) => {
  const s = oe(), {
    params: i,
    el: n,
    wrapperEl: r,
    device: o
  } = t, a = !!i.nested, l = e === "on" ? "addEventListener" : "removeEventListener", d = e;
  !n || typeof n == "string" || (s[l]("touchstart", t.onDocumentTouchStart, {
    passive: !1,
    capture: a
  }), n[l]("touchstart", t.onTouchStart, {
    passive: !1
  }), n[l]("pointerdown", t.onTouchStart, {
    passive: !1
  }), s[l]("touchmove", t.onTouchMove, {
    passive: !1,
    capture: a
  }), s[l]("pointermove", t.onTouchMove, {
    passive: !1,
    capture: a
  }), s[l]("touchend", t.onTouchEnd, {
    passive: !0
  }), s[l]("pointerup", t.onTouchEnd, {
    passive: !0
  }), s[l]("pointercancel", t.onTouchEnd, {
    passive: !0
  }), s[l]("touchcancel", t.onTouchEnd, {
    passive: !0
  }), s[l]("pointerout", t.onTouchEnd, {
    passive: !0
  }), s[l]("pointerleave", t.onTouchEnd, {
    passive: !0
  }), s[l]("contextmenu", t.onTouchEnd, {
    passive: !0
  }), (i.preventClicks || i.preventClicksPropagation) && n[l]("click", t.onClick, !0), i.cssMode && r[l]("scroll", t.onScroll), i.updateOnWindowResize ? t[d](o.ios || o.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", Bt, !0) : t[d]("observerUpdate", Bt, !0), n[l]("load", t.onLoad, {
    capture: !0
  }));
};
function Vn() {
  const t = this, {
    params: e
  } = t;
  t.onTouchStart = Rn.bind(t), t.onTouchMove = Fn.bind(t), t.onTouchEnd = Bn.bind(t), t.onDocumentTouchStart = Hn.bind(t), e.cssMode && (t.onScroll = Dn.bind(t)), t.onClick = zn.bind(t), t.onLoad = Nn.bind(t), gs(t, "on");
}
function Gn() {
  gs(this, "off");
}
var jn = {
  attachEvents: Vn,
  detachEvents: Gn
};
const zt = (t, e) => t.grid && e.grid && e.grid.rows > 1;
function Un() {
  const t = this, {
    realIndex: e,
    initialized: s,
    params: i,
    el: n
  } = t, r = i.breakpoints;
  if (!r || r && Object.keys(r).length === 0) return;
  const o = oe(), a = i.breakpointsBase === "window" || !i.breakpointsBase ? i.breakpointsBase : "container", l = ["window", "container"].includes(i.breakpointsBase) || !i.breakpointsBase ? t.el : o.querySelector(i.breakpointsBase), d = t.getBreakpoint(r, a, l);
  if (!d || t.currentBreakpoint === d) return;
  const u = (d in r ? r[d] : void 0) || t.originalParams, v = zt(t, i), g = zt(t, u), m = t.params.grabCursor, w = u.grabCursor, b = i.enabled;
  v && !g ? (n.classList.remove(`${i.containerModifierClass}grid`, `${i.containerModifierClass}grid-column`), t.emitContainerClasses()) : !v && g && (n.classList.add(`${i.containerModifierClass}grid`), (u.grid.fill && u.grid.fill === "column" || !u.grid.fill && i.grid.fill === "column") && n.classList.add(`${i.containerModifierClass}grid-column`), t.emitContainerClasses()), m && !w ? t.unsetGrabCursor() : !m && w && t.setGrabCursor(), ["navigation", "pagination", "scrollbar"].forEach((M) => {
    if (typeof u[M] > "u") return;
    const A = i[M] && i[M].enabled, L = u[M] && u[M].enabled;
    A && !L && t[M].disable(), !A && L && t[M].enable();
  });
  const S = u.direction && u.direction !== i.direction, f = i.loop && (u.slidesPerView !== i.slidesPerView || S), h = i.loop;
  S && s && t.changeDirection(), Z(t.params, u);
  const _ = t.params.enabled, T = t.params.loop;
  Object.assign(t, {
    allowTouchMove: t.params.allowTouchMove,
    allowSlideNext: t.params.allowSlideNext,
    allowSlidePrev: t.params.allowSlidePrev
  }), b && !_ ? t.disable() : !b && _ && t.enable(), t.currentBreakpoint = d, t.emit("_beforeBreakpoint", u), s && (f ? (t.loopDestroy(), t.loopCreate(e), t.updateSlides()) : !h && T ? (t.loopCreate(e), t.updateSlides()) : h && !T && t.loopDestroy()), t.emit("breakpoint", u);
}
function qn(t, e, s) {
  if (e === void 0 && (e = "window"), !t || e === "container" && !s) return;
  let i = !1;
  const n = J(), r = e === "window" ? n.innerHeight : s.clientHeight, o = Object.keys(t).map((a) => {
    if (typeof a == "string" && a.indexOf("@") === 0) {
      const l = parseFloat(a.substr(1));
      return {
        value: r * l,
        point: a
      };
    }
    return {
      value: a,
      point: a
    };
  });
  o.sort((a, l) => parseInt(a.value, 10) - parseInt(l.value, 10));
  for (let a = 0; a < o.length; a += 1) {
    const {
      point: l,
      value: d
    } = o[a];
    e === "window" ? n.matchMedia(`(min-width: ${d}px)`).matches && (i = l) : d <= s.clientWidth && (i = l);
  }
  return i || "max";
}
var Wn = {
  setBreakpoint: Un,
  getBreakpoint: qn
};
function Xn(t, e) {
  const s = [];
  return t.forEach((i) => {
    typeof i == "object" ? Object.keys(i).forEach((n) => {
      i[n] && s.push(e + n);
    }) : typeof i == "string" && s.push(e + i);
  }), s;
}
function Yn() {
  const t = this, {
    classNames: e,
    params: s,
    rtl: i,
    el: n,
    device: r
  } = t, o = Xn(["initialized", s.direction, {
    "free-mode": t.params.freeMode && s.freeMode.enabled
  }, {
    autoheight: s.autoHeight
  }, {
    rtl: i
  }, {
    grid: s.grid && s.grid.rows > 1
  }, {
    "grid-column": s.grid && s.grid.rows > 1 && s.grid.fill === "column"
  }, {
    android: r.android
  }, {
    ios: r.ios
  }, {
    "css-mode": s.cssMode
  }, {
    centered: s.cssMode && s.centeredSlides
  }, {
    "watch-progress": s.watchSlidesProgress
  }], s.containerModifierClass);
  e.push(...o), n.classList.add(...e), t.emitContainerClasses();
}
function Jn() {
  const t = this, {
    el: e,
    classNames: s
  } = t;
  !e || typeof e == "string" || (e.classList.remove(...s), t.emitContainerClasses());
}
var Kn = {
  addClasses: Yn,
  removeClasses: Jn
};
function Zn() {
  const t = this, {
    isLocked: e,
    params: s
  } = t, {
    slidesOffsetBefore: i
  } = s;
  if (i) {
    const n = t.slides.length - 1, r = t.slidesGrid[n] + t.slidesSizesGrid[n] + i * 2;
    t.isLocked = t.size > r;
  } else
    t.isLocked = t.snapGrid.length === 1;
  s.allowSlideNext === !0 && (t.allowSlideNext = !t.isLocked), s.allowSlidePrev === !0 && (t.allowSlidePrev = !t.isLocked), e && e !== t.isLocked && (t.isEnd = !1), e !== t.isLocked && t.emit(t.isLocked ? "lock" : "unlock");
}
var Qn = {
  checkOverflow: Zn
}, Dt = {
  init: !0,
  direction: "horizontal",
  oneWayMovement: !1,
  swiperElementNodeName: "SWIPER-CONTAINER",
  touchEventsTarget: "wrapper",
  initialSlide: 0,
  speed: 300,
  cssMode: !1,
  updateOnWindowResize: !0,
  resizeObserver: !0,
  nested: !1,
  createElements: !1,
  eventsPrefix: "swiper",
  enabled: !0,
  focusableElements: "input, select, option, textarea, button, video, label",
  // Overrides
  width: null,
  height: null,
  //
  preventInteractionOnTransition: !1,
  // ssr
  userAgent: null,
  url: null,
  // To support iOS's swipe-to-go-back gesture (when being used in-app).
  edgeSwipeDetection: !1,
  edgeSwipeThreshold: 20,
  // Autoheight
  autoHeight: !1,
  // Set wrapper width
  setWrapperSize: !1,
  // Virtual Translate
  virtualTranslate: !1,
  // Effects
  effect: "slide",
  // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
  // Breakpoints
  breakpoints: void 0,
  breakpointsBase: "window",
  // Slides grid
  spaceBetween: 0,
  slidesPerView: 1,
  slidesPerGroup: 1,
  slidesPerGroupSkip: 0,
  slidesPerGroupAuto: !1,
  centeredSlides: !1,
  centeredSlidesBounds: !1,
  slidesOffsetBefore: 0,
  // in px
  slidesOffsetAfter: 0,
  // in px
  normalizeSlideIndex: !0,
  centerInsufficientSlides: !1,
  // Disable swiper and hide navigation when container not overflow
  watchOverflow: !0,
  // Round length
  roundLengths: !1,
  // Touches
  touchRatio: 1,
  touchAngle: 45,
  simulateTouch: !0,
  shortSwipes: !0,
  longSwipes: !0,
  longSwipesRatio: 0.5,
  longSwipesMs: 300,
  followFinger: !0,
  allowTouchMove: !0,
  threshold: 5,
  touchMoveStopPropagation: !1,
  touchStartPreventDefault: !0,
  touchStartForcePreventDefault: !1,
  touchReleaseOnEdges: !1,
  // Unique Navigation Elements
  uniqueNavElements: !0,
  // Resistance
  resistance: !0,
  resistanceRatio: 0.85,
  // Progress
  watchSlidesProgress: !1,
  // Cursor
  grabCursor: !1,
  // Clicks
  preventClicks: !0,
  preventClicksPropagation: !0,
  slideToClickedSlide: !1,
  // loop
  loop: !1,
  loopAddBlankSlides: !0,
  loopAdditionalSlides: 0,
  loopPreventsSliding: !0,
  // rewind
  rewind: !1,
  // Swiping/no swiping
  allowSlidePrev: !0,
  allowSlideNext: !0,
  swipeHandler: null,
  // '.swipe-handler',
  noSwiping: !0,
  noSwipingClass: "swiper-no-swiping",
  noSwipingSelector: null,
  // Passive Listeners
  passiveListeners: !0,
  maxBackfaceHiddenSlides: 10,
  // NS
  containerModifierClass: "swiper-",
  // NEW
  slideClass: "swiper-slide",
  slideBlankClass: "swiper-slide-blank",
  slideActiveClass: "swiper-slide-active",
  slideVisibleClass: "swiper-slide-visible",
  slideFullyVisibleClass: "swiper-slide-fully-visible",
  slideNextClass: "swiper-slide-next",
  slidePrevClass: "swiper-slide-prev",
  wrapperClass: "swiper-wrapper",
  lazyPreloaderClass: "swiper-lazy-preloader",
  lazyPreloadPrevNext: 0,
  // Callbacks
  runCallbacksOnInit: !0,
  // Internals
  _emitClasses: !1
};
function er(t, e) {
  return function(i) {
    i === void 0 && (i = {});
    const n = Object.keys(i)[0], r = i[n];
    if (typeof r != "object" || r === null) {
      Z(e, i);
      return;
    }
    if (t[n] === !0 && (t[n] = {
      enabled: !0
    }), n === "navigation" && t[n] && t[n].enabled && !t[n].prevEl && !t[n].nextEl && (t[n].auto = !0), ["pagination", "scrollbar"].indexOf(n) >= 0 && t[n] && t[n].enabled && !t[n].el && (t[n].auto = !0), !(n in t && "enabled" in r)) {
      Z(e, i);
      return;
    }
    typeof t[n] == "object" && !("enabled" in t[n]) && (t[n].enabled = !0), t[n] || (t[n] = {
      enabled: !1
    }), Z(e, i);
  };
}
const lt = {
  eventsEmitter: Ji,
  update: ln,
  translate: hn,
  transition: wn,
  slide: Cn,
  loop: Mn,
  grabCursor: In,
  events: jn,
  breakpoints: Wn,
  checkOverflow: Qn,
  classes: Kn
}, dt = {};
class W {
  constructor() {
    let e, s;
    for (var i = arguments.length, n = new Array(i), r = 0; r < i; r++)
      n[r] = arguments[r];
    n.length === 1 && n[0].constructor && Object.prototype.toString.call(n[0]).slice(8, -1) === "Object" ? s = n[0] : [e, s] = n, s || (s = {}), s = Z({}, s), e && !s.el && (s.el = e);
    const o = oe();
    if (s.el && typeof s.el == "string" && o.querySelectorAll(s.el).length > 1) {
      const c = [];
      return o.querySelectorAll(s.el).forEach((u) => {
        const v = Z({}, s, {
          el: u
        });
        c.push(new W(v));
      }), c;
    }
    const a = this;
    a.__swiper__ = !0, a.support = fs(), a.device = ps({
      userAgent: s.userAgent
    }), a.browser = hs(), a.eventsListeners = {}, a.eventsAnyListeners = [], a.modules = [...a.__modules__], s.modules && Array.isArray(s.modules) && a.modules.push(...s.modules);
    const l = {};
    a.modules.forEach((c) => {
      c({
        params: s,
        swiper: a,
        extendParams: er(s, l),
        on: a.on.bind(a),
        once: a.once.bind(a),
        off: a.off.bind(a),
        emit: a.emit.bind(a)
      });
    });
    const d = Z({}, Dt, l);
    return a.params = Z({}, d, dt, s), a.originalParams = Z({}, a.params), a.passedParams = Z({}, s), a.params && a.params.on && Object.keys(a.params.on).forEach((c) => {
      a.on(c, a.params.on[c]);
    }), a.params && a.params.onAny && a.onAny(a.params.onAny), Object.assign(a, {
      enabled: a.params.enabled,
      el: e,
      // Classes
      classNames: [],
      // Slides
      slides: [],
      slidesGrid: [],
      snapGrid: [],
      slidesSizesGrid: [],
      // isDirection
      isHorizontal() {
        return a.params.direction === "horizontal";
      },
      isVertical() {
        return a.params.direction === "vertical";
      },
      // Indexes
      activeIndex: 0,
      realIndex: 0,
      //
      isBeginning: !0,
      isEnd: !1,
      // Props
      translate: 0,
      previousTranslate: 0,
      progress: 0,
      velocity: 0,
      animating: !1,
      cssOverflowAdjustment() {
        return Math.trunc(this.translate / 2 ** 23) * 2 ** 23;
      },
      // Locks
      allowSlideNext: a.params.allowSlideNext,
      allowSlidePrev: a.params.allowSlidePrev,
      // Touch Events
      touchEventsData: {
        isTouched: void 0,
        isMoved: void 0,
        allowTouchCallbacks: void 0,
        touchStartTime: void 0,
        isScrolling: void 0,
        currentTranslate: void 0,
        startTranslate: void 0,
        allowThresholdMove: void 0,
        // Form elements to match
        focusableElements: a.params.focusableElements,
        // Last click time
        lastClickTime: 0,
        clickTimeout: void 0,
        // Velocities
        velocities: [],
        allowMomentumBounce: void 0,
        startMoving: void 0,
        pointerId: null,
        touchId: null
      },
      // Clicks
      allowClick: !0,
      // Touches
      allowTouchMove: a.params.allowTouchMove,
      touches: {
        startX: 0,
        startY: 0,
        currentX: 0,
        currentY: 0,
        diff: 0
      },
      // Images
      imagesToLoad: [],
      imagesLoaded: 0
    }), a.emit("_swiper"), a.params.init && a.init(), a;
  }
  getDirectionLabel(e) {
    return this.isHorizontal() ? e : {
      width: "height",
      "margin-top": "margin-left",
      "margin-bottom ": "margin-right",
      "margin-left": "margin-top",
      "margin-right": "margin-bottom",
      "padding-left": "padding-top",
      "padding-right": "padding-bottom",
      marginRight: "marginBottom"
    }[e];
  }
  getSlideIndex(e) {
    const {
      slidesEl: s,
      params: i
    } = this, n = re(s, `.${i.slideClass}, swiper-slide`), r = Ge(n[0]);
    return Ge(e) - r;
  }
  getSlideIndexByData(e) {
    return this.getSlideIndex(this.slides.find((s) => s.getAttribute("data-swiper-slide-index") * 1 === e));
  }
  recalcSlides() {
    const e = this, {
      slidesEl: s,
      params: i
    } = e;
    e.slides = re(s, `.${i.slideClass}, swiper-slide`);
  }
  enable() {
    const e = this;
    e.enabled || (e.enabled = !0, e.params.grabCursor && e.setGrabCursor(), e.emit("enable"));
  }
  disable() {
    const e = this;
    e.enabled && (e.enabled = !1, e.params.grabCursor && e.unsetGrabCursor(), e.emit("disable"));
  }
  setProgress(e, s) {
    const i = this;
    e = Math.min(Math.max(e, 0), 1);
    const n = i.minTranslate(), o = (i.maxTranslate() - n) * e + n;
    i.translateTo(o, typeof s > "u" ? 0 : s), i.updateActiveIndex(), i.updateSlidesClasses();
  }
  emitContainerClasses() {
    const e = this;
    if (!e.params._emitClasses || !e.el) return;
    const s = e.el.className.split(" ").filter((i) => i.indexOf("swiper") === 0 || i.indexOf(e.params.containerModifierClass) === 0);
    e.emit("_containerClasses", s.join(" "));
  }
  getSlideClasses(e) {
    const s = this;
    return s.destroyed ? "" : e.className.split(" ").filter((i) => i.indexOf("swiper-slide") === 0 || i.indexOf(s.params.slideClass) === 0).join(" ");
  }
  emitSlidesClasses() {
    const e = this;
    if (!e.params._emitClasses || !e.el) return;
    const s = [];
    e.slides.forEach((i) => {
      const n = e.getSlideClasses(i);
      s.push({
        slideEl: i,
        classNames: n
      }), e.emit("_slideClass", i, n);
    }), e.emit("_slideClasses", s);
  }
  slidesPerViewDynamic(e, s) {
    e === void 0 && (e = "current"), s === void 0 && (s = !1);
    const i = this, {
      params: n,
      slides: r,
      slidesGrid: o,
      slidesSizesGrid: a,
      size: l,
      activeIndex: d
    } = i;
    let c = 1;
    if (typeof n.slidesPerView == "number") return n.slidesPerView;
    if (n.centeredSlides) {
      let u = r[d] ? Math.ceil(r[d].swiperSlideSize) : 0, v;
      for (let g = d + 1; g < r.length; g += 1)
        r[g] && !v && (u += Math.ceil(r[g].swiperSlideSize), c += 1, u > l && (v = !0));
      for (let g = d - 1; g >= 0; g -= 1)
        r[g] && !v && (u += r[g].swiperSlideSize, c += 1, u > l && (v = !0));
    } else if (e === "current")
      for (let u = d + 1; u < r.length; u += 1)
        (s ? o[u] + a[u] - o[d] < l : o[u] - o[d] < l) && (c += 1);
    else
      for (let u = d - 1; u >= 0; u -= 1)
        o[d] - o[u] < l && (c += 1);
    return c;
  }
  update() {
    const e = this;
    if (!e || e.destroyed) return;
    const {
      snapGrid: s,
      params: i
    } = e;
    i.breakpoints && e.setBreakpoint(), [...e.el.querySelectorAll('[loading="lazy"]')].forEach((o) => {
      o.complete && $e(e, o);
    }), e.updateSize(), e.updateSlides(), e.updateProgress(), e.updateSlidesClasses();
    function n() {
      const o = e.rtlTranslate ? e.translate * -1 : e.translate, a = Math.min(Math.max(o, e.maxTranslate()), e.minTranslate());
      e.setTranslate(a), e.updateActiveIndex(), e.updateSlidesClasses();
    }
    let r;
    if (i.freeMode && i.freeMode.enabled && !i.cssMode)
      n(), i.autoHeight && e.updateAutoHeight();
    else {
      if ((i.slidesPerView === "auto" || i.slidesPerView > 1) && e.isEnd && !i.centeredSlides) {
        const o = e.virtual && i.virtual.enabled ? e.virtual.slides : e.slides;
        r = e.slideTo(o.length - 1, 0, !1, !0);
      } else
        r = e.slideTo(e.activeIndex, 0, !1, !0);
      r || n();
    }
    i.watchOverflow && s !== e.snapGrid && e.checkOverflow(), e.emit("update");
  }
  changeDirection(e, s) {
    s === void 0 && (s = !0);
    const i = this, n = i.params.direction;
    return e || (e = n === "horizontal" ? "vertical" : "horizontal"), e === n || e !== "horizontal" && e !== "vertical" || (i.el.classList.remove(`${i.params.containerModifierClass}${n}`), i.el.classList.add(`${i.params.containerModifierClass}${e}`), i.emitContainerClasses(), i.params.direction = e, i.slides.forEach((r) => {
      e === "vertical" ? r.style.width = "" : r.style.height = "";
    }), i.emit("changeDirection"), s && i.update()), i;
  }
  changeLanguageDirection(e) {
    const s = this;
    s.rtl && e === "rtl" || !s.rtl && e === "ltr" || (s.rtl = e === "rtl", s.rtlTranslate = s.params.direction === "horizontal" && s.rtl, s.rtl ? (s.el.classList.add(`${s.params.containerModifierClass}rtl`), s.el.dir = "rtl") : (s.el.classList.remove(`${s.params.containerModifierClass}rtl`), s.el.dir = "ltr"), s.update());
  }
  mount(e) {
    const s = this;
    if (s.mounted) return !0;
    let i = e || s.params.el;
    if (typeof i == "string" && (i = document.querySelector(i)), !i)
      return !1;
    i.swiper = s, i.parentNode && i.parentNode.host && i.parentNode.host.nodeName === s.params.swiperElementNodeName.toUpperCase() && (s.isElement = !0);
    const n = () => `.${(s.params.wrapperClass || "").trim().split(" ").join(".")}`;
    let o = i && i.shadowRoot && i.shadowRoot.querySelector ? i.shadowRoot.querySelector(n()) : re(i, n())[0];
    return !o && s.params.createElements && (o = Ve("div", s.params.wrapperClass), i.append(o), re(i, `.${s.params.slideClass}`).forEach((a) => {
      o.append(a);
    })), Object.assign(s, {
      el: i,
      wrapperEl: o,
      slidesEl: s.isElement && !i.parentNode.host.slideSlots ? i.parentNode.host : o,
      hostEl: s.isElement ? i.parentNode.host : i,
      mounted: !0,
      // RTL
      rtl: i.dir.toLowerCase() === "rtl" || de(i, "direction") === "rtl",
      rtlTranslate: s.params.direction === "horizontal" && (i.dir.toLowerCase() === "rtl" || de(i, "direction") === "rtl"),
      wrongRTL: de(o, "display") === "-webkit-box"
    }), !0;
  }
  init(e) {
    const s = this;
    if (s.initialized || s.mount(e) === !1) return s;
    s.emit("beforeInit"), s.params.breakpoints && s.setBreakpoint(), s.addClasses(), s.updateSize(), s.updateSlides(), s.params.watchOverflow && s.checkOverflow(), s.params.grabCursor && s.enabled && s.setGrabCursor(), s.params.loop && s.virtual && s.params.virtual.enabled ? s.slideTo(s.params.initialSlide + s.virtual.slidesBefore, 0, s.params.runCallbacksOnInit, !1, !0) : s.slideTo(s.params.initialSlide, 0, s.params.runCallbacksOnInit, !1, !0), s.params.loop && s.loopCreate(), s.attachEvents();
    const n = [...s.el.querySelectorAll('[loading="lazy"]')];
    return s.isElement && n.push(...s.hostEl.querySelectorAll('[loading="lazy"]')), n.forEach((r) => {
      r.complete ? $e(s, r) : r.addEventListener("load", (o) => {
        $e(s, o.target);
      });
    }), vt(s), s.initialized = !0, vt(s), s.emit("init"), s.emit("afterInit"), s;
  }
  destroy(e, s) {
    e === void 0 && (e = !0), s === void 0 && (s = !0);
    const i = this, {
      params: n,
      el: r,
      wrapperEl: o,
      slides: a
    } = i;
    return typeof i.params > "u" || i.destroyed || (i.emit("beforeDestroy"), i.initialized = !1, i.detachEvents(), n.loop && i.loopDestroy(), s && (i.removeClasses(), r && typeof r != "string" && r.removeAttribute("style"), o && o.removeAttribute("style"), a && a.length && a.forEach((l) => {
      l.classList.remove(n.slideVisibleClass, n.slideFullyVisibleClass, n.slideActiveClass, n.slideNextClass, n.slidePrevClass), l.removeAttribute("style"), l.removeAttribute("data-swiper-slide-index");
    })), i.emit("destroy"), Object.keys(i.eventsListeners).forEach((l) => {
      i.off(l);
    }), e !== !1 && (i.el && typeof i.el != "string" && (i.el.swiper = null), Bi(i)), i.destroyed = !0), null;
  }
  static extendDefaults(e) {
    Z(dt, e);
  }
  static get extendedDefaults() {
    return dt;
  }
  static get defaults() {
    return Dt;
  }
  static installModule(e) {
    W.prototype.__modules__ || (W.prototype.__modules__ = []);
    const s = W.prototype.__modules__;
    typeof e == "function" && s.indexOf(e) < 0 && s.push(e);
  }
  static use(e) {
    return Array.isArray(e) ? (e.forEach((s) => W.installModule(s)), W) : (W.installModule(e), W);
  }
}
Object.keys(lt).forEach((t) => {
  Object.keys(lt[t]).forEach((e) => {
    W.prototype[e] = lt[t][e];
  });
});
W.use([Xi, Yi]);
function tr(t, e, s, i) {
  return t.params.createElements && Object.keys(i).forEach((n) => {
    if (!s[n] && s.auto === !0) {
      let r = re(t.el, `.${i[n]}`)[0];
      r || (r = Ve("div", i[n]), r.className = i[n], t.el.append(r)), s[n] = r, e[n] = r;
    }
  }), s;
}
function _e(t) {
  return t === void 0 && (t = ""), `.${t.trim().replace(/([\.:!+\/])/g, "\\$1").replace(/ /g, ".")}`;
}
function xe(t) {
  let {
    swiper: e,
    extendParams: s,
    on: i,
    emit: n
  } = t;
  const r = "swiper-pagination";
  s({
    pagination: {
      el: null,
      bulletElement: "span",
      clickable: !1,
      hideOnClick: !1,
      renderBullet: null,
      renderProgressbar: null,
      renderFraction: null,
      renderCustom: null,
      progressbarOpposite: !1,
      type: "bullets",
      // 'bullets' or 'progressbar' or 'fraction' or 'custom'
      dynamicBullets: !1,
      dynamicMainBullets: 1,
      formatFractionCurrent: (f) => f,
      formatFractionTotal: (f) => f,
      bulletClass: `${r}-bullet`,
      bulletActiveClass: `${r}-bullet-active`,
      modifierClass: `${r}-`,
      currentClass: `${r}-current`,
      totalClass: `${r}-total`,
      hiddenClass: `${r}-hidden`,
      progressbarFillClass: `${r}-progressbar-fill`,
      progressbarOppositeClass: `${r}-progressbar-opposite`,
      clickableClass: `${r}-clickable`,
      lockClass: `${r}-lock`,
      horizontalClass: `${r}-horizontal`,
      verticalClass: `${r}-vertical`,
      paginationDisabledClass: `${r}-disabled`
    }
  }), e.pagination = {
    el: null,
    bullets: []
  };
  let o, a = 0;
  function l() {
    return !e.params.pagination.el || !e.pagination.el || Array.isArray(e.pagination.el) && e.pagination.el.length === 0;
  }
  function d(f, h) {
    const {
      bulletActiveClass: _
    } = e.params.pagination;
    f && (f = f[`${h === "prev" ? "previous" : "next"}ElementSibling`], f && (f.classList.add(`${_}-${h}`), f = f[`${h === "prev" ? "previous" : "next"}ElementSibling`], f && f.classList.add(`${_}-${h}-${h}`)));
  }
  function c(f, h, _) {
    if (f = f % _, h = h % _, h === f + 1)
      return "next";
    if (h === f - 1)
      return "previous";
  }
  function u(f) {
    const h = f.target.closest(_e(e.params.pagination.bulletClass));
    if (!h)
      return;
    f.preventDefault();
    const _ = Ge(h) * e.params.slidesPerGroup;
    if (e.params.loop) {
      if (e.realIndex === _) return;
      const T = c(e.realIndex, _, e.slides.length);
      T === "next" ? e.slideNext() : T === "previous" ? e.slidePrev() : e.slideToLoop(_);
    } else
      e.slideTo(_);
  }
  function v() {
    const f = e.rtl, h = e.params.pagination;
    if (l()) return;
    let _ = e.pagination.el;
    _ = le(_);
    let T, M;
    const A = e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : e.slides.length, L = e.params.loop ? Math.ceil(A / e.params.slidesPerGroup) : e.snapGrid.length;
    if (e.params.loop ? (M = e.previousRealIndex || 0, T = e.params.slidesPerGroup > 1 ? Math.floor(e.realIndex / e.params.slidesPerGroup) : e.realIndex) : typeof e.snapIndex < "u" ? (T = e.snapIndex, M = e.previousSnapIndex) : (M = e.previousIndex || 0, T = e.activeIndex || 0), h.type === "bullets" && e.pagination.bullets && e.pagination.bullets.length > 0) {
      const I = e.pagination.bullets;
      let C, O, k;
      if (h.dynamicBullets && (o = gt(I[0], e.isHorizontal() ? "width" : "height"), _.forEach((P) => {
        P.style[e.isHorizontal() ? "width" : "height"] = `${o * (h.dynamicMainBullets + 4)}px`;
      }), h.dynamicMainBullets > 1 && M !== void 0 && (a += T - (M || 0), a > h.dynamicMainBullets - 1 ? a = h.dynamicMainBullets - 1 : a < 0 && (a = 0)), C = Math.max(T - a, 0), O = C + (Math.min(I.length, h.dynamicMainBullets) - 1), k = (O + C) / 2), I.forEach((P) => {
        const R = [...["", "-next", "-next-next", "-prev", "-prev-prev", "-main"].map((B) => `${h.bulletActiveClass}${B}`)].map((B) => typeof B == "string" && B.includes(" ") ? B.split(" ") : B).flat();
        P.classList.remove(...R);
      }), _.length > 1)
        I.forEach((P) => {
          const R = Ge(P);
          R === T ? P.classList.add(...h.bulletActiveClass.split(" ")) : e.isElement && P.setAttribute("part", "bullet"), h.dynamicBullets && (R >= C && R <= O && P.classList.add(...`${h.bulletActiveClass}-main`.split(" ")), R === C && d(P, "prev"), R === O && d(P, "next"));
        });
      else {
        const P = I[T];
        if (P && P.classList.add(...h.bulletActiveClass.split(" ")), e.isElement && I.forEach((R, B) => {
          R.setAttribute("part", B === T ? "bullet-active" : "bullet");
        }), h.dynamicBullets) {
          const R = I[C], B = I[O];
          for (let U = C; U <= O; U += 1)
            I[U] && I[U].classList.add(...`${h.bulletActiveClass}-main`.split(" "));
          d(R, "prev"), d(B, "next");
        }
      }
      if (h.dynamicBullets) {
        const P = Math.min(I.length, h.dynamicMainBullets + 4), R = (o * P - o) / 2 - k * o, B = f ? "right" : "left";
        I.forEach((U) => {
          U.style[e.isHorizontal() ? B : "top"] = `${R}px`;
        });
      }
    }
    _.forEach((I, C) => {
      if (h.type === "fraction" && (I.querySelectorAll(_e(h.currentClass)).forEach((O) => {
        O.textContent = h.formatFractionCurrent(T + 1);
      }), I.querySelectorAll(_e(h.totalClass)).forEach((O) => {
        O.textContent = h.formatFractionTotal(L);
      })), h.type === "progressbar") {
        let O;
        h.progressbarOpposite ? O = e.isHorizontal() ? "vertical" : "horizontal" : O = e.isHorizontal() ? "horizontal" : "vertical";
        const k = (T + 1) / L;
        let P = 1, R = 1;
        O === "horizontal" ? P = k : R = k, I.querySelectorAll(_e(h.progressbarFillClass)).forEach((B) => {
          B.style.transform = `translate3d(0,0,0) scaleX(${P}) scaleY(${R})`, B.style.transitionDuration = `${e.params.speed}ms`;
        });
      }
      h.type === "custom" && h.renderCustom ? (I.innerHTML = h.renderCustom(e, T + 1, L), C === 0 && n("paginationRender", I)) : (C === 0 && n("paginationRender", I), n("paginationUpdate", I)), e.params.watchOverflow && e.enabled && I.classList[e.isLocked ? "add" : "remove"](h.lockClass);
    });
  }
  function g() {
    const f = e.params.pagination;
    if (l()) return;
    const h = e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : e.grid && e.params.grid.rows > 1 ? e.slides.length / Math.ceil(e.params.grid.rows) : e.slides.length;
    let _ = e.pagination.el;
    _ = le(_);
    let T = "";
    if (f.type === "bullets") {
      let M = e.params.loop ? Math.ceil(h / e.params.slidesPerGroup) : e.snapGrid.length;
      e.params.freeMode && e.params.freeMode.enabled && M > h && (M = h);
      for (let A = 0; A < M; A += 1)
        f.renderBullet ? T += f.renderBullet.call(e, A, f.bulletClass) : T += `<${f.bulletElement} ${e.isElement ? 'part="bullet"' : ""} class="${f.bulletClass}"></${f.bulletElement}>`;
    }
    f.type === "fraction" && (f.renderFraction ? T = f.renderFraction.call(e, f.currentClass, f.totalClass) : T = `<span class="${f.currentClass}"></span> / <span class="${f.totalClass}"></span>`), f.type === "progressbar" && (f.renderProgressbar ? T = f.renderProgressbar.call(e, f.progressbarFillClass) : T = `<span class="${f.progressbarFillClass}"></span>`), e.pagination.bullets = [], _.forEach((M) => {
      f.type !== "custom" && (M.innerHTML = T || ""), f.type === "bullets" && e.pagination.bullets.push(...M.querySelectorAll(_e(f.bulletClass)));
    }), f.type !== "custom" && n("paginationRender", _[0]);
  }
  function m() {
    e.params.pagination = tr(e, e.originalParams.pagination, e.params.pagination, {
      el: "swiper-pagination"
    });
    const f = e.params.pagination;
    if (!f.el) return;
    let h;
    typeof f.el == "string" && e.isElement && (h = e.el.querySelector(f.el)), !h && typeof f.el == "string" && (h = [...document.querySelectorAll(f.el)]), h || (h = f.el), !(!h || h.length === 0) && (e.params.uniqueNavElements && typeof f.el == "string" && Array.isArray(h) && h.length > 1 && (h = [...e.el.querySelectorAll(f.el)], h.length > 1 && (h = h.find((_) => us(_, ".swiper")[0] === e.el))), Array.isArray(h) && h.length === 1 && (h = h[0]), Object.assign(e.pagination, {
      el: h
    }), h = le(h), h.forEach((_) => {
      f.type === "bullets" && f.clickable && _.classList.add(...(f.clickableClass || "").split(" ")), _.classList.add(f.modifierClass + f.type), _.classList.add(e.isHorizontal() ? f.horizontalClass : f.verticalClass), f.type === "bullets" && f.dynamicBullets && (_.classList.add(`${f.modifierClass}${f.type}-dynamic`), a = 0, f.dynamicMainBullets < 1 && (f.dynamicMainBullets = 1)), f.type === "progressbar" && f.progressbarOpposite && _.classList.add(f.progressbarOppositeClass), f.clickable && _.addEventListener("click", u), e.enabled || _.classList.add(f.lockClass);
    }));
  }
  function w() {
    const f = e.params.pagination;
    if (l()) return;
    let h = e.pagination.el;
    h && (h = le(h), h.forEach((_) => {
      _.classList.remove(f.hiddenClass), _.classList.remove(f.modifierClass + f.type), _.classList.remove(e.isHorizontal() ? f.horizontalClass : f.verticalClass), f.clickable && (_.classList.remove(...(f.clickableClass || "").split(" ")), _.removeEventListener("click", u));
    })), e.pagination.bullets && e.pagination.bullets.forEach((_) => _.classList.remove(...f.bulletActiveClass.split(" ")));
  }
  i("changeDirection", () => {
    if (!e.pagination || !e.pagination.el) return;
    const f = e.params.pagination;
    let {
      el: h
    } = e.pagination;
    h = le(h), h.forEach((_) => {
      _.classList.remove(f.horizontalClass, f.verticalClass), _.classList.add(e.isHorizontal() ? f.horizontalClass : f.verticalClass);
    });
  }), i("init", () => {
    e.params.pagination.enabled === !1 ? S() : (m(), g(), v());
  }), i("activeIndexChange", () => {
    typeof e.snapIndex > "u" && v();
  }), i("snapIndexChange", () => {
    v();
  }), i("snapGridLengthChange", () => {
    g(), v();
  }), i("destroy", () => {
    w();
  }), i("enable disable", () => {
    let {
      el: f
    } = e.pagination;
    f && (f = le(f), f.forEach((h) => h.classList[e.enabled ? "remove" : "add"](e.params.pagination.lockClass)));
  }), i("lock unlock", () => {
    v();
  }), i("click", (f, h) => {
    const _ = h.target, T = le(e.pagination.el);
    if (e.params.pagination.el && e.params.pagination.hideOnClick && T && T.length > 0 && !_.classList.contains(e.params.pagination.bulletClass)) {
      if (e.navigation && (e.navigation.nextEl && _ === e.navigation.nextEl || e.navigation.prevEl && _ === e.navigation.prevEl)) return;
      const M = T[0].classList.contains(e.params.pagination.hiddenClass);
      n(M === !0 ? "paginationShow" : "paginationHide"), T.forEach((A) => A.classList.toggle(e.params.pagination.hiddenClass));
    }
  });
  const b = () => {
    e.el.classList.remove(e.params.pagination.paginationDisabledClass);
    let {
      el: f
    } = e.pagination;
    f && (f = le(f), f.forEach((h) => h.classList.remove(e.params.pagination.paginationDisabledClass))), m(), g(), v();
  }, S = () => {
    e.el.classList.add(e.params.pagination.paginationDisabledClass);
    let {
      el: f
    } = e.pagination;
    f && (f = le(f), f.forEach((h) => h.classList.add(e.params.pagination.paginationDisabledClass))), w();
  };
  Object.assign(e.pagination, {
    enable: b,
    disable: S,
    render: g,
    update: v,
    init: m,
    destroy: w
  });
}
function Nt(t) {
  let {
    swiper: e,
    extendParams: s,
    on: i,
    emit: n,
    params: r
  } = t;
  e.autoplay = {
    running: !1,
    paused: !1,
    timeLeft: 0
  }, s({
    autoplay: {
      enabled: !1,
      delay: 3e3,
      waitForTransition: !0,
      disableOnInteraction: !1,
      stopOnLastSlide: !1,
      reverseDirection: !1,
      pauseOnMouseEnter: !1
    }
  });
  let o, a, l = r && r.autoplay ? r.autoplay.delay : 3e3, d = r && r.autoplay ? r.autoplay.delay : 3e3, c, u = (/* @__PURE__ */ new Date()).getTime(), v, g, m, w, b, S, f;
  function h(z) {
    !e || e.destroyed || !e.wrapperEl || z.target === e.wrapperEl && (e.wrapperEl.removeEventListener("transitionend", h), !(f || z.detail && z.detail.bySwiperTouchMove) && C());
  }
  const _ = () => {
    if (e.destroyed || !e.autoplay.running) return;
    e.autoplay.paused ? v = !0 : v && (d = c, v = !1);
    const z = e.autoplay.paused ? c : u + d - (/* @__PURE__ */ new Date()).getTime();
    e.autoplay.timeLeft = z, n("autoplayTimeLeft", z, z / l), a = requestAnimationFrame(() => {
      _();
    });
  }, T = () => {
    let z;
    return e.virtual && e.params.virtual.enabled ? z = e.slides.find((Y) => Y.classList.contains("swiper-slide-active")) : z = e.slides[e.activeIndex], z ? parseInt(z.getAttribute("data-swiper-autoplay"), 10) : void 0;
  }, M = (z) => {
    if (e.destroyed || !e.autoplay.running) return;
    cancelAnimationFrame(a), _();
    let te = typeof z > "u" ? e.params.autoplay.delay : z;
    l = e.params.autoplay.delay, d = e.params.autoplay.delay;
    const Y = T();
    !Number.isNaN(Y) && Y > 0 && typeof z > "u" && (te = Y, l = Y, d = Y), c = te;
    const ue = e.params.speed, Oe = () => {
      !e || e.destroyed || (e.params.autoplay.reverseDirection ? !e.isBeginning || e.params.loop || e.params.rewind ? (e.slidePrev(ue, !0, !0), n("autoplay")) : e.params.autoplay.stopOnLastSlide || (e.slideTo(e.slides.length - 1, ue, !0, !0), n("autoplay")) : !e.isEnd || e.params.loop || e.params.rewind ? (e.slideNext(ue, !0, !0), n("autoplay")) : e.params.autoplay.stopOnLastSlide || (e.slideTo(0, ue, !0, !0), n("autoplay")), e.params.cssMode && (u = (/* @__PURE__ */ new Date()).getTime(), requestAnimationFrame(() => {
        M();
      })));
    };
    return te > 0 ? (clearTimeout(o), o = setTimeout(() => {
      Oe();
    }, te)) : requestAnimationFrame(() => {
      Oe();
    }), te;
  }, A = () => {
    u = (/* @__PURE__ */ new Date()).getTime(), e.autoplay.running = !0, M(), n("autoplayStart");
  }, L = () => {
    e.autoplay.running = !1, clearTimeout(o), cancelAnimationFrame(a), n("autoplayStop");
  }, I = (z, te) => {
    if (e.destroyed || !e.autoplay.running) return;
    clearTimeout(o), z || (S = !0);
    const Y = () => {
      n("autoplayPause"), e.params.autoplay.waitForTransition ? e.wrapperEl.addEventListener("transitionend", h) : C();
    };
    if (e.autoplay.paused = !0, te) {
      b && (c = e.params.autoplay.delay), b = !1, Y();
      return;
    }
    c = (c || e.params.autoplay.delay) - ((/* @__PURE__ */ new Date()).getTime() - u), !(e.isEnd && c < 0 && !e.params.loop) && (c < 0 && (c = 0), Y());
  }, C = () => {
    e.isEnd && c < 0 && !e.params.loop || e.destroyed || !e.autoplay.running || (u = (/* @__PURE__ */ new Date()).getTime(), S ? (S = !1, M(c)) : M(), e.autoplay.paused = !1, n("autoplayResume"));
  }, O = () => {
    if (e.destroyed || !e.autoplay.running) return;
    const z = oe();
    z.visibilityState === "hidden" && (S = !0, I(!0)), z.visibilityState === "visible" && C();
  }, k = (z) => {
    z.pointerType === "mouse" && (S = !0, f = !0, !(e.animating || e.autoplay.paused) && I(!0));
  }, P = (z) => {
    z.pointerType === "mouse" && (f = !1, e.autoplay.paused && C());
  }, R = () => {
    e.params.autoplay.pauseOnMouseEnter && (e.el.addEventListener("pointerenter", k), e.el.addEventListener("pointerleave", P));
  }, B = () => {
    e.el && typeof e.el != "string" && (e.el.removeEventListener("pointerenter", k), e.el.removeEventListener("pointerleave", P));
  }, U = () => {
    oe().addEventListener("visibilitychange", O);
  }, st = () => {
    oe().removeEventListener("visibilitychange", O);
  };
  i("init", () => {
    e.params.autoplay.enabled && (R(), U(), A());
  }), i("destroy", () => {
    B(), st(), e.autoplay.running && L();
  }), i("_freeModeStaticRelease", () => {
    (m || S) && C();
  }), i("_freeModeNoMomentumRelease", () => {
    e.params.autoplay.disableOnInteraction ? L() : I(!0, !0);
  }), i("beforeTransitionStart", (z, te, Y) => {
    e.destroyed || !e.autoplay.running || (Y || !e.params.autoplay.disableOnInteraction ? I(!0, !0) : L());
  }), i("sliderFirstMove", () => {
    if (!(e.destroyed || !e.autoplay.running)) {
      if (e.params.autoplay.disableOnInteraction) {
        L();
        return;
      }
      g = !0, m = !1, S = !1, w = setTimeout(() => {
        S = !0, m = !0, I(!0);
      }, 200);
    }
  }), i("touchEnd", () => {
    if (!(e.destroyed || !e.autoplay.running || !g)) {
      if (clearTimeout(w), clearTimeout(o), e.params.autoplay.disableOnInteraction) {
        m = !1, g = !1;
        return;
      }
      m && e.params.cssMode && C(), m = !1, g = !1;
    }
  }), i("slideChange", () => {
    e.destroyed || !e.autoplay.running || (b = !0);
  }), Object.assign(e.autoplay, {
    start: A,
    stop: L,
    pause: I,
    resume: C
  });
}
const sr = {
  xmlns: "http://www.w3.org/2000/svg",
  style: { display: "none" }
}, ir = { class: "FixedRatio ratio-3-2 falling-off-left falling-off-right desk-l:falling-off-max-left desk-l:falling-off-max-right" }, nr = ["data-swiper-id"], rr = { class: "swiper-wrapper Swiper__wrapper" }, or = ["onClick"], ar = { class: "etx-background-media BackgroundMedia" }, lr = { class: "etx-media Media" }, dr = ["src"], cr = { class: "swiper Swiper" }, ur = { class: "swiper-wrapper Swiper__wrapper" }, fr = ["onClick"], pr = {
  key: 1,
  class: "etx-text Text"
}, hr = { class: "font-uppercase font-weight-bold font-color-primary" }, mr = { class: "Swiper__cta" }, gr = {
  key: 0,
  class: "etx-button-list ButtonList"
}, vr = { class: "etx-button__text Button__text" }, Pd = /* @__PURE__ */ ee({
  __name: "HighlightComponent",
  props: {
    background: {},
    dataSource: {},
    stripeImage: {},
    speed: {},
    allRefsText: {}
  },
  emits: ["allReferencesClicked", "referenceClicked"],
  setup(t, { emit: e }) {
    const s = e, i = t, n = se(i.dataSource), r = (/* @__PURE__ */ new Date()).getTime(), o = (/* @__PURE__ */ new Date()).getTime() + 1;
    let a, l;
    const d = () => {
      const g = n.data.length > 1;
      a && a.destroy(!0, !0), l && l.destroy(!0, !0), l = new W(`.SwiperReferenceHighlightControls[data-swiper-id="${o}"] .Swiper`, {
        direction: "horizontal",
        loop: g,
        slidesPerGroup: 1,
        slidesPerView: 1,
        autoplay: {
          delay: 5e3,
          disableOnInteraction: !1
        },
        simulateTouch: !0,
        pagination: {
          enabled: !0,
          el: `.SwiperReferenceHighlightControls[data-swiper-id="${o}"] .Swiper__controls__pagination`,
          clickable: !0
        },
        effect: "horizontal",
        modules: [xe, Nt]
      }), a = new W(`.SwiperReferenceHighlight[data-swiper-id="${r}"].Swiper`, {
        direction: "horizontal",
        loop: g,
        slidesPerGroup: 1,
        slidesPerView: 1,
        autoplay: {
          delay: 5e3,
          disableOnInteraction: !1
        },
        simulateTouch: !0,
        pagination: {
          enabled: !0,
          el: `.SwiperReferenceHighlightControls[data-swiper-id="${o}"] .Swiper__controls__pagination`,
          clickable: !0
        },
        effect: "horizontal",
        modules: [Nt, xe]
      }), a.on("realIndexChange", (m) => {
        l && l.slideTo(m.realIndex);
      });
    };
    let c;
    we(() => {
      c = n.loaded$.subscribe(() => {
        d();
      });
    }), Ye(() => {
      c && c.unsubscribe();
    });
    const u = () => {
      s("allReferencesClicked");
    }, v = (g) => {
      s("referenceClicked", g);
    };
    return (g, m) => (x(), E(H, null, [
      (x(), E("svg", sr, m[1] || (m[1] = [
        Ws('<symbol id="brandshape-vertical" viewBox="0 0 208 208"><path style="fill:var(--color-svg-main);" d="M208,0h-41.6v208h41.6V0Z"></path><path style="fill:var(--color-svg-main);" d="M41.6,0H0v208h41.6V0Z"></path><path style="fill:var(--color-svg-accent);" d="M124.8,0h-41.6v208h41.6V0Z"></path></symbol><symbol id="brandshape-vertical" viewBox="0 0 208 208"><path style="fill:var(--color-svg-main);" d="M60.9,0h-.4l-.4.8L0,60.9v58.8L78.2,41.6h129.8V0H60.9Z"></path><path style="fill:var(--color-svg-accent);" d="M95.4,83.2L0,178.6v29.4h29.4l83.2-83.2h95.4v-41.6h-112.6Z"></path><path style="fill:var(--color-svg-main);" d="M147.1,208h60.9v-41.6h-78.2l-41.6,41.6h58.8Z"></path></symbol>', 2)
      ]))),
      V((x(), E("div", {
        class: ge(["ReferenceHighlight", i.background === "right" ? "invert" : ""])
      }, [
        p("div", ir, [
          m[2] || (m[2] = p("div", {
            class: "Brandshape av-top",
            "data-color-main": "primary",
            "data-color-accent": "azure"
          }, [
            p("svg", {
              width: "208",
              height: "208"
            }, [
              p("use", { "xlink:href": "#brandshape-vertical" })
            ])
          ], -1)),
          p("div", {
            class: "SwiperReferenceHighlight swiper Swiper",
            "data-swiper-id": N(r)
          }, [
            p("div", rr, [
              (x(!0), E(H, null, q(n.data, (w, b) => (x(), E("div", {
                key: "swiper-image-" + b,
                class: "swiper-slide Swiper__wrapper__slide"
              }, [
                w.id ? (x(), E("a", {
                  key: 0,
                  class: "Swiper__wrapper__slide__link",
                  onClick: (S) => v(w)
                }, null, 8, or)) : D("", !0),
                p("div", ar, [
                  p("div", lr, [
                    p("picture", null, [
                      w.image ? (x(), E("img", {
                        key: 0,
                        src: w.image,
                        loading: "eager"
                      }, null, 8, dr)) : D("", !0)
                    ])
                  ])
                ])
              ]))), 128))
            ])
          ], 8, nr)
        ]),
        p("div", {
          class: "SwiperReferenceHighlightControls",
          "data-swiper-id": o
        }, [
          p("div", cr, [
            p("div", ur, [
              (x(!0), E(H, null, q(n.data, (w, b) => (x(), E("div", {
                key: "swiper-info-" + b,
                class: "swiper-slide Swiper__wrapper__slide"
              }, [
                w.id ? (x(), E("a", {
                  key: 0,
                  class: "Swiper__wrapper__slide__link",
                  onClick: (S) => v(w)
                }, null, 8, fr)) : D("", !0),
                w.title ? (x(), E("div", pr, [
                  p("p", null, [
                    p("span", hr, F(w.title.main), 1),
                    m[3] || (m[3] = p("br", null, null, -1)),
                    ls(" " + F(w.title.sub), 1)
                  ])
                ])) : D("", !0)
              ]))), 128))
            ])
          ]),
          m[5] || (m[5] = p("div", { class: "Swiper__controls" }, [
            p("div", { class: "Swiper__controls__pagination" })
          ], -1)),
          p("div", mr, [
            i.allRefsText ? (x(), E("div", gr, [
              p("a", {
                class: "etx-button Button minimal",
                onClick: m[0] || (m[0] = (w) => u()),
                title: ""
              }, [
                p("div", vr, [
                  p("span", null, F(i.allRefsText), 1)
                ]),
                m[4] || (m[4] = p("div", { class: "etx-button__icon Button__icon" }, [
                  p("i", { class: "far fa-long-arrow-right" })
                ], -1))
              ])
            ])) : D("", !0)
          ])
        ])
      ], 2)), [
        [N(G)]
      ])
    ], 64));
  }
}), ve = (t) => () => {
  if (t) {
    const e = t.el;
    e && (e.removeAttribute("style"), e.setAttribute("style", "--swiper-min-height: " + wr(e) + "px")), t.update();
  }
}, wr = (t) => {
  const e = getComputedStyle(t), s = parseFloat(e.marginTop) + parseFloat(e.marginBottom);
  return Math.ceil(t.offsetHeight + s);
}, yr = ["data-swiper-id"], br = { class: "etx-media Media" }, _r = { class: "" }, Sr = ["src", "data-src"], xr = /* @__PURE__ */ ee({
  __name: "ImageSliderComponent",
  props: {
    images: {},
    id: {}
  },
  setup(t) {
    const e = t, s = Ie(e.images);
    s.value.length < 3 && (s.value = [...s.value, ...s.value]);
    const i = Ie(null);
    let n = Ie(void 0);
    const r = async () => {
      await Js(), n.value && n.value.destroy(!0, !0);
      let o;
      n.value = new W(`.Swiper[data-swiper-id="${e.id}"]`, {
        direction: "horizontal",
        autoplay: !1,
        autoHeight: !1,
        slidesPerView: "auto",
        spaceBetween: 30,
        loop: !0,
        simulateTouch: !0,
        pagination: {
          enabled: !0,
          el: `.Swiper[data-swiper-id="${e.id}"] .Swiper__controls__pagination`,
          clickable: !0
        },
        modules: [xe]
      }), n.value.on("resize", () => {
        clearTimeout(o), o = setTimeout(() => {
          setTimeout(() => {
            if (n?.value) {
              const l = n.value.slides[0].offsetHeight;
              n.value.el.style.height = l + "px", console.log("size:", n.value.el.style.height), n.value.update();
            }
          }, 1250);
        }, 300);
      }), n.value.update(), setTimeout(() => {
        window.addEventListener("resize", () => {
          ve(n.value);
        });
      }, 10);
    };
    return Xs(async () => e.images, () => {
      r();
    }), Ye(() => {
      n && window.removeEventListener("resize", ve(n.value));
    }), Ys(() => {
      n.value && n.value.destroy(!0, !0);
    }), we(async () => {
      setTimeout(() => {
        r();
      }, 0);
    }), (o, a) => V((x(), E("div", {
      class: "swiper Swiper SwiperImages move-up",
      "data-swiper-id": e.id,
      style: { "--swiper-min-height": "783px" }
    }, [
      p("div", {
        ref_key: "swiperWrapperRef",
        ref: i,
        class: "swiper-wrapper Swiper__wrapper"
      }, [
        (x(!0), E(H, null, q(s.value, (l, d) => (x(), E("div", {
          key: "media-slider-" + d,
          class: "swiper-slide Swiper__wrapper__slide"
        }, [
          p("div", br, [
            p("picture", _r, [
              p("img", {
                src: l.url,
                "data-src": l.url
              }, null, 8, Sr)
            ])
          ])
        ]))), 128))
      ], 512),
      a[0] || (a[0] = p("div", { class: "Swiper__controls" }, [
        p("div", { class: "swiper-pagination Swiper__controls__pagination" })
      ], -1))
    ], 8, yr)), [
      [N(G)]
    ]);
  }
}), Tr = ["data-swiper-id"], Er = { class: "swiper-wrapper Swiper__wrapper" }, Cr = { class: "etx-center Center" }, Pr = { class: "etx-flex Flex gv-0 tab-m:gv-0 av-stretch" }, Or = {
  key: 0,
  class: "etx-flex__item Flex__item c-0 tab-m:c-4"
}, Lr = { class: "etx-media Media" }, Mr = { class: "" }, Ar = ["src", "data-src"], kr = { class: "etx-flex__item Flex__item tab-m:c-7 tab-m:ml-1" }, Ir = {
  class: "etx-card Card",
  "data-angle-position": "top-left",
  "data-angle-color": "secondary"
}, $r = { class: "etx-card__item Card__item pl-150 pr-0 pt-150 pb-200 grow-1" }, Rr = { class: "etx-text Text" }, Fr = { class: "etx-card__item Card__item pl-150 pr-0 pv-0" }, Br = { class: "etx-text Text" }, zr = { class: "font-size-larger font-weight-bold" }, Dr = /* @__PURE__ */ ee({
  __name: "QuoteSliderComponent",
  props: {
    quotes: {},
    id: {}
  },
  setup(t) {
    const e = t, s = se(e.quotes);
    let i;
    const n = () => {
      i = new W(`.Swiper[data-swiper-id="${e.id}"]`, {
        direction: "horizontal",
        autoplay: !1,
        autoHeight: !0,
        loop: !1,
        spaceBetween: 30,
        simulateTouch: !0,
        pagination: {
          enabled: !0,
          el: `.Swiper[data-swiper-id="${e.id}"] .Swiper__controls__pagination`,
          clickable: !0
        },
        modules: [xe]
      }), window.addEventListener("resize", ve(i));
    };
    return we(() => {
      n();
    }), Ye(() => {
      i && window.removeEventListener("resize", ve(i));
    }), (r, o) => V((x(), E("div", {
      class: "swiper Swiper SwiperQuotes move-up",
      "data-swiper-id": e.id
    }, [
      p("div", Er, [
        (x(!0), E(H, null, q(s, (a, l) => (x(), E("div", {
          key: "media-slider-" + l,
          class: "swiper-slide Swiper__wrapper__slide"
        }, [
          p("div", Cr, [
            p("div", Pr, [
              a.image ? (x(), E("div", Or, [
                p("div", Lr, [
                  p("picture", Mr, [
                    p("img", {
                      src: a.image.url,
                      "data-src": a.image.url
                    }, null, 8, Ar)
                  ])
                ])
              ])) : D("", !0),
              p("div", kr, [
                p("div", Ir, [
                  p("div", $r, [
                    p("div", Rr, [
                      p("blockquote", null, [
                        p("p", null, F(a.quote), 1)
                      ])
                    ])
                  ]),
                  p("div", Fr, [
                    p("div", Br, [
                      p("p", zr, F(a.person), 1)
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]))), 128))
      ]),
      o[0] || (o[0] = p("div", { class: "Swiper__controls" }, [
        p("div", { class: "swiper-pagination Swiper__controls__pagination" })
      ], -1))
    ], 8, Tr)), [
      [N(G)]
    ]);
  }
}), Od = () => se({
  hero: {
    title: {
      main: "",
      sub: ""
    },
    image: {
      url: ""
    },
    breadcrumbs: []
  },
  intro: {
    text: "",
    title: {
      main: "",
      sub: ""
    },
    wanted: {
      cta: {
        text: ""
      },
      date: {
        text: ""
      },
      location: {
        text: ""
      },
      title: {
        main: ""
      }
    }
  },
  images: [],
  textBlock: {
    title: {
      main: ""
    },
    content: {
      text: ""
    }
  }
}), Nr = { class: "etx-flex Flex gv-200 tab-l:gv-0" }, Hr = { class: "etx-flex__item Flex__item tab-s:c-10 tab-m:c-9 tab-l:c-4 desk-s:c-3" }, Vr = { class: "etx-text Text" }, Gr = { class: "font-color-primary" }, jr = { class: "etx-flex__item Flex__item tab-l:c-7 desk-s:c-8 tab-l:ml-1" }, Ur = { class: "etx-flex Flex mob-m:c-2 tab-m:c-3 gh-50 gv-50 tab-s:gh-100 tab-s:gv-100 av-stretch" }, qr = { class: "etx-flex__item Flex__item c-12" }, Wr = { class: "etx-text Text" }, Xr = { class: "font-h4" }, Yr = {
  key: 0,
  class: "etx-flex__item Flex__item c-12"
}, Jr = { class: "etx-text Text" }, Kr = {
  key: 1,
  class: "etx-flex__item Flex__item c-12"
}, Zr = ["href"], Qr = { class: "etx-button__text Button__text" }, eo = { class: "etx-flex__item Flex__item" }, to = ["href"], so = { class: "etx-card__item Card__item ph-75 pv-75" }, io = { class: "etx-item Item fullwidth av-bottom" }, no = { class: "etx-item__text Item__text" }, ro = { class: "font-size-large font-weight-bold" }, oo = /* @__PURE__ */ ee({
  __name: "TileTeaserComponent",
  props: {
    data: {}
  },
  setup(t) {
    const s = se(t.data);
    return we(() => {
    }), (i, n) => (x(), E("div", Nr, [
      p("div", Hr, [
        V((x(), E("div", Vr, [
          p("h3", Gr, F(s.title.main), 1),
          p("p", null, F(s.text), 1)
        ])), [
          [N(G)]
        ])
      ]),
      p("div", jr, [
        (x(!0), E(H, null, q(s.sections, (r, o) => (x(), E("div", Ur, [
          p("div", qr, [
            V((x(), E("div", Wr, [
              p("p", Xr, F(r.title.main), 1)
            ])), [
              [N(G)]
            ])
          ]),
          (x(!0), E(H, null, q(r.subSections, (a, l) => (x(), E(H, null, [
            a.url ? D("", !0) : (x(), E("div", Yr, [
              V((x(), E("div", Jr, [
                p("p", null, F(a.text), 1)
              ])), [
                [N(G)]
              ])
            ])),
            a.url ? (x(), E("div", Kr, [
              V((x(), E("a", {
                class: "etx-button Button minimal padding-h-0 color-primary",
                href: a.url,
                title: ""
              }, [
                p("div", Qr, [
                  p("span", null, F(a.text), 1)
                ]),
                n[0] || (n[0] = p("div", { class: "etx-button__icon Button__icon" }, [
                  p("i", { class: "far fa-long-arrow-right" })
                ], -1))
              ], 8, Zr)), [
                [N(G)]
              ])
            ])) : D("", !0),
            (x(!0), E(H, null, q(a.tiles, (d, c) => (x(), E("div", eo, [
              V((x(), E("div", {
                class: ge(["etx-card Card CardLink has-link", d.style?.bgPrimary === !0 ? "bg-primary" : "bg-secondary"])
              }, [
                p("a", {
                  class: "etx-card__link Card__link",
                  href: d.url,
                  title: ""
                }, null, 8, to),
                n[2] || (n[2] = p("div", { class: "etx-card__item Card__item pv-0 grow-1" }, null, -1)),
                p("div", so, [
                  p("div", io, [
                    p("div", no, [
                      p("p", ro, F(d.text), 1)
                    ]),
                    n[1] || (n[1] = p("div", { class: "etx-item__icon Item__icon" }, [
                      p("div", { class: "Icon" }, [
                        p("i", { class: "far fa-long-arrow-right" })
                      ])
                    ], -1))
                  ])
                ])
              ], 2)), [
                [N(G)]
              ])
            ]))), 256))
          ], 64))), 256))
        ]))), 256))
      ])
    ]));
  }
}), ao = { class: "etx-flex__item Flex__item tab-m:c-5 tab-m:ml-1" }, lo = {
  class: "etx-card Card bg-secondary move-up",
  "data-angle-position": "top-right",
  "data-angle-color": "orange"
}, co = { class: "etx-card__item Card__item ph-150 pv-150" }, uo = { class: "etx-text Text" }, fo = {
  key: 0,
  class: "font-weight-bold"
}, po = {
  key: 0,
  class: "etx-card__item Card__item ph-150 pt-0"
}, ho = { class: "etx-text Text" }, mo = { class: "font-weight-bold" }, go = { class: "font-color-primary" }, vo = { class: "etx-card__item Card__item ph-150 pt-0 pb-50" }, wo = { class: "etx-item Item" }, yo = { class: "etx-item__text Item__text" }, bo = { class: "etx-card__item Card__item ph-150 pt-0 pb-50" }, _o = { class: "etx-item Item" }, So = { class: "etx-item__text Item__text" }, xo = { key: 0 }, To = { key: 1 }, Eo = { class: "etx-card__item Card__item ph-150 pt-0 pb-150" }, Co = { class: "etx-button__text Button__text" }, Po = /* @__PURE__ */ ee({
  __name: "WantedPosterComponent",
  props: {
    data: {}
  },
  emits: ["ctaClicked"],
  setup(t, { emit: e }) {
    const s = e, n = se(t), r = () => {
      s("ctaClicked");
    };
    return (o, a) => (x(), E("div", ao, [
      V((x(), E("div", lo, [
        p("div", co, [
          p("div", uo, [
            p("h3", null, F(n.data.title.main), 1),
            n.data.title.sub ? (x(), E("p", fo, F(n.data.title.sub), 1)) : D("", !0)
          ])
        ]),
        n.data.customer ? (x(), E("div", po, [
          p("div", ho, [
            p("p", mo, [
              ls(F(n.data.customer.title), 1),
              a[1] || (a[1] = p("br", null, null, -1)),
              p("span", go, F(n.data.customer.value), 1)
            ])
          ])
        ])) : D("", !0),
        p("div", vo, [
          p("div", wo, [
            a[2] || (a[2] = p("div", { class: "etx-item__icon Item__icon font-color-primary" }, [
              p("i", { class: "far fa-map-marker-alt" })
            ], -1)),
            p("div", yo, [
              p("p", null, F(n.data.location.text), 1)
            ])
          ])
        ]),
        p("div", bo, [
          p("div", _o, [
            a[3] || (a[3] = p("div", { class: "etx-item__icon Item__icon font-color-primary" }, [
              p("i", { class: "far fa-calendar" })
            ], -1)),
            p("div", So, [
              n.data.date.text !== "2099" ? (x(), E("p", xo, F(n.data.date.text), 1)) : (x(), E("p", To, "Ongoing"))
            ])
          ])
        ]),
        p("div", Eo, [
          n.data.cta !== void 0 ? (x(), E("a", {
            key: 0,
            class: "etx-button Button focus fullwidth",
            onClick: a[0] || (a[0] = (l) => r()),
            title: ""
          }, [
            p("div", Co, [
              p("span", null, F(n.data.cta.text), 1)
            ]),
            a[4] || (a[4] = p("div", { class: "etx-button__icon Button__icon" }, [
              p("i", { class: "far fa-long-arrow-right" })
            ], -1))
          ])) : D("", !0)
        ])
      ])), [
        [N(G)]
      ])
    ]));
  }
}), Oo = {
  key: 0,
  class: "etx-container Container overflow-visible"
}, Lo = { class: "etx-center Center" }, Mo = { class: "etx-flex Flex tab-s:gv-0" }, Ao = { class: "etx-flex__item Flex__item tab-s:c-10 tab-m:c-6" }, ko = { class: "etx-text Text" }, Io = ["innerHTML"], $o = ["innerHTML"], Ro = ["innerHTML"], Fo = {
  key: 0,
  class: "etx-flex__item Flex__item tab-m:c-5 tab-m:ml-1"
}, Bo = {
  key: 1,
  class: "etx-container Container pt-0"
}, zo = { class: "etx-center Center" }, Do = { class: "etx-flex Flex gv-0" }, No = { class: "etx-flex__item Flex__item" }, Ho = {
  key: 2,
  class: "etx-container Container pt-0"
}, Vo = { class: "etx-center Center" }, Go = {
  key: 3,
  class: "etx-container Container pt-0"
}, jo = { class: "etx-center Center" }, Uo = { class: "etx-flex Flex tab-l:gv-0" }, qo = { class: "etx-flex__item Flex__item tab-s:c-10 tab-m:c-9 tab-l:c-4 desk-s:c-3" }, Wo = { class: "etx-text Text" }, Xo = { class: "font-h3 font-color-primary" }, Yo = { class: "etx-flex__item Flex__item tab-s:c-10 tab-m:c-9 tab-l:c-7 desk-s:c-8 tab-l:ml-1" }, Jo = { class: "etx-text Text" }, Ko = ["innerHTML"], Zo = {
  key: 4,
  class: "etx-container Container pt-0"
}, Qo = { class: "etx-center Center" }, ea = { class: "etx-flex Flex" }, ta = { class: "etx-flex__item Flex__item tab-s:c-10 tab-m:c-9 tab-l:c-8 tab-s:ml-2 tab-m:ml-3 tab-l:ml-4" }, sa = ["innerHTML"], ia = {
  key: 5,
  class: "etx-container Container pt-0"
}, na = { class: "etx-center Center" }, ra = { class: "etx-center Center" }, oa = { class: "etx-flex Flex gv-200 tab-l:gv-0" }, aa = { class: "etx-flex__item Flex__item tab-s:c-10 tab-m:c-9 tab-l:c-4 desk-s:c-3" }, la = { class: "etx-text Text" }, da = { class: "font-h3 font-color-primary" }, ca = { class: "etx-flex__item Flex__item tab-l:c-7 desk-s:c-8 tab-l:ml-1" }, ua = { class: "etx-flex Flex gh-200 gv-150 mob-l:c-2" }, fa = { class: "etx-text Text" }, Ld = /* @__PURE__ */ ee({
  __name: "ReferenceDetailComponent",
  props: {
    data: {}
  },
  emits: ["ctaClicked"],
  setup(t, { emit: e }) {
    const s = t, i = se(s), n = Ks(() => s.data.advantages?.style ?? "bg-secondary"), r = e, o = () => {
      r("ctaClicked");
    };
    return (a, l) => (x(), E(H, null, [
      fe($i, {
        data: i.data.hero
      }, null, 8, ["data"]),
      i.data.intro ? (x(), E("div", Oo, [
        p("div", Lo, [
          p("div", Mo, [
            p("div", Ao, [
              V((x(), E("div", ko, [
                p("h2", {
                  class: "font-h3",
                  innerHTML: i.data.intro.title.main
                }, null, 8, Io),
                p("p", {
                  class: "font-lead",
                  innerHTML: i.data.intro.title.sub
                }, null, 8, $o),
                p("p", {
                  innerHTML: i.data.intro.text
                }, null, 8, Ro)
              ])), [
                [N(G)]
              ])
            ]),
            i.data.intro.wanted ? (x(), E("div", Fo, [
              fe(Po, {
                data: i.data.intro.wanted,
                onCtaClicked: l[0] || (l[0] = (d) => o())
              }, null, 8, ["data"])
            ])) : D("", !0)
          ])
        ])
      ])) : D("", !0),
      i.data.images?.length > 1 ? (x(), E("div", Bo, [
        p("div", zo, [
          p("div", Do, [
            p("div", No, [
              fe(xr, {
                id: "image-slider-1",
                images: i.data.images
              }, null, 8, ["images"])
            ])
          ])
        ])
      ])) : D("", !0),
      i.data.tileTeaser ? (x(), E("div", Ho, [
        p("div", Vo, [
          fe(oo, {
            data: i.data.tileTeaser
          }, null, 8, ["data"])
        ])
      ])) : D("", !0),
      i.data.textBlock && i.data.textBlock.title.main && i.data.textBlock.content.text ? (x(), E("div", Go, [
        p("div", jo, [
          p("div", Uo, [
            p("div", qo, [
              V((x(), E("div", Wo, [
                p("h2", Xo, F(i.data.textBlock.title.main), 1)
              ])), [
                [N(G)]
              ])
            ]),
            p("div", Yo, [
              V((x(), E("div", Jo, [
                p("p", {
                  innerHTML: i.data.textBlock.content.text
                }, null, 8, Ko)
              ])), [
                [N(G)]
              ])
            ])
          ])
        ])
      ])) : D("", !0),
      i.data.mediaBlock && i.data.mediaBlock.code ? (x(), E("div", Zo, [
        p("div", Qo, [
          p("div", ea, [
            p("div", ta, [
              V(p("div", {
                class: "etx-video Video",
                innerHTML: i.data.mediaBlock.code
              }, null, 8, sa), [
                [N(G)]
              ])
            ])
          ])
        ])
      ])) : D("", !0),
      (i.data.quotes?.length ?? 0) > 0 ? (x(), E("div", ia, [
        p("div", na, [
          fe(Dr, {
            id: "quote-slider-1",
            quotes: i.data.quotes
          }, null, 8, ["quotes"])
        ])
      ])) : D("", !0),
      (i.data.advantages?.advantages.length ?? 0) > 0 ? (x(), E("div", {
        key: 6,
        class: ge(["etx-container Container pt-100 pb-100", n.value])
      }, [
        p("div", ra, [
          p("div", oa, [
            p("div", aa, [
              V((x(), E("div", la, [
                p("h2", da, F(i.data.advantages?.title?.main), 1),
                p("p", null, F(i.data.advantages?.text), 1)
              ])), [
                [N(G)]
              ])
            ]),
            p("div", ca, [
              p("div", ua, [
                (x(!0), E(H, null, q(i.data.advantages?.advantages, (d, c) => (x(), E("div", {
                  class: "etx-flex__item Flex__item",
                  key: "advantage-" + c
                }, [
                  V((x(), E("div", fa, [
                    p("ul", null, [
                      p("li", null, F(d), 1)
                    ])
                  ])), [
                    [N(G)]
                  ])
                ]))), 128))
              ])
            ])
          ])
        ])
      ], 2)) : D("", !0)
    ], 64));
  }
}), pa = { class: "etx-card Card has-shadow has-hover move-up TeaserCard" }, ha = { class: "etx-card__item Card__item ph-0 pv-0" }, ma = { class: "etx-media Media" }, ga = ["src"], va = { class: "etx-card__item Card__item pb-0 grow-1" }, wa = { class: "TagList" }, ya = { class: "etx-card__item Card__item pt-200 pb-150 grow-1" }, ba = { class: "etx-text Text" }, _a = {
  key: 0,
  class: "font-size-smaller font-color-medium"
}, Sa = { class: "font-size-larger" }, xa = { class: "font-weight-bold" }, Ta = { class: "font-color-medium" }, vs = /* @__PURE__ */ ee({
  __name: "TeaserCardComponent",
  props: {
    url: {},
    id: {},
    image: {},
    tags: {},
    title: {}
  },
  setup(t) {
    const e = t, s = se(e);
    return (i, n) => V((x(), E("div", pa, [
      n[1] || (n[1] = p("a", {
        class: "etx-card__link Card__link",
        title: ""
      }, null, -1)),
      p("div", ha, [
        p("div", ma, [
          p("picture", null, [
            p("img", {
              src: s.image.url,
              loading: "eager"
            }, null, 8, ga)
          ])
        ])
      ]),
      p("div", va, [
        p("div", wa, [
          (x(!0), E(H, null, q(e.tags, (r, o) => (x(), De(Pt, {
            key: "teaser-card-card" + o,
            text: r
          }, null, 8, ["text"]))), 128))
        ])
      ]),
      p("div", ya, [
        p("div", ba, [
          e.title.small.length > 0 ? (x(), E("p", _a, F(e.title.small), 1)) : D("", !0),
          p("p", Sa, [
            p("span", xa, F(e.title.main), 1),
            n[0] || (n[0] = p("br", null, null, -1)),
            p("span", Ta, F(e.title.sub), 1)
          ])
        ])
      ])
    ])), [
      [N(G)]
    ]);
  }
}), Ea = { class: "etx-flex Flex mob-l:c-2 tab-l:c-3 gv-300 av-stretch TeaserModule" }, Md = /* @__PURE__ */ ee({
  __name: "TeaserListComponent",
  props: {
    dataSource: {}
  },
  emits: ["loadData", "selected"],
  setup(t, { emit: e }) {
    const i = se(t.dataSource), n = e, r = (o) => {
      n("selected", o);
    };
    return (o, a) => (x(), E("div", Ea, [
      (x(!0), E(H, null, q(i.data, (l, d) => (x(), E("div", {
        class: "etx-flex__item Flex__item",
        key: "teaser-card-" + d
      }, [
        fe(vs, {
          id: l.properties.id,
          image: l.properties.image,
          title: l.properties.title,
          tags: l.properties.tags,
          onClick: (c) => r(l)
        }, null, 8, ["id", "image", "title", "tags", "onClick"])
      ]))), 128))
    ]));
  }
}), Ca = ["data-swiper-id"], Pa = { class: "swiper-wrapper Swiper__wrapper" }, Ad = /* @__PURE__ */ ee({
  __name: "TeaserSliderComponent",
  props: {
    dataSource: {},
    pageSize: {},
    loadMore: { type: Boolean },
    id: {}
  },
  emits: ["selected"],
  setup(t, { emit: e }) {
    const s = t, i = se(s.dataSource), n = e, r = (l) => {
      n("selected", l);
    };
    let o;
    const a = () => {
      o = new W(`.Swiper[data-swiper-id="${s.id}"]`, {
        direction: "horizontal",
        spaceBetween: 30,
        loop: !1,
        simulateTouch: !0,
        pagination: {
          enabled: !0,
          el: `.Swiper[data-swiper-id="${s.id}"] .Swiper__controls__pagination`,
          clickable: !0
        },
        breakpoints: {
          0: { slidesPerView: 1 },
          650: { slidesPerView: 2 },
          1200: { slidesPerView: 3 }
        },
        modules: [xe]
      }), window.addEventListener("resize", ve(o));
    };
    return we(() => {
      a();
    }), Ye(() => {
      o && window.removeEventListener("resize", ve(o));
    }), (l, d) => (x(), E("div", {
      class: "swiper Swiper SwiperCards",
      "data-swiper-id": s.id
    }, [
      p("div", Pa, [
        (x(!0), E(H, null, q(i.data, (c, u) => (x(), E("div", {
          key: "teaser-card-" + u,
          class: "swiper-slide Swiper__wrapper__slide"
        }, [
          fe(vs, {
            id: c.properties.id,
            image: c.properties.image,
            title: c.properties.title,
            tags: c.properties.tags,
            onClick: (v) => r(c)
          }, null, 8, ["id", "image", "title", "tags", "onClick"])
        ]))), 128))
      ]),
      d[0] || (d[0] = p("div", { class: "Swiper__controls" }, [
        p("div", { class: "swiper-pagination Swiper__controls__pagination" })
      ], -1))
    ], 8, Ca));
  }
});
var wt = function(t, e) {
  return wt = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(s, i) {
    s.__proto__ = i;
  } || function(s, i) {
    for (var n in i) Object.prototype.hasOwnProperty.call(i, n) && (s[n] = i[n]);
  }, wt(t, e);
};
function ce(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
  wt(t, e);
  function s() {
    this.constructor = t;
  }
  t.prototype = e === null ? Object.create(e) : (s.prototype = e.prototype, new s());
}
function yt(t) {
  var e = typeof Symbol == "function" && Symbol.iterator, s = e && t[e], i = 0;
  if (s) return s.call(t);
  if (t && typeof t.length == "number") return {
    next: function() {
      return t && i >= t.length && (t = void 0), { value: t && t[i++], done: !t };
    }
  };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function je(t, e) {
  var s = typeof Symbol == "function" && t[Symbol.iterator];
  if (!s) return t;
  var i = s.call(t), n, r = [], o;
  try {
    for (; (e === void 0 || e-- > 0) && !(n = i.next()).done; ) r.push(n.value);
  } catch (a) {
    o = { error: a };
  } finally {
    try {
      n && !n.done && (s = i.return) && s.call(i);
    } finally {
      if (o) throw o.error;
    }
  }
  return r;
}
function Ue(t, e, s) {
  if (s || arguments.length === 2) for (var i = 0, n = e.length, r; i < n; i++)
    (r || !(i in e)) && (r || (r = Array.prototype.slice.call(e, 0, i)), r[i] = e[i]);
  return t.concat(r || Array.prototype.slice.call(e));
}
function ae(t) {
  return typeof t == "function";
}
function ws(t) {
  var e = function(i) {
    Error.call(i), i.stack = new Error().stack;
  }, s = t(e);
  return s.prototype = Object.create(Error.prototype), s.prototype.constructor = s, s;
}
var ct = ws(function(t) {
  return function(s) {
    t(this), this.message = s ? s.length + ` errors occurred during unsubscription:
` + s.map(function(i, n) {
      return n + 1 + ") " + i.toString();
    }).join(`
  `) : "", this.name = "UnsubscriptionError", this.errors = s;
  };
});
function qe(t, e) {
  if (t) {
    var s = t.indexOf(e);
    0 <= s && t.splice(s, 1);
  }
}
var Ee = function() {
  function t(e) {
    this.initialTeardown = e, this.closed = !1, this._parentage = null, this._finalizers = null;
  }
  return t.prototype.unsubscribe = function() {
    var e, s, i, n, r;
    if (!this.closed) {
      this.closed = !0;
      var o = this._parentage;
      if (o)
        if (this._parentage = null, Array.isArray(o))
          try {
            for (var a = yt(o), l = a.next(); !l.done; l = a.next()) {
              var d = l.value;
              d.remove(this);
            }
          } catch (w) {
            e = { error: w };
          } finally {
            try {
              l && !l.done && (s = a.return) && s.call(a);
            } finally {
              if (e) throw e.error;
            }
          }
        else
          o.remove(this);
      var c = this.initialTeardown;
      if (ae(c))
        try {
          c();
        } catch (w) {
          r = w instanceof ct ? w.errors : [w];
        }
      var u = this._finalizers;
      if (u) {
        this._finalizers = null;
        try {
          for (var v = yt(u), g = v.next(); !g.done; g = v.next()) {
            var m = g.value;
            try {
              Ht(m);
            } catch (w) {
              r = r ?? [], w instanceof ct ? r = Ue(Ue([], je(r)), je(w.errors)) : r.push(w);
            }
          }
        } catch (w) {
          i = { error: w };
        } finally {
          try {
            g && !g.done && (n = v.return) && n.call(v);
          } finally {
            if (i) throw i.error;
          }
        }
      }
      if (r)
        throw new ct(r);
    }
  }, t.prototype.add = function(e) {
    var s;
    if (e && e !== this)
      if (this.closed)
        Ht(e);
      else {
        if (e instanceof t) {
          if (e.closed || e._hasParent(this))
            return;
          e._addParent(this);
        }
        (this._finalizers = (s = this._finalizers) !== null && s !== void 0 ? s : []).push(e);
      }
  }, t.prototype._hasParent = function(e) {
    var s = this._parentage;
    return s === e || Array.isArray(s) && s.includes(e);
  }, t.prototype._addParent = function(e) {
    var s = this._parentage;
    this._parentage = Array.isArray(s) ? (s.push(e), s) : s ? [s, e] : e;
  }, t.prototype._removeParent = function(e) {
    var s = this._parentage;
    s === e ? this._parentage = null : Array.isArray(s) && qe(s, e);
  }, t.prototype.remove = function(e) {
    var s = this._finalizers;
    s && qe(s, e), e instanceof t && e._removeParent(this);
  }, t.EMPTY = function() {
    var e = new t();
    return e.closed = !0, e;
  }(), t;
}(), ys = Ee.EMPTY;
function bs(t) {
  return t instanceof Ee || t && "closed" in t && ae(t.remove) && ae(t.add) && ae(t.unsubscribe);
}
function Ht(t) {
  ae(t) ? t() : t.unsubscribe();
}
var Oa = {
  onUnhandledError: null,
  onStoppedNotification: null,
  Promise: void 0,
  useDeprecatedSynchronousErrorHandling: !1,
  useDeprecatedNextContext: !1
}, La = {
  setTimeout: function(t, e) {
    for (var s = [], i = 2; i < arguments.length; i++)
      s[i - 2] = arguments[i];
    return setTimeout.apply(void 0, Ue([t, e], je(s)));
  },
  clearTimeout: function(t) {
    return clearTimeout(t);
  },
  delegate: void 0
};
function Ma(t) {
  La.setTimeout(function() {
    throw t;
  });
}
function Vt() {
}
function Re(t) {
  t();
}
var Lt = function(t) {
  ce(e, t);
  function e(s) {
    var i = t.call(this) || this;
    return i.isStopped = !1, s ? (i.destination = s, bs(s) && s.add(i)) : i.destination = Ia, i;
  }
  return e.create = function(s, i, n) {
    return new bt(s, i, n);
  }, e.prototype.next = function(s) {
    this.isStopped || this._next(s);
  }, e.prototype.error = function(s) {
    this.isStopped || (this.isStopped = !0, this._error(s));
  }, e.prototype.complete = function() {
    this.isStopped || (this.isStopped = !0, this._complete());
  }, e.prototype.unsubscribe = function() {
    this.closed || (this.isStopped = !0, t.prototype.unsubscribe.call(this), this.destination = null);
  }, e.prototype._next = function(s) {
    this.destination.next(s);
  }, e.prototype._error = function(s) {
    try {
      this.destination.error(s);
    } finally {
      this.unsubscribe();
    }
  }, e.prototype._complete = function() {
    try {
      this.destination.complete();
    } finally {
      this.unsubscribe();
    }
  }, e;
}(Ee), Aa = function() {
  function t(e) {
    this.partialObserver = e;
  }
  return t.prototype.next = function(e) {
    var s = this.partialObserver;
    if (s.next)
      try {
        s.next(e);
      } catch (i) {
        ke(i);
      }
  }, t.prototype.error = function(e) {
    var s = this.partialObserver;
    if (s.error)
      try {
        s.error(e);
      } catch (i) {
        ke(i);
      }
    else
      ke(e);
  }, t.prototype.complete = function() {
    var e = this.partialObserver;
    if (e.complete)
      try {
        e.complete();
      } catch (s) {
        ke(s);
      }
  }, t;
}(), bt = function(t) {
  ce(e, t);
  function e(s, i, n) {
    var r = t.call(this) || this, o;
    return ae(s) || !s ? o = {
      next: s ?? void 0,
      error: i ?? void 0,
      complete: n ?? void 0
    } : o = s, r.destination = new Aa(o), r;
  }
  return e;
}(Lt);
function ke(t) {
  Ma(t);
}
function ka(t) {
  throw t;
}
var Ia = {
  closed: !0,
  next: Vt,
  error: ka,
  complete: Vt
}, $a = function() {
  return typeof Symbol == "function" && Symbol.observable || "@@observable";
}();
function Ra(t) {
  return t;
}
function Fa(t) {
  return t.length === 0 ? Ra : t.length === 1 ? t[0] : function(s) {
    return t.reduce(function(i, n) {
      return n(i);
    }, s);
  };
}
var Gt = function() {
  function t(e) {
    e && (this._subscribe = e);
  }
  return t.prototype.lift = function(e) {
    var s = new t();
    return s.source = this, s.operator = e, s;
  }, t.prototype.subscribe = function(e, s, i) {
    var n = this, r = za(e) ? e : new bt(e, s, i);
    return Re(function() {
      var o = n, a = o.operator, l = o.source;
      r.add(a ? a.call(r, l) : l ? n._subscribe(r) : n._trySubscribe(r));
    }), r;
  }, t.prototype._trySubscribe = function(e) {
    try {
      return this._subscribe(e);
    } catch (s) {
      e.error(s);
    }
  }, t.prototype.forEach = function(e, s) {
    var i = this;
    return s = jt(s), new s(function(n, r) {
      var o = new bt({
        next: function(a) {
          try {
            e(a);
          } catch (l) {
            r(l), o.unsubscribe();
          }
        },
        error: r,
        complete: n
      });
      i.subscribe(o);
    });
  }, t.prototype._subscribe = function(e) {
    var s;
    return (s = this.source) === null || s === void 0 ? void 0 : s.subscribe(e);
  }, t.prototype[$a] = function() {
    return this;
  }, t.prototype.pipe = function() {
    for (var e = [], s = 0; s < arguments.length; s++)
      e[s] = arguments[s];
    return Fa(e)(this);
  }, t.prototype.toPromise = function(e) {
    var s = this;
    return e = jt(e), new e(function(i, n) {
      var r;
      s.subscribe(function(o) {
        return r = o;
      }, function(o) {
        return n(o);
      }, function() {
        return i(r);
      });
    });
  }, t.create = function(e) {
    return new t(e);
  }, t;
}();
function jt(t) {
  var e;
  return (e = t ?? Oa.Promise) !== null && e !== void 0 ? e : Promise;
}
function Ba(t) {
  return t && ae(t.next) && ae(t.error) && ae(t.complete);
}
function za(t) {
  return t && t instanceof Lt || Ba(t) && bs(t);
}
function Da(t) {
  return ae(t?.lift);
}
function Na(t) {
  return function(e) {
    if (Da(e))
      return e.lift(function(s) {
        try {
          return t(s, this);
        } catch (i) {
          this.error(i);
        }
      });
    throw new TypeError("Unable to lift unknown Observable type");
  };
}
function Ha(t, e, s, i, n) {
  return new Va(t, e, s, i, n);
}
var Va = function(t) {
  ce(e, t);
  function e(s, i, n, r, o, a) {
    var l = t.call(this, s) || this;
    return l.onFinalize = o, l.shouldUnsubscribe = a, l._next = i ? function(d) {
      try {
        i(d);
      } catch (c) {
        s.error(c);
      }
    } : t.prototype._next, l._error = r ? function(d) {
      try {
        r(d);
      } catch (c) {
        s.error(c);
      } finally {
        this.unsubscribe();
      }
    } : t.prototype._error, l._complete = n ? function() {
      try {
        n();
      } catch (d) {
        s.error(d);
      } finally {
        this.unsubscribe();
      }
    } : t.prototype._complete, l;
  }
  return e.prototype.unsubscribe = function() {
    var s;
    if (!this.shouldUnsubscribe || this.shouldUnsubscribe()) {
      var i = this.closed;
      t.prototype.unsubscribe.call(this), !i && ((s = this.onFinalize) === null || s === void 0 || s.call(this));
    }
  }, e;
}(Lt), Ga = ws(function(t) {
  return function() {
    t(this), this.name = "ObjectUnsubscribedError", this.message = "object unsubscribed";
  };
}), _s = function(t) {
  ce(e, t);
  function e() {
    var s = t.call(this) || this;
    return s.closed = !1, s.currentObservers = null, s.observers = [], s.isStopped = !1, s.hasError = !1, s.thrownError = null, s;
  }
  return e.prototype.lift = function(s) {
    var i = new Ut(this, this);
    return i.operator = s, i;
  }, e.prototype._throwIfClosed = function() {
    if (this.closed)
      throw new Ga();
  }, e.prototype.next = function(s) {
    var i = this;
    Re(function() {
      var n, r;
      if (i._throwIfClosed(), !i.isStopped) {
        i.currentObservers || (i.currentObservers = Array.from(i.observers));
        try {
          for (var o = yt(i.currentObservers), a = o.next(); !a.done; a = o.next()) {
            var l = a.value;
            l.next(s);
          }
        } catch (d) {
          n = { error: d };
        } finally {
          try {
            a && !a.done && (r = o.return) && r.call(o);
          } finally {
            if (n) throw n.error;
          }
        }
      }
    });
  }, e.prototype.error = function(s) {
    var i = this;
    Re(function() {
      if (i._throwIfClosed(), !i.isStopped) {
        i.hasError = i.isStopped = !0, i.thrownError = s;
        for (var n = i.observers; n.length; )
          n.shift().error(s);
      }
    });
  }, e.prototype.complete = function() {
    var s = this;
    Re(function() {
      if (s._throwIfClosed(), !s.isStopped) {
        s.isStopped = !0;
        for (var i = s.observers; i.length; )
          i.shift().complete();
      }
    });
  }, e.prototype.unsubscribe = function() {
    this.isStopped = this.closed = !0, this.observers = this.currentObservers = null;
  }, Object.defineProperty(e.prototype, "observed", {
    get: function() {
      var s;
      return ((s = this.observers) === null || s === void 0 ? void 0 : s.length) > 0;
    },
    enumerable: !1,
    configurable: !0
  }), e.prototype._trySubscribe = function(s) {
    return this._throwIfClosed(), t.prototype._trySubscribe.call(this, s);
  }, e.prototype._subscribe = function(s) {
    return this._throwIfClosed(), this._checkFinalizedStatuses(s), this._innerSubscribe(s);
  }, e.prototype._innerSubscribe = function(s) {
    var i = this, n = this, r = n.hasError, o = n.isStopped, a = n.observers;
    return r || o ? ys : (this.currentObservers = null, a.push(s), new Ee(function() {
      i.currentObservers = null, qe(a, s);
    }));
  }, e.prototype._checkFinalizedStatuses = function(s) {
    var i = this, n = i.hasError, r = i.thrownError, o = i.isStopped;
    n ? s.error(r) : o && s.complete();
  }, e.prototype.asObservable = function() {
    var s = new Gt();
    return s.source = this, s;
  }, e.create = function(s, i) {
    return new Ut(s, i);
  }, e;
}(Gt), Ut = function(t) {
  ce(e, t);
  function e(s, i) {
    var n = t.call(this) || this;
    return n.destination = s, n.source = i, n;
  }
  return e.prototype.next = function(s) {
    var i, n;
    (n = (i = this.destination) === null || i === void 0 ? void 0 : i.next) === null || n === void 0 || n.call(i, s);
  }, e.prototype.error = function(s) {
    var i, n;
    (n = (i = this.destination) === null || i === void 0 ? void 0 : i.error) === null || n === void 0 || n.call(i, s);
  }, e.prototype.complete = function() {
    var s, i;
    (i = (s = this.destination) === null || s === void 0 ? void 0 : s.complete) === null || i === void 0 || i.call(s);
  }, e.prototype._subscribe = function(s) {
    var i, n;
    return (n = (i = this.source) === null || i === void 0 ? void 0 : i.subscribe(s)) !== null && n !== void 0 ? n : ys;
  }, e;
}(_s), ja = {
  now: function() {
    return Date.now();
  },
  delegate: void 0
}, Ua = function(t) {
  ce(e, t);
  function e(s, i) {
    return t.call(this) || this;
  }
  return e.prototype.schedule = function(s, i) {
    return this;
  }, e;
}(Ee), qt = {
  setInterval: function(t, e) {
    for (var s = [], i = 2; i < arguments.length; i++)
      s[i - 2] = arguments[i];
    return setInterval.apply(void 0, Ue([t, e], je(s)));
  },
  clearInterval: function(t) {
    return clearInterval(t);
  },
  delegate: void 0
}, qa = function(t) {
  ce(e, t);
  function e(s, i) {
    var n = t.call(this, s, i) || this;
    return n.scheduler = s, n.work = i, n.pending = !1, n;
  }
  return e.prototype.schedule = function(s, i) {
    var n;
    if (i === void 0 && (i = 0), this.closed)
      return this;
    this.state = s;
    var r = this.id, o = this.scheduler;
    return r != null && (this.id = this.recycleAsyncId(o, r, i)), this.pending = !0, this.delay = i, this.id = (n = this.id) !== null && n !== void 0 ? n : this.requestAsyncId(o, this.id, i), this;
  }, e.prototype.requestAsyncId = function(s, i, n) {
    return n === void 0 && (n = 0), qt.setInterval(s.flush.bind(s, this), n);
  }, e.prototype.recycleAsyncId = function(s, i, n) {
    if (n === void 0 && (n = 0), n != null && this.delay === n && this.pending === !1)
      return i;
    i != null && qt.clearInterval(i);
  }, e.prototype.execute = function(s, i) {
    if (this.closed)
      return new Error("executing a cancelled action");
    this.pending = !1;
    var n = this._execute(s, i);
    if (n)
      return n;
    this.pending === !1 && this.id != null && (this.id = this.recycleAsyncId(this.scheduler, this.id, null));
  }, e.prototype._execute = function(s, i) {
    var n = !1, r;
    try {
      this.work(s);
    } catch (o) {
      n = !0, r = o || new Error("Scheduled action threw falsy error");
    }
    if (n)
      return this.unsubscribe(), r;
  }, e.prototype.unsubscribe = function() {
    if (!this.closed) {
      var s = this, i = s.id, n = s.scheduler, r = n.actions;
      this.work = this.state = this.scheduler = null, this.pending = !1, qe(r, this), i != null && (this.id = this.recycleAsyncId(n, i, null)), this.delay = null, t.prototype.unsubscribe.call(this);
    }
  }, e;
}(Ua), Wt = function() {
  function t(e, s) {
    s === void 0 && (s = t.now), this.schedulerActionCtor = e, this.now = s;
  }
  return t.prototype.schedule = function(e, s, i) {
    return s === void 0 && (s = 0), new this.schedulerActionCtor(this, e).schedule(i, s);
  }, t.now = ja.now, t;
}(), Wa = function(t) {
  ce(e, t);
  function e(s, i) {
    i === void 0 && (i = Wt.now);
    var n = t.call(this, s, i) || this;
    return n.actions = [], n._active = !1, n;
  }
  return e.prototype.flush = function(s) {
    var i = this.actions;
    if (this._active) {
      i.push(s);
      return;
    }
    var n;
    this._active = !0;
    do
      if (n = s.execute(s.state, s.delay))
        break;
    while (s = i.shift());
    if (this._active = !1, n) {
      for (; s = i.shift(); )
        s.unsubscribe();
      throw n;
    }
  }, e;
}(Wt), Xa = new Wa(qa);
function Ya(t, e) {
  return e === void 0 && (e = Xa), Na(function(s, i) {
    var n = null, r = null, o = null, a = function() {
      if (n) {
        n.unsubscribe(), n = null;
        var d = r;
        r = null, i.next(d);
      }
    };
    function l() {
      var d = o + t, c = e.now();
      if (c < d) {
        n = this.schedule(void 0, d - c), i.add(n);
        return;
      }
      a();
    }
    s.subscribe(Ha(i, function(d) {
      r = d, o = e.now(), n || (n = e.schedule(l, t), i.add(n));
    }, function() {
      a(), i.complete();
    }, void 0, function() {
      r = n = null;
    }));
  });
}
class kd {
  constructor(e) {
    this._load = e, this._data = Ie([]), this.activeFilter = {
      pageSize: 5,
      pageIndex: 0
    }, this._loaded$ = new _s(), this.loaded$ = this._loaded$.asObservable().pipe(
      Ya(100)
    );
  }
  get data() {
    return this._data;
  }
  setData(e) {
    this._data.value = e, this._loaded$.next();
  }
  /**
   * Trigger the _load function passed at initialization of this class
   * Passes the filter object into the _load method
   * Fetches the data from _load method and adds or replaces the data
   * @param filter
   * @param mode
   * @returns
   */
  load(e, s) {
    return new Promise((i) => {
      const n = {
        ...this.activeFilter,
        ...e,
        pageSize: e.pageSize,
        pageIndex: e.pageIndex ?? this.activeFilter.pageIndex
      };
      this._load(n).then((r) => {
        s === "overwrite" ? this._data.value = r : this._data.value = [
          ...this._data?.value ?? [],
          ...r ?? []
        ], this.activeFilter = n, this.activeFilter.pageIndex = (e?.pageIndex ?? this.activeFilter?.pageIndex ?? 0) + 1, i(), this._loaded$.next();
      });
    });
  }
}
function Ss(t, e) {
  return function() {
    return t.apply(e, arguments);
  };
}
const { toString: Ja } = Object.prototype, { getPrototypeOf: Mt } = Object, Je = /* @__PURE__ */ ((t) => (e) => {
  const s = Ja.call(e);
  return t[s] || (t[s] = s.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), ie = (t) => (t = t.toLowerCase(), (e) => Je(e) === t), Ke = (t) => (e) => typeof e === t, { isArray: ye } = Array, Te = Ke("undefined");
function Ka(t) {
  return t !== null && !Te(t) && t.constructor !== null && !Te(t.constructor) && Q(t.constructor.isBuffer) && t.constructor.isBuffer(t);
}
const xs = ie("ArrayBuffer");
function Za(t) {
  let e;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? e = ArrayBuffer.isView(t) : e = t && t.buffer && xs(t.buffer), e;
}
const Qa = Ke("string"), Q = Ke("function"), Ts = Ke("number"), Ze = (t) => t !== null && typeof t == "object", el = (t) => t === !0 || t === !1, Fe = (t) => {
  if (Je(t) !== "object")
    return !1;
  const e = Mt(t);
  return (e === null || e === Object.prototype || Object.getPrototypeOf(e) === null) && !(Symbol.toStringTag in t) && !(Symbol.iterator in t);
}, tl = ie("Date"), sl = ie("File"), il = ie("Blob"), nl = ie("FileList"), rl = (t) => Ze(t) && Q(t.pipe), ol = (t) => {
  let e;
  return t && (typeof FormData == "function" && t instanceof FormData || Q(t.append) && ((e = Je(t)) === "formdata" || // detect form-data instance
  e === "object" && Q(t.toString) && t.toString() === "[object FormData]"));
}, al = ie("URLSearchParams"), [ll, dl, cl, ul] = ["ReadableStream", "Request", "Response", "Headers"].map(ie), fl = (t) => t.trim ? t.trim() : t.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function Ce(t, e, { allOwnKeys: s = !1 } = {}) {
  if (t === null || typeof t > "u")
    return;
  let i, n;
  if (typeof t != "object" && (t = [t]), ye(t))
    for (i = 0, n = t.length; i < n; i++)
      e.call(null, t[i], i, t);
  else {
    const r = s ? Object.getOwnPropertyNames(t) : Object.keys(t), o = r.length;
    let a;
    for (i = 0; i < o; i++)
      a = r[i], e.call(null, t[a], a, t);
  }
}
function Es(t, e) {
  e = e.toLowerCase();
  const s = Object.keys(t);
  let i = s.length, n;
  for (; i-- > 0; )
    if (n = s[i], e === n.toLowerCase())
      return n;
  return null;
}
const pe = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, Cs = (t) => !Te(t) && t !== pe;
function _t() {
  const { caseless: t } = Cs(this) && this || {}, e = {}, s = (i, n) => {
    const r = t && Es(e, n) || n;
    Fe(e[r]) && Fe(i) ? e[r] = _t(e[r], i) : Fe(i) ? e[r] = _t({}, i) : ye(i) ? e[r] = i.slice() : e[r] = i;
  };
  for (let i = 0, n = arguments.length; i < n; i++)
    arguments[i] && Ce(arguments[i], s);
  return e;
}
const pl = (t, e, s, { allOwnKeys: i } = {}) => (Ce(e, (n, r) => {
  s && Q(n) ? t[r] = Ss(n, s) : t[r] = n;
}, { allOwnKeys: i }), t), hl = (t) => (t.charCodeAt(0) === 65279 && (t = t.slice(1)), t), ml = (t, e, s, i) => {
  t.prototype = Object.create(e.prototype, i), t.prototype.constructor = t, Object.defineProperty(t, "super", {
    value: e.prototype
  }), s && Object.assign(t.prototype, s);
}, gl = (t, e, s, i) => {
  let n, r, o;
  const a = {};
  if (e = e || {}, t == null) return e;
  do {
    for (n = Object.getOwnPropertyNames(t), r = n.length; r-- > 0; )
      o = n[r], (!i || i(o, t, e)) && !a[o] && (e[o] = t[o], a[o] = !0);
    t = s !== !1 && Mt(t);
  } while (t && (!s || s(t, e)) && t !== Object.prototype);
  return e;
}, vl = (t, e, s) => {
  t = String(t), (s === void 0 || s > t.length) && (s = t.length), s -= e.length;
  const i = t.indexOf(e, s);
  return i !== -1 && i === s;
}, wl = (t) => {
  if (!t) return null;
  if (ye(t)) return t;
  let e = t.length;
  if (!Ts(e)) return null;
  const s = new Array(e);
  for (; e-- > 0; )
    s[e] = t[e];
  return s;
}, yl = /* @__PURE__ */ ((t) => (e) => t && e instanceof t)(typeof Uint8Array < "u" && Mt(Uint8Array)), bl = (t, e) => {
  const i = (t && t[Symbol.iterator]).call(t);
  let n;
  for (; (n = i.next()) && !n.done; ) {
    const r = n.value;
    e.call(t, r[0], r[1]);
  }
}, _l = (t, e) => {
  let s;
  const i = [];
  for (; (s = t.exec(e)) !== null; )
    i.push(s);
  return i;
}, Sl = ie("HTMLFormElement"), xl = (t) => t.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(s, i, n) {
    return i.toUpperCase() + n;
  }
), Xt = (({ hasOwnProperty: t }) => (e, s) => t.call(e, s))(Object.prototype), Tl = ie("RegExp"), Ps = (t, e) => {
  const s = Object.getOwnPropertyDescriptors(t), i = {};
  Ce(s, (n, r) => {
    let o;
    (o = e(n, r, t)) !== !1 && (i[r] = o || n);
  }), Object.defineProperties(t, i);
}, El = (t) => {
  Ps(t, (e, s) => {
    if (Q(t) && ["arguments", "caller", "callee"].indexOf(s) !== -1)
      return !1;
    const i = t[s];
    if (Q(i)) {
      if (e.enumerable = !1, "writable" in e) {
        e.writable = !1;
        return;
      }
      e.set || (e.set = () => {
        throw Error("Can not rewrite read-only method '" + s + "'");
      });
    }
  });
}, Cl = (t, e) => {
  const s = {}, i = (n) => {
    n.forEach((r) => {
      s[r] = !0;
    });
  };
  return ye(t) ? i(t) : i(String(t).split(e)), s;
}, Pl = () => {
}, Ol = (t, e) => t != null && Number.isFinite(t = +t) ? t : e, ut = "abcdefghijklmnopqrstuvwxyz", Yt = "0123456789", Os = {
  DIGIT: Yt,
  ALPHA: ut,
  ALPHA_DIGIT: ut + ut.toUpperCase() + Yt
}, Ll = (t = 16, e = Os.ALPHA_DIGIT) => {
  let s = "";
  const { length: i } = e;
  for (; t--; )
    s += e[Math.random() * i | 0];
  return s;
};
function Ml(t) {
  return !!(t && Q(t.append) && t[Symbol.toStringTag] === "FormData" && t[Symbol.iterator]);
}
const Al = (t) => {
  const e = new Array(10), s = (i, n) => {
    if (Ze(i)) {
      if (e.indexOf(i) >= 0)
        return;
      if (!("toJSON" in i)) {
        e[n] = i;
        const r = ye(i) ? [] : {};
        return Ce(i, (o, a) => {
          const l = s(o, n + 1);
          !Te(l) && (r[a] = l);
        }), e[n] = void 0, r;
      }
    }
    return i;
  };
  return s(t, 0);
}, kl = ie("AsyncFunction"), Il = (t) => t && (Ze(t) || Q(t)) && Q(t.then) && Q(t.catch), Ls = ((t, e) => t ? setImmediate : e ? ((s, i) => (pe.addEventListener("message", ({ source: n, data: r }) => {
  n === pe && r === s && i.length && i.shift()();
}, !1), (n) => {
  i.push(n), pe.postMessage(s, "*");
}))(`axios@${Math.random()}`, []) : (s) => setTimeout(s))(
  typeof setImmediate == "function",
  Q(pe.postMessage)
), $l = typeof queueMicrotask < "u" ? queueMicrotask.bind(pe) : typeof process < "u" && process.nextTick || Ls, y = {
  isArray: ye,
  isArrayBuffer: xs,
  isBuffer: Ka,
  isFormData: ol,
  isArrayBufferView: Za,
  isString: Qa,
  isNumber: Ts,
  isBoolean: el,
  isObject: Ze,
  isPlainObject: Fe,
  isReadableStream: ll,
  isRequest: dl,
  isResponse: cl,
  isHeaders: ul,
  isUndefined: Te,
  isDate: tl,
  isFile: sl,
  isBlob: il,
  isRegExp: Tl,
  isFunction: Q,
  isStream: rl,
  isURLSearchParams: al,
  isTypedArray: yl,
  isFileList: nl,
  forEach: Ce,
  merge: _t,
  extend: pl,
  trim: fl,
  stripBOM: hl,
  inherits: ml,
  toFlatObject: gl,
  kindOf: Je,
  kindOfTest: ie,
  endsWith: vl,
  toArray: wl,
  forEachEntry: bl,
  matchAll: _l,
  isHTMLForm: Sl,
  hasOwnProperty: Xt,
  hasOwnProp: Xt,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: Ps,
  freezeMethods: El,
  toObjectSet: Cl,
  toCamelCase: xl,
  noop: Pl,
  toFiniteNumber: Ol,
  findKey: Es,
  global: pe,
  isContextDefined: Cs,
  ALPHABET: Os,
  generateString: Ll,
  isSpecCompliantForm: Ml,
  toJSONObject: Al,
  isAsyncFn: kl,
  isThenable: Il,
  setImmediate: Ls,
  asap: $l
};
function $(t, e, s, i, n) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = t, this.name = "AxiosError", e && (this.code = e), s && (this.config = s), i && (this.request = i), n && (this.response = n, this.status = n.status ? n.status : null);
}
y.inherits($, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: y.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
});
const Ms = $.prototype, As = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((t) => {
  As[t] = { value: t };
});
Object.defineProperties($, As);
Object.defineProperty(Ms, "isAxiosError", { value: !0 });
$.from = (t, e, s, i, n, r) => {
  const o = Object.create(Ms);
  return y.toFlatObject(t, o, function(l) {
    return l !== Error.prototype;
  }, (a) => a !== "isAxiosError"), $.call(o, t.message, e, s, i, n), o.cause = t, o.name = t.name, r && Object.assign(o, r), o;
};
const Rl = null;
function St(t) {
  return y.isPlainObject(t) || y.isArray(t);
}
function ks(t) {
  return y.endsWith(t, "[]") ? t.slice(0, -2) : t;
}
function Jt(t, e, s) {
  return t ? t.concat(e).map(function(n, r) {
    return n = ks(n), !s && r ? "[" + n + "]" : n;
  }).join(s ? "." : "") : e;
}
function Fl(t) {
  return y.isArray(t) && !t.some(St);
}
const Bl = y.toFlatObject(y, {}, null, function(e) {
  return /^is[A-Z]/.test(e);
});
function Qe(t, e, s) {
  if (!y.isObject(t))
    throw new TypeError("target must be an object");
  e = e || new FormData(), s = y.toFlatObject(s, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(w, b) {
    return !y.isUndefined(b[w]);
  });
  const i = s.metaTokens, n = s.visitor || c, r = s.dots, o = s.indexes, l = (s.Blob || typeof Blob < "u" && Blob) && y.isSpecCompliantForm(e);
  if (!y.isFunction(n))
    throw new TypeError("visitor must be a function");
  function d(m) {
    if (m === null) return "";
    if (y.isDate(m))
      return m.toISOString();
    if (!l && y.isBlob(m))
      throw new $("Blob is not supported. Use a Buffer instead.");
    return y.isArrayBuffer(m) || y.isTypedArray(m) ? l && typeof Blob == "function" ? new Blob([m]) : Buffer.from(m) : m;
  }
  function c(m, w, b) {
    let S = m;
    if (m && !b && typeof m == "object") {
      if (y.endsWith(w, "{}"))
        w = i ? w : w.slice(0, -2), m = JSON.stringify(m);
      else if (y.isArray(m) && Fl(m) || (y.isFileList(m) || y.endsWith(w, "[]")) && (S = y.toArray(m)))
        return w = ks(w), S.forEach(function(h, _) {
          !(y.isUndefined(h) || h === null) && e.append(
            // eslint-disable-next-line no-nested-ternary
            o === !0 ? Jt([w], _, r) : o === null ? w : w + "[]",
            d(h)
          );
        }), !1;
    }
    return St(m) ? !0 : (e.append(Jt(b, w, r), d(m)), !1);
  }
  const u = [], v = Object.assign(Bl, {
    defaultVisitor: c,
    convertValue: d,
    isVisitable: St
  });
  function g(m, w) {
    if (!y.isUndefined(m)) {
      if (u.indexOf(m) !== -1)
        throw Error("Circular reference detected in " + w.join("."));
      u.push(m), y.forEach(m, function(S, f) {
        (!(y.isUndefined(S) || S === null) && n.call(
          e,
          S,
          y.isString(f) ? f.trim() : f,
          w,
          v
        )) === !0 && g(S, w ? w.concat(f) : [f]);
      }), u.pop();
    }
  }
  if (!y.isObject(t))
    throw new TypeError("data must be an object");
  return g(t), e;
}
function Kt(t) {
  const e = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(t).replace(/[!'()~]|%20|%00/g, function(i) {
    return e[i];
  });
}
function At(t, e) {
  this._pairs = [], t && Qe(t, this, e);
}
const Is = At.prototype;
Is.append = function(e, s) {
  this._pairs.push([e, s]);
};
Is.toString = function(e) {
  const s = e ? function(i) {
    return e.call(this, i, Kt);
  } : Kt;
  return this._pairs.map(function(n) {
    return s(n[0]) + "=" + s(n[1]);
  }, "").join("&");
};
function zl(t) {
  return encodeURIComponent(t).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function $s(t, e, s) {
  if (!e)
    return t;
  const i = s && s.encode || zl;
  y.isFunction(s) && (s = {
    serialize: s
  });
  const n = s && s.serialize;
  let r;
  if (n ? r = n(e, s) : r = y.isURLSearchParams(e) ? e.toString() : new At(e, s).toString(i), r) {
    const o = t.indexOf("#");
    o !== -1 && (t = t.slice(0, o)), t += (t.indexOf("?") === -1 ? "?" : "&") + r;
  }
  return t;
}
class Zt {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(e, s, i) {
    return this.handlers.push({
      fulfilled: e,
      rejected: s,
      synchronous: i ? i.synchronous : !1,
      runWhen: i ? i.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(e) {
    this.handlers[e] && (this.handlers[e] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(e) {
    y.forEach(this.handlers, function(i) {
      i !== null && e(i);
    });
  }
}
const Rs = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, Dl = typeof URLSearchParams < "u" ? URLSearchParams : At, Nl = typeof FormData < "u" ? FormData : null, Hl = typeof Blob < "u" ? Blob : null, Vl = {
  isBrowser: !0,
  classes: {
    URLSearchParams: Dl,
    FormData: Nl,
    Blob: Hl
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, kt = typeof window < "u" && typeof document < "u", xt = typeof navigator == "object" && navigator || void 0, Gl = kt && (!xt || ["ReactNative", "NativeScript", "NS"].indexOf(xt.product) < 0), jl = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", Ul = kt && window.location.href || "http://localhost", ql = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: kt,
  hasStandardBrowserEnv: Gl,
  hasStandardBrowserWebWorkerEnv: jl,
  navigator: xt,
  origin: Ul
}, Symbol.toStringTag, { value: "Module" })), X = {
  ...ql,
  ...Vl
};
function Wl(t, e) {
  return Qe(t, new X.classes.URLSearchParams(), Object.assign({
    visitor: function(s, i, n, r) {
      return X.isNode && y.isBuffer(s) ? (this.append(i, s.toString("base64")), !1) : r.defaultVisitor.apply(this, arguments);
    }
  }, e));
}
function Xl(t) {
  return y.matchAll(/\w+|\[(\w*)]/g, t).map((e) => e[0] === "[]" ? "" : e[1] || e[0]);
}
function Yl(t) {
  const e = {}, s = Object.keys(t);
  let i;
  const n = s.length;
  let r;
  for (i = 0; i < n; i++)
    r = s[i], e[r] = t[r];
  return e;
}
function Fs(t) {
  function e(s, i, n, r) {
    let o = s[r++];
    if (o === "__proto__") return !0;
    const a = Number.isFinite(+o), l = r >= s.length;
    return o = !o && y.isArray(n) ? n.length : o, l ? (y.hasOwnProp(n, o) ? n[o] = [n[o], i] : n[o] = i, !a) : ((!n[o] || !y.isObject(n[o])) && (n[o] = []), e(s, i, n[o], r) && y.isArray(n[o]) && (n[o] = Yl(n[o])), !a);
  }
  if (y.isFormData(t) && y.isFunction(t.entries)) {
    const s = {};
    return y.forEachEntry(t, (i, n) => {
      e(Xl(i), n, s, 0);
    }), s;
  }
  return null;
}
function Jl(t, e, s) {
  if (y.isString(t))
    try {
      return (e || JSON.parse)(t), y.trim(t);
    } catch (i) {
      if (i.name !== "SyntaxError")
        throw i;
    }
  return (0, JSON.stringify)(t);
}
const Pe = {
  transitional: Rs,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(e, s) {
    const i = s.getContentType() || "", n = i.indexOf("application/json") > -1, r = y.isObject(e);
    if (r && y.isHTMLForm(e) && (e = new FormData(e)), y.isFormData(e))
      return n ? JSON.stringify(Fs(e)) : e;
    if (y.isArrayBuffer(e) || y.isBuffer(e) || y.isStream(e) || y.isFile(e) || y.isBlob(e) || y.isReadableStream(e))
      return e;
    if (y.isArrayBufferView(e))
      return e.buffer;
    if (y.isURLSearchParams(e))
      return s.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), e.toString();
    let a;
    if (r) {
      if (i.indexOf("application/x-www-form-urlencoded") > -1)
        return Wl(e, this.formSerializer).toString();
      if ((a = y.isFileList(e)) || i.indexOf("multipart/form-data") > -1) {
        const l = this.env && this.env.FormData;
        return Qe(
          a ? { "files[]": e } : e,
          l && new l(),
          this.formSerializer
        );
      }
    }
    return r || n ? (s.setContentType("application/json", !1), Jl(e)) : e;
  }],
  transformResponse: [function(e) {
    const s = this.transitional || Pe.transitional, i = s && s.forcedJSONParsing, n = this.responseType === "json";
    if (y.isResponse(e) || y.isReadableStream(e))
      return e;
    if (e && y.isString(e) && (i && !this.responseType || n)) {
      const o = !(s && s.silentJSONParsing) && n;
      try {
        return JSON.parse(e);
      } catch (a) {
        if (o)
          throw a.name === "SyntaxError" ? $.from(a, $.ERR_BAD_RESPONSE, this, null, this.response) : a;
      }
    }
    return e;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: X.classes.FormData,
    Blob: X.classes.Blob
  },
  validateStatus: function(e) {
    return e >= 200 && e < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
y.forEach(["delete", "get", "head", "post", "put", "patch"], (t) => {
  Pe.headers[t] = {};
});
const Kl = y.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), Zl = (t) => {
  const e = {};
  let s, i, n;
  return t && t.split(`
`).forEach(function(o) {
    n = o.indexOf(":"), s = o.substring(0, n).trim().toLowerCase(), i = o.substring(n + 1).trim(), !(!s || e[s] && Kl[s]) && (s === "set-cookie" ? e[s] ? e[s].push(i) : e[s] = [i] : e[s] = e[s] ? e[s] + ", " + i : i);
  }), e;
}, Qt = Symbol("internals");
function Se(t) {
  return t && String(t).trim().toLowerCase();
}
function Be(t) {
  return t === !1 || t == null ? t : y.isArray(t) ? t.map(Be) : String(t);
}
function Ql(t) {
  const e = /* @__PURE__ */ Object.create(null), s = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let i;
  for (; i = s.exec(t); )
    e[i[1]] = i[2];
  return e;
}
const ed = (t) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(t.trim());
function ft(t, e, s, i, n) {
  if (y.isFunction(i))
    return i.call(this, e, s);
  if (n && (e = s), !!y.isString(e)) {
    if (y.isString(i))
      return e.indexOf(i) !== -1;
    if (y.isRegExp(i))
      return i.test(e);
  }
}
function td(t) {
  return t.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (e, s, i) => s.toUpperCase() + i);
}
function sd(t, e) {
  const s = y.toCamelCase(" " + e);
  ["get", "set", "has"].forEach((i) => {
    Object.defineProperty(t, i + s, {
      value: function(n, r, o) {
        return this[i].call(this, e, n, r, o);
      },
      configurable: !0
    });
  });
}
class K {
  constructor(e) {
    e && this.set(e);
  }
  set(e, s, i) {
    const n = this;
    function r(a, l, d) {
      const c = Se(l);
      if (!c)
        throw new Error("header name must be a non-empty string");
      const u = y.findKey(n, c);
      (!u || n[u] === void 0 || d === !0 || d === void 0 && n[u] !== !1) && (n[u || l] = Be(a));
    }
    const o = (a, l) => y.forEach(a, (d, c) => r(d, c, l));
    if (y.isPlainObject(e) || e instanceof this.constructor)
      o(e, s);
    else if (y.isString(e) && (e = e.trim()) && !ed(e))
      o(Zl(e), s);
    else if (y.isHeaders(e))
      for (const [a, l] of e.entries())
        r(l, a, i);
    else
      e != null && r(s, e, i);
    return this;
  }
  get(e, s) {
    if (e = Se(e), e) {
      const i = y.findKey(this, e);
      if (i) {
        const n = this[i];
        if (!s)
          return n;
        if (s === !0)
          return Ql(n);
        if (y.isFunction(s))
          return s.call(this, n, i);
        if (y.isRegExp(s))
          return s.exec(n);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(e, s) {
    if (e = Se(e), e) {
      const i = y.findKey(this, e);
      return !!(i && this[i] !== void 0 && (!s || ft(this, this[i], i, s)));
    }
    return !1;
  }
  delete(e, s) {
    const i = this;
    let n = !1;
    function r(o) {
      if (o = Se(o), o) {
        const a = y.findKey(i, o);
        a && (!s || ft(i, i[a], a, s)) && (delete i[a], n = !0);
      }
    }
    return y.isArray(e) ? e.forEach(r) : r(e), n;
  }
  clear(e) {
    const s = Object.keys(this);
    let i = s.length, n = !1;
    for (; i--; ) {
      const r = s[i];
      (!e || ft(this, this[r], r, e, !0)) && (delete this[r], n = !0);
    }
    return n;
  }
  normalize(e) {
    const s = this, i = {};
    return y.forEach(this, (n, r) => {
      const o = y.findKey(i, r);
      if (o) {
        s[o] = Be(n), delete s[r];
        return;
      }
      const a = e ? td(r) : String(r).trim();
      a !== r && delete s[r], s[a] = Be(n), i[a] = !0;
    }), this;
  }
  concat(...e) {
    return this.constructor.concat(this, ...e);
  }
  toJSON(e) {
    const s = /* @__PURE__ */ Object.create(null);
    return y.forEach(this, (i, n) => {
      i != null && i !== !1 && (s[n] = e && y.isArray(i) ? i.join(", ") : i);
    }), s;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([e, s]) => e + ": " + s).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(e) {
    return e instanceof this ? e : new this(e);
  }
  static concat(e, ...s) {
    const i = new this(e);
    return s.forEach((n) => i.set(n)), i;
  }
  static accessor(e) {
    const i = (this[Qt] = this[Qt] = {
      accessors: {}
    }).accessors, n = this.prototype;
    function r(o) {
      const a = Se(o);
      i[a] || (sd(n, o), i[a] = !0);
    }
    return y.isArray(e) ? e.forEach(r) : r(e), this;
  }
}
K.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
y.reduceDescriptors(K.prototype, ({ value: t }, e) => {
  let s = e[0].toUpperCase() + e.slice(1);
  return {
    get: () => t,
    set(i) {
      this[s] = i;
    }
  };
});
y.freezeMethods(K);
function pt(t, e) {
  const s = this || Pe, i = e || s, n = K.from(i.headers);
  let r = i.data;
  return y.forEach(t, function(a) {
    r = a.call(s, r, n.normalize(), e ? e.status : void 0);
  }), n.normalize(), r;
}
function Bs(t) {
  return !!(t && t.__CANCEL__);
}
function be(t, e, s) {
  $.call(this, t ?? "canceled", $.ERR_CANCELED, e, s), this.name = "CanceledError";
}
y.inherits(be, $, {
  __CANCEL__: !0
});
function zs(t, e, s) {
  const i = s.config.validateStatus;
  !s.status || !i || i(s.status) ? t(s) : e(new $(
    "Request failed with status code " + s.status,
    [$.ERR_BAD_REQUEST, $.ERR_BAD_RESPONSE][Math.floor(s.status / 100) - 4],
    s.config,
    s.request,
    s
  ));
}
function id(t) {
  const e = /^([-+\w]{1,25})(:?\/\/|:)/.exec(t);
  return e && e[1] || "";
}
function nd(t, e) {
  t = t || 10;
  const s = new Array(t), i = new Array(t);
  let n = 0, r = 0, o;
  return e = e !== void 0 ? e : 1e3, function(l) {
    const d = Date.now(), c = i[r];
    o || (o = d), s[n] = l, i[n] = d;
    let u = r, v = 0;
    for (; u !== n; )
      v += s[u++], u = u % t;
    if (n = (n + 1) % t, n === r && (r = (r + 1) % t), d - o < e)
      return;
    const g = c && d - c;
    return g ? Math.round(v * 1e3 / g) : void 0;
  };
}
function rd(t, e) {
  let s = 0, i = 1e3 / e, n, r;
  const o = (d, c = Date.now()) => {
    s = c, n = null, r && (clearTimeout(r), r = null), t.apply(null, d);
  };
  return [(...d) => {
    const c = Date.now(), u = c - s;
    u >= i ? o(d, c) : (n = d, r || (r = setTimeout(() => {
      r = null, o(n);
    }, i - u)));
  }, () => n && o(n)];
}
const We = (t, e, s = 3) => {
  let i = 0;
  const n = nd(50, 250);
  return rd((r) => {
    const o = r.loaded, a = r.lengthComputable ? r.total : void 0, l = o - i, d = n(l), c = o <= a;
    i = o;
    const u = {
      loaded: o,
      total: a,
      progress: a ? o / a : void 0,
      bytes: l,
      rate: d || void 0,
      estimated: d && a && c ? (a - o) / d : void 0,
      event: r,
      lengthComputable: a != null,
      [e ? "download" : "upload"]: !0
    };
    t(u);
  }, s);
}, es = (t, e) => {
  const s = t != null;
  return [(i) => e[0]({
    lengthComputable: s,
    total: t,
    loaded: i
  }), e[1]];
}, ts = (t) => (...e) => y.asap(() => t(...e)), od = X.hasStandardBrowserEnv ? /* @__PURE__ */ ((t, e) => (s) => (s = new URL(s, X.origin), t.protocol === s.protocol && t.host === s.host && (e || t.port === s.port)))(
  new URL(X.origin),
  X.navigator && /(msie|trident)/i.test(X.navigator.userAgent)
) : () => !0, ad = X.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(t, e, s, i, n, r) {
      const o = [t + "=" + encodeURIComponent(e)];
      y.isNumber(s) && o.push("expires=" + new Date(s).toGMTString()), y.isString(i) && o.push("path=" + i), y.isString(n) && o.push("domain=" + n), r === !0 && o.push("secure"), document.cookie = o.join("; ");
    },
    read(t) {
      const e = document.cookie.match(new RegExp("(^|;\\s*)(" + t + ")=([^;]*)"));
      return e ? decodeURIComponent(e[3]) : null;
    },
    remove(t) {
      this.write(t, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function ld(t) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(t);
}
function dd(t, e) {
  return e ? t.replace(/\/?\/$/, "") + "/" + e.replace(/^\/+/, "") : t;
}
function Ds(t, e) {
  return t && !ld(e) ? dd(t, e) : e;
}
const ss = (t) => t instanceof K ? { ...t } : t;
function me(t, e) {
  e = e || {};
  const s = {};
  function i(d, c, u, v) {
    return y.isPlainObject(d) && y.isPlainObject(c) ? y.merge.call({ caseless: v }, d, c) : y.isPlainObject(c) ? y.merge({}, c) : y.isArray(c) ? c.slice() : c;
  }
  function n(d, c, u, v) {
    if (y.isUndefined(c)) {
      if (!y.isUndefined(d))
        return i(void 0, d, u, v);
    } else return i(d, c, u, v);
  }
  function r(d, c) {
    if (!y.isUndefined(c))
      return i(void 0, c);
  }
  function o(d, c) {
    if (y.isUndefined(c)) {
      if (!y.isUndefined(d))
        return i(void 0, d);
    } else return i(void 0, c);
  }
  function a(d, c, u) {
    if (u in e)
      return i(d, c);
    if (u in t)
      return i(void 0, d);
  }
  const l = {
    url: r,
    method: r,
    data: r,
    baseURL: o,
    transformRequest: o,
    transformResponse: o,
    paramsSerializer: o,
    timeout: o,
    timeoutMessage: o,
    withCredentials: o,
    withXSRFToken: o,
    adapter: o,
    responseType: o,
    xsrfCookieName: o,
    xsrfHeaderName: o,
    onUploadProgress: o,
    onDownloadProgress: o,
    decompress: o,
    maxContentLength: o,
    maxBodyLength: o,
    beforeRedirect: o,
    transport: o,
    httpAgent: o,
    httpsAgent: o,
    cancelToken: o,
    socketPath: o,
    responseEncoding: o,
    validateStatus: a,
    headers: (d, c, u) => n(ss(d), ss(c), u, !0)
  };
  return y.forEach(Object.keys(Object.assign({}, t, e)), function(c) {
    const u = l[c] || n, v = u(t[c], e[c], c);
    y.isUndefined(v) && u !== a || (s[c] = v);
  }), s;
}
const Ns = (t) => {
  const e = me({}, t);
  let { data: s, withXSRFToken: i, xsrfHeaderName: n, xsrfCookieName: r, headers: o, auth: a } = e;
  e.headers = o = K.from(o), e.url = $s(Ds(e.baseURL, e.url), t.params, t.paramsSerializer), a && o.set(
    "Authorization",
    "Basic " + btoa((a.username || "") + ":" + (a.password ? unescape(encodeURIComponent(a.password)) : ""))
  );
  let l;
  if (y.isFormData(s)) {
    if (X.hasStandardBrowserEnv || X.hasStandardBrowserWebWorkerEnv)
      o.setContentType(void 0);
    else if ((l = o.getContentType()) !== !1) {
      const [d, ...c] = l ? l.split(";").map((u) => u.trim()).filter(Boolean) : [];
      o.setContentType([d || "multipart/form-data", ...c].join("; "));
    }
  }
  if (X.hasStandardBrowserEnv && (i && y.isFunction(i) && (i = i(e)), i || i !== !1 && od(e.url))) {
    const d = n && r && ad.read(r);
    d && o.set(n, d);
  }
  return e;
}, cd = typeof XMLHttpRequest < "u", ud = cd && function(t) {
  return new Promise(function(s, i) {
    const n = Ns(t);
    let r = n.data;
    const o = K.from(n.headers).normalize();
    let { responseType: a, onUploadProgress: l, onDownloadProgress: d } = n, c, u, v, g, m;
    function w() {
      g && g(), m && m(), n.cancelToken && n.cancelToken.unsubscribe(c), n.signal && n.signal.removeEventListener("abort", c);
    }
    let b = new XMLHttpRequest();
    b.open(n.method.toUpperCase(), n.url, !0), b.timeout = n.timeout;
    function S() {
      if (!b)
        return;
      const h = K.from(
        "getAllResponseHeaders" in b && b.getAllResponseHeaders()
      ), T = {
        data: !a || a === "text" || a === "json" ? b.responseText : b.response,
        status: b.status,
        statusText: b.statusText,
        headers: h,
        config: t,
        request: b
      };
      zs(function(A) {
        s(A), w();
      }, function(A) {
        i(A), w();
      }, T), b = null;
    }
    "onloadend" in b ? b.onloadend = S : b.onreadystatechange = function() {
      !b || b.readyState !== 4 || b.status === 0 && !(b.responseURL && b.responseURL.indexOf("file:") === 0) || setTimeout(S);
    }, b.onabort = function() {
      b && (i(new $("Request aborted", $.ECONNABORTED, t, b)), b = null);
    }, b.onerror = function() {
      i(new $("Network Error", $.ERR_NETWORK, t, b)), b = null;
    }, b.ontimeout = function() {
      let _ = n.timeout ? "timeout of " + n.timeout + "ms exceeded" : "timeout exceeded";
      const T = n.transitional || Rs;
      n.timeoutErrorMessage && (_ = n.timeoutErrorMessage), i(new $(
        _,
        T.clarifyTimeoutError ? $.ETIMEDOUT : $.ECONNABORTED,
        t,
        b
      )), b = null;
    }, r === void 0 && o.setContentType(null), "setRequestHeader" in b && y.forEach(o.toJSON(), function(_, T) {
      b.setRequestHeader(T, _);
    }), y.isUndefined(n.withCredentials) || (b.withCredentials = !!n.withCredentials), a && a !== "json" && (b.responseType = n.responseType), d && ([v, m] = We(d, !0), b.addEventListener("progress", v)), l && b.upload && ([u, g] = We(l), b.upload.addEventListener("progress", u), b.upload.addEventListener("loadend", g)), (n.cancelToken || n.signal) && (c = (h) => {
      b && (i(!h || h.type ? new be(null, t, b) : h), b.abort(), b = null);
    }, n.cancelToken && n.cancelToken.subscribe(c), n.signal && (n.signal.aborted ? c() : n.signal.addEventListener("abort", c)));
    const f = id(n.url);
    if (f && X.protocols.indexOf(f) === -1) {
      i(new $("Unsupported protocol " + f + ":", $.ERR_BAD_REQUEST, t));
      return;
    }
    b.send(r || null);
  });
}, fd = (t, e) => {
  const { length: s } = t = t ? t.filter(Boolean) : [];
  if (e || s) {
    let i = new AbortController(), n;
    const r = function(d) {
      if (!n) {
        n = !0, a();
        const c = d instanceof Error ? d : this.reason;
        i.abort(c instanceof $ ? c : new be(c instanceof Error ? c.message : c));
      }
    };
    let o = e && setTimeout(() => {
      o = null, r(new $(`timeout ${e} of ms exceeded`, $.ETIMEDOUT));
    }, e);
    const a = () => {
      t && (o && clearTimeout(o), o = null, t.forEach((d) => {
        d.unsubscribe ? d.unsubscribe(r) : d.removeEventListener("abort", r);
      }), t = null);
    };
    t.forEach((d) => d.addEventListener("abort", r));
    const { signal: l } = i;
    return l.unsubscribe = () => y.asap(a), l;
  }
}, pd = function* (t, e) {
  let s = t.byteLength;
  if (s < e) {
    yield t;
    return;
  }
  let i = 0, n;
  for (; i < s; )
    n = i + e, yield t.slice(i, n), i = n;
}, hd = async function* (t, e) {
  for await (const s of md(t))
    yield* pd(s, e);
}, md = async function* (t) {
  if (t[Symbol.asyncIterator]) {
    yield* t;
    return;
  }
  const e = t.getReader();
  try {
    for (; ; ) {
      const { done: s, value: i } = await e.read();
      if (s)
        break;
      yield i;
    }
  } finally {
    await e.cancel();
  }
}, is = (t, e, s, i) => {
  const n = hd(t, e);
  let r = 0, o, a = (l) => {
    o || (o = !0, i && i(l));
  };
  return new ReadableStream({
    async pull(l) {
      try {
        const { done: d, value: c } = await n.next();
        if (d) {
          a(), l.close();
          return;
        }
        let u = c.byteLength;
        if (s) {
          let v = r += u;
          s(v);
        }
        l.enqueue(new Uint8Array(c));
      } catch (d) {
        throw a(d), d;
      }
    },
    cancel(l) {
      return a(l), n.return();
    }
  }, {
    highWaterMark: 2
  });
}, et = typeof fetch == "function" && typeof Request == "function" && typeof Response == "function", Hs = et && typeof ReadableStream == "function", gd = et && (typeof TextEncoder == "function" ? /* @__PURE__ */ ((t) => (e) => t.encode(e))(new TextEncoder()) : async (t) => new Uint8Array(await new Response(t).arrayBuffer())), Vs = (t, ...e) => {
  try {
    return !!t(...e);
  } catch {
    return !1;
  }
}, vd = Hs && Vs(() => {
  let t = !1;
  const e = new Request(X.origin, {
    body: new ReadableStream(),
    method: "POST",
    get duplex() {
      return t = !0, "half";
    }
  }).headers.has("Content-Type");
  return t && !e;
}), ns = 64 * 1024, Tt = Hs && Vs(() => y.isReadableStream(new Response("").body)), Xe = {
  stream: Tt && ((t) => t.body)
};
et && ((t) => {
  ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((e) => {
    !Xe[e] && (Xe[e] = y.isFunction(t[e]) ? (s) => s[e]() : (s, i) => {
      throw new $(`Response type '${e}' is not supported`, $.ERR_NOT_SUPPORT, i);
    });
  });
})(new Response());
const wd = async (t) => {
  if (t == null)
    return 0;
  if (y.isBlob(t))
    return t.size;
  if (y.isSpecCompliantForm(t))
    return (await new Request(X.origin, {
      method: "POST",
      body: t
    }).arrayBuffer()).byteLength;
  if (y.isArrayBufferView(t) || y.isArrayBuffer(t))
    return t.byteLength;
  if (y.isURLSearchParams(t) && (t = t + ""), y.isString(t))
    return (await gd(t)).byteLength;
}, yd = async (t, e) => {
  const s = y.toFiniteNumber(t.getContentLength());
  return s ?? wd(e);
}, bd = et && (async (t) => {
  let {
    url: e,
    method: s,
    data: i,
    signal: n,
    cancelToken: r,
    timeout: o,
    onDownloadProgress: a,
    onUploadProgress: l,
    responseType: d,
    headers: c,
    withCredentials: u = "same-origin",
    fetchOptions: v
  } = Ns(t);
  d = d ? (d + "").toLowerCase() : "text";
  let g = fd([n, r && r.toAbortSignal()], o), m;
  const w = g && g.unsubscribe && (() => {
    g.unsubscribe();
  });
  let b;
  try {
    if (l && vd && s !== "get" && s !== "head" && (b = await yd(c, i)) !== 0) {
      let T = new Request(e, {
        method: "POST",
        body: i,
        duplex: "half"
      }), M;
      if (y.isFormData(i) && (M = T.headers.get("content-type")) && c.setContentType(M), T.body) {
        const [A, L] = es(
          b,
          We(ts(l))
        );
        i = is(T.body, ns, A, L);
      }
    }
    y.isString(u) || (u = u ? "include" : "omit");
    const S = "credentials" in Request.prototype;
    m = new Request(e, {
      ...v,
      signal: g,
      method: s.toUpperCase(),
      headers: c.normalize().toJSON(),
      body: i,
      duplex: "half",
      credentials: S ? u : void 0
    });
    let f = await fetch(m);
    const h = Tt && (d === "stream" || d === "response");
    if (Tt && (a || h && w)) {
      const T = {};
      ["status", "statusText", "headers"].forEach((I) => {
        T[I] = f[I];
      });
      const M = y.toFiniteNumber(f.headers.get("content-length")), [A, L] = a && es(
        M,
        We(ts(a), !0)
      ) || [];
      f = new Response(
        is(f.body, ns, A, () => {
          L && L(), w && w();
        }),
        T
      );
    }
    d = d || "text";
    let _ = await Xe[y.findKey(Xe, d) || "text"](f, t);
    return !h && w && w(), await new Promise((T, M) => {
      zs(T, M, {
        data: _,
        headers: K.from(f.headers),
        status: f.status,
        statusText: f.statusText,
        config: t,
        request: m
      });
    });
  } catch (S) {
    throw w && w(), S && S.name === "TypeError" && /fetch/i.test(S.message) ? Object.assign(
      new $("Network Error", $.ERR_NETWORK, t, m),
      {
        cause: S.cause || S
      }
    ) : $.from(S, S && S.code, t, m);
  }
}), Et = {
  http: Rl,
  xhr: ud,
  fetch: bd
};
y.forEach(Et, (t, e) => {
  if (t) {
    try {
      Object.defineProperty(t, "name", { value: e });
    } catch {
    }
    Object.defineProperty(t, "adapterName", { value: e });
  }
});
const rs = (t) => `- ${t}`, _d = (t) => y.isFunction(t) || t === null || t === !1, Gs = {
  getAdapter: (t) => {
    t = y.isArray(t) ? t : [t];
    const { length: e } = t;
    let s, i;
    const n = {};
    for (let r = 0; r < e; r++) {
      s = t[r];
      let o;
      if (i = s, !_d(s) && (i = Et[(o = String(s)).toLowerCase()], i === void 0))
        throw new $(`Unknown adapter '${o}'`);
      if (i)
        break;
      n[o || "#" + r] = i;
    }
    if (!i) {
      const r = Object.entries(n).map(
        ([a, l]) => `adapter ${a} ` + (l === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let o = e ? r.length > 1 ? `since :
` + r.map(rs).join(`
`) : " " + rs(r[0]) : "as no adapter specified";
      throw new $(
        "There is no suitable adapter to dispatch the request " + o,
        "ERR_NOT_SUPPORT"
      );
    }
    return i;
  },
  adapters: Et
};
function ht(t) {
  if (t.cancelToken && t.cancelToken.throwIfRequested(), t.signal && t.signal.aborted)
    throw new be(null, t);
}
function os(t) {
  return ht(t), t.headers = K.from(t.headers), t.data = pt.call(
    t,
    t.transformRequest
  ), ["post", "put", "patch"].indexOf(t.method) !== -1 && t.headers.setContentType("application/x-www-form-urlencoded", !1), Gs.getAdapter(t.adapter || Pe.adapter)(t).then(function(i) {
    return ht(t), i.data = pt.call(
      t,
      t.transformResponse,
      i
    ), i.headers = K.from(i.headers), i;
  }, function(i) {
    return Bs(i) || (ht(t), i && i.response && (i.response.data = pt.call(
      t,
      t.transformResponse,
      i.response
    ), i.response.headers = K.from(i.response.headers))), Promise.reject(i);
  });
}
const js = "1.7.9", tt = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((t, e) => {
  tt[t] = function(i) {
    return typeof i === t || "a" + (e < 1 ? "n " : " ") + t;
  };
});
const as = {};
tt.transitional = function(e, s, i) {
  function n(r, o) {
    return "[Axios v" + js + "] Transitional option '" + r + "'" + o + (i ? ". " + i : "");
  }
  return (r, o, a) => {
    if (e === !1)
      throw new $(
        n(o, " has been removed" + (s ? " in " + s : "")),
        $.ERR_DEPRECATED
      );
    return s && !as[o] && (as[o] = !0, console.warn(
      n(
        o,
        " has been deprecated since v" + s + " and will be removed in the near future"
      )
    )), e ? e(r, o, a) : !0;
  };
};
tt.spelling = function(e) {
  return (s, i) => (console.warn(`${i} is likely a misspelling of ${e}`), !0);
};
function Sd(t, e, s) {
  if (typeof t != "object")
    throw new $("options must be an object", $.ERR_BAD_OPTION_VALUE);
  const i = Object.keys(t);
  let n = i.length;
  for (; n-- > 0; ) {
    const r = i[n], o = e[r];
    if (o) {
      const a = t[r], l = a === void 0 || o(a, r, t);
      if (l !== !0)
        throw new $("option " + r + " must be " + l, $.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (s !== !0)
      throw new $("Unknown option " + r, $.ERR_BAD_OPTION);
  }
}
const ze = {
  assertOptions: Sd,
  validators: tt
}, ne = ze.validators;
class he {
  constructor(e) {
    this.defaults = e, this.interceptors = {
      request: new Zt(),
      response: new Zt()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(e, s) {
    try {
      return await this._request(e, s);
    } catch (i) {
      if (i instanceof Error) {
        let n = {};
        Error.captureStackTrace ? Error.captureStackTrace(n) : n = new Error();
        const r = n.stack ? n.stack.replace(/^.+\n/, "") : "";
        try {
          i.stack ? r && !String(i.stack).endsWith(r.replace(/^.+\n.+\n/, "")) && (i.stack += `
` + r) : i.stack = r;
        } catch {
        }
      }
      throw i;
    }
  }
  _request(e, s) {
    typeof e == "string" ? (s = s || {}, s.url = e) : s = e || {}, s = me(this.defaults, s);
    const { transitional: i, paramsSerializer: n, headers: r } = s;
    i !== void 0 && ze.assertOptions(i, {
      silentJSONParsing: ne.transitional(ne.boolean),
      forcedJSONParsing: ne.transitional(ne.boolean),
      clarifyTimeoutError: ne.transitional(ne.boolean)
    }, !1), n != null && (y.isFunction(n) ? s.paramsSerializer = {
      serialize: n
    } : ze.assertOptions(n, {
      encode: ne.function,
      serialize: ne.function
    }, !0)), ze.assertOptions(s, {
      baseUrl: ne.spelling("baseURL"),
      withXsrfToken: ne.spelling("withXSRFToken")
    }, !0), s.method = (s.method || this.defaults.method || "get").toLowerCase();
    let o = r && y.merge(
      r.common,
      r[s.method]
    );
    r && y.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (m) => {
        delete r[m];
      }
    ), s.headers = K.concat(o, r);
    const a = [];
    let l = !0;
    this.interceptors.request.forEach(function(w) {
      typeof w.runWhen == "function" && w.runWhen(s) === !1 || (l = l && w.synchronous, a.unshift(w.fulfilled, w.rejected));
    });
    const d = [];
    this.interceptors.response.forEach(function(w) {
      d.push(w.fulfilled, w.rejected);
    });
    let c, u = 0, v;
    if (!l) {
      const m = [os.bind(this), void 0];
      for (m.unshift.apply(m, a), m.push.apply(m, d), v = m.length, c = Promise.resolve(s); u < v; )
        c = c.then(m[u++], m[u++]);
      return c;
    }
    v = a.length;
    let g = s;
    for (u = 0; u < v; ) {
      const m = a[u++], w = a[u++];
      try {
        g = m(g);
      } catch (b) {
        w.call(this, b);
        break;
      }
    }
    try {
      c = os.call(this, g);
    } catch (m) {
      return Promise.reject(m);
    }
    for (u = 0, v = d.length; u < v; )
      c = c.then(d[u++], d[u++]);
    return c;
  }
  getUri(e) {
    e = me(this.defaults, e);
    const s = Ds(e.baseURL, e.url);
    return $s(s, e.params, e.paramsSerializer);
  }
}
y.forEach(["delete", "get", "head", "options"], function(e) {
  he.prototype[e] = function(s, i) {
    return this.request(me(i || {}, {
      method: e,
      url: s,
      data: (i || {}).data
    }));
  };
});
y.forEach(["post", "put", "patch"], function(e) {
  function s(i) {
    return function(r, o, a) {
      return this.request(me(a || {}, {
        method: e,
        headers: i ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: r,
        data: o
      }));
    };
  }
  he.prototype[e] = s(), he.prototype[e + "Form"] = s(!0);
});
class It {
  constructor(e) {
    if (typeof e != "function")
      throw new TypeError("executor must be a function.");
    let s;
    this.promise = new Promise(function(r) {
      s = r;
    });
    const i = this;
    this.promise.then((n) => {
      if (!i._listeners) return;
      let r = i._listeners.length;
      for (; r-- > 0; )
        i._listeners[r](n);
      i._listeners = null;
    }), this.promise.then = (n) => {
      let r;
      const o = new Promise((a) => {
        i.subscribe(a), r = a;
      }).then(n);
      return o.cancel = function() {
        i.unsubscribe(r);
      }, o;
    }, e(function(r, o, a) {
      i.reason || (i.reason = new be(r, o, a), s(i.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(e) {
    if (this.reason) {
      e(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(e) : this._listeners = [e];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(e) {
    if (!this._listeners)
      return;
    const s = this._listeners.indexOf(e);
    s !== -1 && this._listeners.splice(s, 1);
  }
  toAbortSignal() {
    const e = new AbortController(), s = (i) => {
      e.abort(i);
    };
    return this.subscribe(s), e.signal.unsubscribe = () => this.unsubscribe(s), e.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let e;
    return {
      token: new It(function(n) {
        e = n;
      }),
      cancel: e
    };
  }
}
function xd(t) {
  return function(s) {
    return t.apply(null, s);
  };
}
function Td(t) {
  return y.isObject(t) && t.isAxiosError === !0;
}
const Ct = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(Ct).forEach(([t, e]) => {
  Ct[e] = t;
});
function Us(t) {
  const e = new he(t), s = Ss(he.prototype.request, e);
  return y.extend(s, he.prototype, e, { allOwnKeys: !0 }), y.extend(s, e, null, { allOwnKeys: !0 }), s.create = function(n) {
    return Us(me(t, n));
  }, s;
}
const j = Us(Pe);
j.Axios = he;
j.CanceledError = be;
j.CancelToken = It;
j.isCancel = Bs;
j.VERSION = js;
j.toFormData = Qe;
j.AxiosError = $;
j.Cancel = j.CanceledError;
j.all = function(e) {
  return Promise.all(e);
};
j.spread = xd;
j.isAxiosError = Td;
j.mergeConfig = me;
j.AxiosHeaders = K;
j.formToJSON = (t) => Fs(y.isHTMLForm(t) ? new FormData(t) : t);
j.getAdapter = Gs.getAdapter;
j.HttpStatusCode = Ct;
j.default = j;
class Id {
  constructor(e) {
    this._oauthEndpoint = "", this._apiUrl = "", this._authStore = {
      set: (s) => {
        this._authResult = s;
      },
      get: () => this._authResult
    }, this._oauthEndpoint = e.authEndpoint, this._apiUrl = e.apiHost, e.authStore && (console.log("set custom auth store"), this._authStore = e.authStore);
  }
  /**
   * Retrieve stored token
   * Accesses token through provided auth store implementation
   */
  get token() {
    return this._authStore.get()?.access_token ?? "";
  }
  /**
   * Authenticate client and retrieve bearer token
   * Stores token for further requests
   * @returns LosysApiAuthResult
   */
  authenticateAndGetBasicInformation() {
    return new Promise((e, s) => {
      j.post(this._oauthEndpoint, {}, {
        headers: {
          "Content-Type": "application/json"
        }
      }).then((i) => {
        this._authStore.set(i.data), e(i.data);
      }).catch((i) => {
        console.error("Error fetching the token:", i.response ? i.response.data : i.message), s(i);
      });
    });
  }
  /**
   * Request customer project data
   * @param requestData @typeof LosysApiProjectFilter Filter data for the losys endpoint
   * @returns List of projects based on the configured requestData parameter
   */
  getCustomerProjects(e) {
    const s = `${this._apiUrl}/customer/project`, i = new URLSearchParams();
    i.append("limit", e.pageSize.toString()), i.append("start", e.pageIndex.toString()), e.yearFrom && i.append("yearFrom", e.yearFrom.toString()), e.yearTo && i.append("yearTo", e.yearTo.toString());
    const n = ["expand", "cantons", "categoryIds", "companyIds", "groupIds", "languages", "projectIds"];
    for (const o of n) {
      const a = e[o];
      a && a.forEach((l) => {
        i.append(`${o}[]`, l);
      });
    }
    const r = `${s}?${i.toString()}`;
    return new Promise((o, a) => {
      j.get(`${r}`, {
        headers: {
          Authorization: `Bearer ${this.token}`
        }
      }).then((l) => {
        o(l.data);
      }).catch((l) => {
        console.error("Error fetching the data:", l.response ? l.response.data : l.message), a(l);
      });
    });
  }
}
export {
  si as BreadcrumbComponent,
  Cd as FilterComponent,
  $i as HeroComponent,
  Pd as HighlightComponent,
  xr as ImageSliderComponent,
  Id as LosysApiService,
  Dr as QuoteSliderComponent,
  kd as ReactiveAsyncDataSource,
  Ld as ReferenceDetailComponent,
  Pt as TagComponent,
  vs as TeaserCardComponent,
  Md as TeaserListComponent,
  Ad as TeaserSliderComponent,
  oo as TileTeaserComponent,
  Po as WantedPosterComponent,
  Od as createReferenceDetail,
  G as vEtxAppearance
};
